class WebsiteFilesDictionary {
  constructor() {
    // Embedded data from the JSON file
    this.data = [
  {
    "filename": "what_is_a_weather_api.txt",
    "id": "file-JwkPZfuz43DncPFdtJH5nW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/what-is-a-weather-api/",
    "title": "What is a Weather API?"
  },
  {
    "filename": "weather_forecast_widget_implementation_guide.txt",
    "id": "file-H99a3W3fNDhDi79kDJtUCn",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/weather-forecast-widget-implementation-guide/",
    "title": "Weather Forecast Widget Implementation Guide"
  },
  {
    "filename": "weather_api_changelog.txt",
    "id": "file-JQ7LNuVxUusYCgeuBLxi17",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-api-changelog/",
    "title": "Weather API Changelog"
  },
  {
    "filename": "weather_widget_install_guide.txt",
    "id": "file-8FE8PdsTxsLn2ZbzocC8PX",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/weather-widget-install-guide/",
    "title": "Weather Widget Install Guide"
  },
  {
    "filename": "where_can_i_find_historical_cloud_and_visibility_data.txt",
    "id": "file-UqJFsSAh69Lr4ECV6KNWCY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-cloud-and-visibility-data/",
    "title": "Where can I find historical cloud and visibility data?"
  },
  {
    "filename": "what_is_the_difference_between_temperature_heat_index_wind_chill_feels_like_temperature_apparent_temperature_and_realfeel_temperature.txt",
    "id": "file-NhNv8RrWnhrJPoUYmfEoEy",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/what-is-the-difference-between-temperature-heat-index-wind-chill-feels-like-temperature-apparent-temperature-and-realfeel-temperature/",
    "title": "What is the difference between temperature, heat index, wind chill, feels like temperature, apparent temperature and RealFeel Temperature?"
  },
  {
    "filename": "where_can_i_find_historical_rainfall_data.txt",
    "id": "file-N564TUWQvRfeYxPSCNnAvT",
    "source": "https://www.visualcrossing.com/resources/blog/where-can-i-find-historical-rainfall-data/",
    "title": "Where can I find historical rainfall data?"
  },
  {
    "filename": "weather_data_documentation.txt",
    "id": "file-4ffL4G4bgCqtVR6MHZDVk1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-data-documentation/",
    "title": "Weather Data Documentation"
  },
  {
    "filename": "weather_usage_in_home_automation_domotics.txt",
    "id": "file-2MUc4AvBu5fkGg6oU5wmg6",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/weather-usage-in-home-automation-domotics/",
    "title": "Weather usage in home automation / domotics"
  },
  {
    "filename": "weather_api_json_result_structure.txt",
    "id": "file-AgsrGtqAZYqsmSkrSueRaT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-api-json-result-structure/",
    "title": "Weather API JSON result structure"
  },
  {
    "filename": "what_is_the_querycost_parameter.txt",
    "id": "file-NBNn5z5Jr3hioh8Fd2vakn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/what-is-the-querycost-parameter/",
    "title": "What is the queryCost parameter?"
  },
  {
    "filename": "what_is_the_typical_weather_for_universal_studios.txt",
    "id": "file-TuaCF5TpkGhnMjdNqDuJ6g",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-the-typical-weather-for-universal-studios/",
    "title": "What is the Typical Weather for Universal Studios?"
  },
  {
    "filename": "weather_workbook_for_excel.txt",
    "id": "file-YR9xwairhjYnbE5MCKmxDt",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/weather-excel-workbooks/",
    "title": "Weather Workbook for Excel"
  },
  {
    "filename": "what_is_the_difference_between_rain_sleet_snow_and_ice_precipitation_types.txt",
    "id": "file-MrDhQGHmjccsuaRNFy3uQW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-is-the-difference-between-rain-sleet-snow-and-ice-precipitation-types/",
    "title": "What is the difference between rain, sleet, snow and ice precipitation types?"
  },
  {
    "filename": "weather_dependent_industries.txt",
    "id": "file-CRzHEbazK9LnKodXM6aUFC",
    "source": "https://www.visualcrossing.com/resources/blog/weather-dependent-industries/",
    "title": "Weather-Dependent Industries"
  },
  {
    "filename": "what_are_frost_quakes_and_cryoseisms.txt",
    "id": "file-JFawPYUeb7MrJHg3SrmAH2",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-frost-quakes-and-cryoseisms/",
    "title": "What are Frost Quakes and Cryoseisms?"
  },
  {
    "filename": "where_can_you_find_high_quality_historical_weather_data_at_a_low_cost.txt",
    "id": "file-MQvuTkDFEa3uaVwXoV2PQp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-you-find-high-quality-historical-weather-data-at-a-low-cost/",
    "title": "Where can you find high quality Historical Weather Data at a low cost?"
  },
  {
    "filename": "why_do_weather_systems_typically_move_from_west_to_east.txt",
    "id": "file-FajS6bjjspWh44FvT4Jzab",
    "source": "https://www.visualcrossing.com/resources/blog/why-weather-systems-move-from-west-to-east/",
    "title": "Why Do Weather Systems Typically Move from West to East?"
  },
  {
    "filename": "weather_alerts.txt",
    "id": "file-EXRcMJewSxqPV7pmsF8GTv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-alerts/",
    "title": "Weather Alerts"
  },
  {
    "filename": "what_is_kwhth_or_kwhe_and_why_does_the_difference_matter.txt",
    "id": "file-1BaQJcgf3VDhcAWi9A96V2",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-a-kwhth-kwhe-or-kilowatt-hour-thermal/",
    "title": "What Is kWhth or kWhe and Why Does the Difference Matter?"
  },
  {
    "filename": "where_can_i_find_historical_heat_index_and_wind_chill_data.txt",
    "id": "file-8kNPciMay7xfFuLrySMfwp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-heat-index-and-wind-chill-data/",
    "title": "Where can I find historical heat index and wind chill data?"
  },
  {
    "filename": "world_meteorological_day_2025.txt",
    "id": "file-Nnffq6WPKNGVewcRLJWLdB",
    "source": "https://www.visualcrossing.com/resources/blog/world-meteorological-day-celebrating-science-awareness/",
    "title": "World Meteorological Day 2025"
  },
  {
    "filename": "what_forecast_weather_measures_are_available.txt",
    "id": "file-7WU1UKxGG52LPAYdv9yyRc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-forecast-weather-measures-are-available/",
    "title": "What forecast weather measures are available?"
  },
  {
    "filename": "weather_data_sources_and_attribution.txt",
    "id": "file-QdN4XCi6sZL9Rzm2D7ybQn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-data-sources-and-attribution/",
    "title": "Weather data sources and attribution"
  },
  {
    "filename": "what_exactly_is_a_weather_record.txt",
    "id": "file-4EGcPmSMoz4P2jroKTbwZu",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-exactly-is-a-weather-record/",
    "title": "What exactly is a weather record?"
  },
  {
    "filename": "weather_api_documentation_legacy_endpoints.txt",
    "id": "file-SLozYokU6rztQTabqxZG6T",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-api-documentation/",
    "title": "Weather API Documentation (Legacy endpoints)"
  },
  {
    "filename": "where_does_the_weather_get_energy.txt",
    "id": "file-7DwQcRixU4b4PBGX9BHbkd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/where-does-the-weather-get-energy/",
    "title": "Where does the weather get energy?"
  },
  {
    "filename": "weather_data_conditions.txt",
    "id": "file-N8V33Nakzrrnwfnb8GVNsj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-condition-fields/",
    "title": "Weather Data Conditions"
  },
  {
    "filename": "where_can_i_find_historical_precipitation_data.txt",
    "id": "file-Cunq6kKz66LvvSDYBtFSfu",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/where-can-i-find-historical-precipitation-data/",
    "title": "Where can I find historical precipitation data?"
  },
  {
    "filename": "weather_alerts_for_excel.txt",
    "id": "file-97TetrrPM4XLRrZfph1uFw",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/weather-alerts-for-excel/",
    "title": "Weather Alerts for Excel"
  },
  {
    "filename": "what_was_the_weather_on_a_certain_date.txt",
    "id": "file-7VEfSTAsYum6e77Prs5XGn",
    "source": "https://www.visualcrossing.com/resources/blog/what-was-the-weather-on-a-certain-date/",
    "title": "What was the Weather on a Certain Date?"
  },
  {
    "filename": "where_can_i_find_historical_wind_data.txt",
    "id": "file-Tyf8iHdCvFqj5EyjXzrY39",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-wind-data/",
    "title": "Where can I find historical wind data?"
  },
  {
    "filename": "what_historical_weather_measures_are_available.txt",
    "id": "file-Tt91qRcHCfDZkqxdjEKvpF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-historical-weather-measures-are-available/",
    "title": "What historical weather measures are available?"
  },
  {
    "filename": "what_weather_cancels_flights.txt",
    "id": "file-DdufFSgeu8cjNTNNSEG4PJ",
    "source": "https://www.visualcrossing.com/resources/blog/what-weather-cancels-flights/",
    "title": "What Weather Cancels Flights"
  },
  {
    "filename": "weather_data_and_weather_apis_for_nonprofit_organizations.txt",
    "id": "file-AyBYXzcYZFpt4oL3C7F74S",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-data-and-weather-apis-for-nonprofit-organizations/",
    "title": "Weather Data and Weather APIs for Nonprofit Organizations"
  },
  {
    "filename": "what_are_degree_days_038_how_to_use_them.txt",
    "id": "file-Br2Dio4AywgPJoj4Z7CELY",
    "source": "https://www.visualcrossing.com/resources/blog/degree-days/",
    "title": "What Are Degree Days & How to Use Them?"
  },
  {
    "filename": "what_was_the_temperature_on_a_date.txt",
    "id": "file-67DusG2ui2dwZsMEMdbwyc",
    "source": "https://www.visualcrossing.com/resources/blog/what-was-the-temperature-on-a-date/",
    "title": "What was the temperature on a date?"
  },
  {
    "filename": "what_industries_rely_on_visual_crossing_weather_data.txt",
    "id": "file-SfNoHNoDZc8254yQ23W2wB",
    "source": "https://www.visualcrossing.com/resources/blog/what-industries-rely-on-visual-crossing-weather-data/",
    "title": "What industries rely on Visual Crossing Weather data?"
  },
  {
    "filename": "where_can_i_find_historical_temperature_data.txt",
    "id": "file-9dRzwjUeL45MoxYnj598ip",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-temperature-data/",
    "title": "Where can I find historical temperature data?"
  },
  {
    "filename": "what_will_my_weather_data_cost.txt",
    "id": "file-2HnbiiKfimL5DcktbriRLK",
    "source": "https://www.visualcrossing.com/resources/blog/what-will-my-weather-data-cost/",
    "title": "What will my weather data cost?"
  },
  {
    "filename": "weather_unit_conversion_in_microsoft_excel.txt",
    "id": "file-KP2MJeJMFQq5E69tD8kia3",
    "source": "https://www.visualcrossing.com/resources/blog/weather-unit-conversion-in-microsoft-excel/",
    "title": "Weather unit conversion in Microsoft Excel"
  },
  {
    "filename": "what_is_the_cause_of_8220_maximum_concurrent_jobs_has_been_exceeded_8221_http_response_429.txt",
    "id": "file-Bve1APyn8F6d54m3bNUMJD",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/what-is-the-cause-of-maximum-concurrent-jobs-has-been-exceeded-http-response-429/",
    "title": "What is the cause of 'Maximum concurrent jobs has been exceeded', HTTP response 429"
  },
  {
    "filename": "where_can_i_find_historical_humidity_data.txt",
    "id": "file-9CugSJtfPnYeenvq8mb3xH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-humidity-data/",
    "title": "Where can I find historical humidity data?"
  },
  {
    "filename": "weather_data_visualization.txt",
    "id": "file-1WrqraPMmnZk3b1K5cCov9",
    "source": "https://www.visualcrossing.com/resources/blog/weather-data-visualization/",
    "title": "Weather Data Visualization"
  },
  {
    "filename": "weather_workbook_for_excel_8211_customization.txt",
    "id": "file-KjnUDWMQiXZ4ZwgZntLqnY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/weather-workbook-for-excel-customization/",
    "title": "Weather Workbook for Excel - Customization"
  },
  {
    "filename": "replacing_the_openweathermap_api_with_visual_crossing_weather.txt",
    "id": "file-PDrW33Czq189VuEiuxms9R",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-openweathermap-api-with-visual-crossing-weather/",
    "title": "Replacing the OpenWeatherMap API with Visual Crossing Weather"
  },
  {
    "filename": "setting_the_location_source_for_the_visual_crossing_weather_add_in.txt",
    "id": "file-6V7j6zEBjDcZ2Wf9JT8GJa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/setting-the-location-source-for-the-visual-crossing-weather-add-in/",
    "title": "Setting the Location Source for the Visual Crossing Weather Add-in"
  },
  {
    "filename": "the_role_of_ai_tools_in_weather_forecasting.txt",
    "id": "file-AvJzth7DmUKwYGTmdB23T1",
    "source": "https://www.visualcrossing.com/resources/blog/the-role-of-ai-tools-in-weather-forecasting/",
    "title": "The Role of AI Tools in Weather Forecasting"
  },
  {
    "filename": "how_we_process_the_noaa_integrated_surface_database_historical_weather_data.txt",
    "id": "file-9ZWcMLJspW89aNcXAVUgkU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-we-process-integrated-surface-database-historical-weather-data/",
    "title": "How We Process the NOAA Integrated Surface Database Historical Weather Data"
  },
  {
    "filename": "how_to_view_usage_details_of_your_account.txt",
    "id": "file-SZsRbQM9nBtPYeJnrv8BZe",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-view-usage-details-of-your-account/",
    "title": "How to view usage details of your account"
  },
  {
    "filename": "using_the_timeline_weather_api_with_multiple_locations_in_the_same_request.txt",
    "id": "file-9aeaVuEZEViWmLmnAq8mWW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/using-the-timeline-weather-api-with-multiple-locations-in-the-same-request/",
    "title": "Using the Timeline Weather API with multiple locations in the same request"
  },
  {
    "filename": "using_microsoft_excel_to_analyze_gardening_weather_and_climate_8211_part_1.txt",
    "id": "file-Xc9uCGsJZgxGWz9nvGq1bu",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/using-microsoft-excel-to-analyze-gardening-weather-and-climate/",
    "title": "Using Microsoft Excel to Analyze Gardening Weather and Climate - Part 1"
  },
  {
    "filename": "visual_crossing_weather_data_availability_guide.txt",
    "id": "file-LvrfZREXViaqPjeRxbjNii",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/visual-crossing-weather-data-availability-guide/",
    "title": "Visual Crossing Weather Data Availability Guide"
  },
  {
    "filename": "tutorial_how_to_build_a_weather_dataset_for_download_bulk_import_or_scheduling.txt",
    "id": "file-Ueb3WRxMnZioZuMnV6U3cL",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-build-a-weather-dataset-for-download-bulk-import-or-scheduling/",
    "title": "Tutorial:  How to Build a Weather Dataset for Download, Bulk Import or Scheduling"
  },
  {
    "filename": "using_microsoft_excel_to_analyze_gardening_weather_8211_part_3_growing_degree_days.txt",
    "id": "file-65Pw3bmf5jP6CtAT7nqQ3q",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/using-microsoft-excel-to-analyze-gardening-weather-part-3-growing-degree-days/",
    "title": "Using Microsoft Excel to Analyze Gardening Weather - Part 3, Growing Degree Days"
  },
  {
    "filename": "using_the_time_period_parameter_to_specify_dynamic_dates_for_weather_api_requests.txt",
    "id": "file-UaemfM9zwxFwJx16HLvXc7",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/using-the-time-period-parameter-to-specify-dynamic-dates-for-weather-api-requests/",
    "title": "Using the time period parameter to specify dynamic dates for Weather API requests"
  },
  {
    "filename": "how_to_use_the_microsoft_excel_webservice_function_to_retrieve_weather_data.txt",
    "id": "file-QNe6DX7ne6qXo1P1acmSC1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-use-the-microsoft-excel-webservice-function-to-retrieve-weather-data/",
    "title": "How to use the Microsoft Excel WEBSERVICE function to retrieve weather data"
  },
  {
    "filename": "how_to_use_historical_weather_data_to_forecast_the_weather_for_any_day_of_the_year.txt",
    "id": "file-98yjwmGuYkCJ7qUNeNkxdn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-use-historical-weather-data-to-forecast-the-weather-for-any-day-of-the-year/",
    "title": "How to use historical weather data to forecast the weather for any day of the year."
  },
  {
    "filename": "replacing_the_google_weather_api.txt",
    "id": "file-2mYGG6ELBaefiW9vTXFsye",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-google-weather-api/",
    "title": "Replacing the Google Weather API"
  },
  {
    "filename": "stored_dataset_api_documentation.txt",
    "id": "file-LjoMzaRVLoAPidfMzQmt1t",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/stored-dataset-api-documentation/",
    "title": "Stored Dataset API Documentation"
  },
  {
    "filename": "precipitation_coverage_is_the_most_important_weather_metric_you_don_8217_t_know.txt",
    "id": "file-GuS7QK4bGbBappJqdCUmkh",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-precipitation-coverage/",
    "title": "Precipitation coverage is the most important weather metric you don't know"
  },
  {
    "filename": "how_to_use_the_timeline_weather_api_to_retrieve_historical_weather_data_and_weather_forecast_data_in_java.txt",
    "id": "file-M6EkUDhJsY8ghmewE5ub2J",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-timeline-weather-api-to-retrieve-historical-weather-data-and-weather-forecast-data-in-java/",
    "title": "How to use the Timeline Weather API to retrieve historical weather data and weather forecast data in Java"
  },
  {
    "filename": "modifying_the_weather_station_search_parameters.txt",
    "id": "file-4EV2ksdbLMTUP4bNMQzdt3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/modifying-the-weather-station-search-parameters/",
    "title": "Modifying the weather station search parameters"
  },
  {
    "filename": "how_we_built_the_winter_energy_calculator.txt",
    "id": "file-S2c6bpSxv2Ja8pvzAWFhEg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-we-built-the-winter-energy-calculator/",
    "title": "How We Built the Winter Energy Calculator"
  },
  {
    "filename": "replacing_the_yahoo_weather_api.txt",
    "id": "file-GPDpisXBKCoRvJVMYDNd7E",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-yahoo-weather-api/",
    "title": "Replacing the Yahoo Weather API"
  },
  {
    "filename": "using_remote_data_sources_in_the_weather_api.txt",
    "id": "file-XBdAvAMHBJpJ7mEJNdKRQn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/using-remote-data-sources-in-the-weather-api/",
    "title": "Using remote data sources in the Weather API"
  },
  {
    "filename": "multi_site_forecast_workbook_for_excel.txt",
    "id": "file-EVN6HoTsEbWqFZuDCk3m6c",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/multi-site-weather-forecast-excel-workbook/",
    "title": "Multi-site Forecast Workbook for Excel"
  },
  {
    "filename": "understanding_and_optimizing_the_visual_crossing_weather_pay_as_you_go_plan.txt",
    "id": "file-9rSiSZeb3XJfnL2CguZ5Kb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/understanding-and-optimizing-the-visual-crossing-weather-pay-as-you-go-plan/",
    "title": "Understanding and optimizing the Visual Crossing Weather Pay-as-you-go plan"
  },
  {
    "filename": "i_think_that_i_8217_m_seeing_bad_weather_data_what_should_i_do.txt",
    "id": "file-VZPNbxp3JRgiho6WT5EHvp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/i-think-that-im-seeing-bad-weather-data-what-should-i-do/",
    "title": "I think that I'm seeing bad weather data.  What should I do?"
  },
  {
    "filename": "visual_crossing_weather_extensions.txt",
    "id": "file-QQNnBT1wE1eSAPpcH4J2h3",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/visual-crossing-weather-extensions/",
    "title": "Visual Crossing Weather Extensions"
  },
  {
    "filename": "tutorial_how_to_load_weather_data_into_microsoft_excel_using_a_web_query_url.txt",
    "id": "file-KRBBsS7XrFq6WgfCF9KE8c",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-into-microsoft-excel-using-a-web-query-data-connection/",
    "title": "Tutorial: How to Load Weather Data into Microsoft Excel using a Web Query URL"
  },
  {
    "filename": "understanding_the_8220_fair_use_8221_system_in_visual_crossing_weather.txt",
    "id": "file-SFX8aLRcyxm32fPaxum6QA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/understanding-the-fair-use-system-in-visual-crossing-weather/",
    "title": "Understanding the 'fair use' system in Visual Crossing Weather"
  },
  {
    "filename": "visual_crossing_weather_packaged_options.txt",
    "id": "file-9AThu88YAXSaXbzxCWWEXT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/visual-crossing-weather-packaged-options/",
    "title": "Visual Crossing Weather Packaged Options"
  },
  {
    "filename": "timeline_weather_api.txt",
    "id": "file-JYppTPQL8KacuTJs9KhKaY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/timeline-weather-api/",
    "title": "Timeline Weather API"
  },
  {
    "filename": "requesting_sub_hourly_data_in_the_timeline_weather_api.txt",
    "id": "file-HBUiMnRihUPukwkM6N4wz4",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/sub-hourly-data-in-the-timeline-weather-api/",
    "title": "Requesting sub-hourly data in the Timeline Weather API"
  },
  {
    "filename": "how_to_use_the_visual_crossing_weather_microsoft_excel_add_in.txt",
    "id": "file-7ekZ4g8jotdDboo8ascFiZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-use-the-visual-crossing-weather-microsoft-excel-add-in/",
    "title": "How to use the Visual Crossing Weather Microsoft Excel Add-in"
  },
  {
    "filename": "parameter_based_web_queries_in_excel.txt",
    "id": "file-ChPHcq2bciFu9JKyes5MkM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/parameter-based-web-queries-in-excel/",
    "title": "Parameter Based, Web Queries in Excel"
  },
  {
    "filename": "http_error_codes.txt",
    "id": "file-8mDiVhdu1CvHMAkAWQTvih",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/http-error-codes/",
    "title": "HTTP Error Codes"
  },
  {
    "filename": "importing_data_from_a_json_weather_api_into_microsoft_excel_using_power_query.txt",
    "id": "file-9DqiFotYNMGBQGro2KSkGN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/importing-data-from-a-json-weather-api-into-microsoft-excel-using-power-query/",
    "title": "Importing data from a JSON Weather API  into Microsoft Excel using Power Query"
  },
  {
    "filename": "weather_alerts.txt",
    "id": "file-4n1nQoTd3SoVa9HWP3d9aV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-alerts/",
    "title": "Weather Alerts"
  },
  {
    "filename": "requesting_sub_hourly_weather_data_using_the_weather_api.txt",
    "id": "file-GRGJi7p79F1xKGkgFpM1g3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/requesting-sub-hourly-weather-data-using-the-weather-api/",
    "title": "Requesting sub-hourly weather data using the Weather API"
  },
  {
    "filename": "unit_groups_and_measurement_units.txt",
    "id": "file-NgSuJhK7dn7VNbQLpfgHV9",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/unit-groups-and-measurement-units/",
    "title": "Unit groups and measurement units"
  },
  {
    "filename": "how_your_data_is_used_within_visual_crossing.txt",
    "id": "file-SaQhoo8NkauSBCXy5mqEwc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-your-data-is-used-within-visual-crossing/",
    "title": "How your data is used within Visual Crossing"
  },
  {
    "filename": "introduction_to_weather_statistics_and_analysis.txt",
    "id": "file-47Lt4zJSK4GuoNM4kfX5Jf",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/introduction-to-weather-statistics-and-analysis/",
    "title": "Introduction to Weather Statistics and Analysis"
  },
  {
    "filename": "in_what_environments_can_i_run_weather_api_queries.txt",
    "id": "file-A9PPQkwhzyKRSC4znwp3ft",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/in-what-environments-can-i-run-weather-api-queries/",
    "title": "In what environments can I run weather API queries?"
  },
  {
    "filename": "how_to_use_java_to_load_weather_forecast_data.txt",
    "id": "file-XZMpjQdYzXv9aVuv68rd8b",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-fetch-weather-forecast-data-from-a-restful-web-service-in-java/",
    "title": "How to use Java to load weather forecast data"
  },
  {
    "filename": "invoice_and_billing_questions.txt",
    "id": "file-FGcAmg1id8YZNDLYWKCvcH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/invoice-and-billing-questions/",
    "title": "Invoice and billing questions"
  },
  {
    "filename": "how_to_use_the_calendar_control_in_the_visual_crossing_weather_data_web_query_gui.txt",
    "id": "file-HcMpVcCo2yCV6xjJmNYETB",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/how-to-use-the-calendar-control-in-the-visual-crossing-weather-data-web-query-gui/",
    "title": "How to use the calendar control in the Visual Crossing Weather Data Web Query GUI"
  },
  {
    "filename": "how_to_use_python_and_pandas_to_join_historical_weather_data_to_road_accident_data.txt",
    "id": "file-1EseDvj7PEfBDKsmpmHyee",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-python-and-pandas-to-join-historical-weather-data-to-road-accident-data/",
    "title": "How to use Python and Pandas to join historical weather data to road accident data"
  },
  {
    "filename": "how_to_make_a_wordpress_plugin_that_uses_shortcodes_to_show_the_weather_forecast.txt",
    "id": "file-1makgZfaZ9tVcKK6caN26c",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-make-a-wordpress-plugin-that-uses-shortcodes-to-show-the-weather-forecast/",
    "title": "How to make a WordPress plugin that uses shortcodes to show the weather forecast"
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_oracle_analytics_desktop.txt",
    "id": "file-BjRN4K5X9DJqtDss52p4SS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-oracle-analytics-desktop/",
    "title": "How to load weather forecast data into Oracle Analytics Desktop"
  },
  {
    "filename": "how_to_load_weather_data_into_apache_openoffice_calc.txt",
    "id": "file-DRVWPSe8oQyHGwJzgpBJTJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-load-weather-data-into-apache-openoffice-calc/",
    "title": "How to load Weather Data into Apache OpenOffice Calc"
  },
  {
    "filename": "how_to_load_weather_data_in_javascript_using_fetch_api_jquery_d3_or_node_js.txt",
    "id": "file-KTLuHs5Uj6fFzgSJrcA8yN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-javascript/",
    "title": "How to load weather data in JavaScript using Fetch API, jQuery, d3 or node.js"
  },
  {
    "filename": "how_to_query_weather_forecasts_from_the_past_8211_historical_forecasts.txt",
    "id": "file-7NYo3i2brgsMa4DXQnhdBT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-query-weather-forecasts-from-the-past-historical-forecasts/",
    "title": "How to query weather forecasts from the past - Historical Forecasts"
  },
  {
    "filename": "how_to_show_weather_data_in_an_outlook_add_in.txt",
    "id": "file-HdVSzM3kDh7gYPvrwubNy6",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-show-weather-data-in-an-outlook-add-in/",
    "title": "How to show weather data in an Outlook add-in"
  },
  {
    "filename": "how_to_manage_visual_crossing_weather_data_subscriptions.txt",
    "id": "file-3888zwwQCdFnaBXkB7Fnop",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-manage-visual-crossing-weather-data-subscriptions/",
    "title": "How to manage Visual Crossing Weather Data Subscriptions"
  },
  {
    "filename": "how_to_use_curl_to_fetch_bulk_weather_data.txt",
    "id": "file-TrFUwCBgqGq1mJjnRjocFV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-curl-to-fetch-bulk-weather-data/",
    "title": "How to use cURL to fetch bulk weather data"
  },
  {
    "filename": "how_to_load_weather_data_using_google_s_go_language.txt",
    "id": "file-JxsPwkSP8bi1B5xZbHDkzC",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-googles-go-language/",
    "title": "How to load weather data using Google\u2019s Go language"
  },
  {
    "filename": "how_to_replace_the_dark_sky_api_using_the_visual_crossing_weather_api.txt",
    "id": "file-Ne4E33ut6YBV1rhN26dp5H",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-replace-the-dark-sky-api-using-the-visual-crossing-timeline-weather-api/",
    "title": "How to replace the Dark Sky API using the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_tibco_spotfire_via_odata_request.txt",
    "id": "file-VAHwBKGzgYMAcd9PM2k4Sr",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-tibco-spotfire-via-odata-request/",
    "title": "How to load weather forecast data into TIBCO Spotfire via ODATA request"
  },
  {
    "filename": "how_to_load_weather_data_into_google_sheets_using_json.txt",
    "id": "file-FpvojsTm8j5iYhXKaPmueE",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-load-weather-data-into-google-sheets-using-json/",
    "title": "How To Load Weather Data into Google Sheets using JSON"
  },
  {
    "filename": "how_to_load_weather_data_using_lisp.txt",
    "id": "file-2SJCqUjAtB6ChTw9REbUBX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-lisp/",
    "title": "How to load weather data using LISP"
  },
  {
    "filename": "how_to_use_cors_with_a_restful_weather_api.txt",
    "id": "file-HvaGi2bSMMchFsDNijcCSf",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-use-cors-with-a-restful-weather-api/",
    "title": "How to use CORS with a RESTful Weather API"
  },
  {
    "filename": "how_to_load_weather_data_in_php.txt",
    "id": "file-TtmxwP2n6Pn9v9sb1jYpJ7",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-php/",
    "title": "How to load weather data in PHP"
  },
  {
    "filename": "how_to_obtain_solar_radiation_data.txt",
    "id": "file-CwjtaAnRWKXYwDGScovp3H",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-obtain-solar-radiation-data/",
    "title": "How to obtain solar radiation data?"
  },
  {
    "filename": "how_to_use_curl_to_download_weather_data.txt",
    "id": "file-BZpb5ASYn1nP5TauXn1FoS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-curl-to-download-weather-data/",
    "title": "How to use cURL to download weather data"
  },
  {
    "filename": "how_to_manage_your_personal_account_information.txt",
    "id": "file-24b9fctxVkHfMyXQWX8Jf4",
    "source": "https://www.visualcrossing.com/resources/documentation/how-to-manage-your-personal-account-information/",
    "title": "How to manage your personal account information"
  },
  {
    "filename": "how_to_replace_the_weather_underground_api.txt",
    "id": "file-Stov3i9sNwu1WCVFa1qTee",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-weather-underground-api/",
    "title": "How to Replace the Weather Underground API?"
  },
  {
    "filename": "how_to_load_weather_data_into_a_juypter_notebook.txt",
    "id": "file-SqcAq7n5jLF8AKSSDLDNQ9",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-into-a-juypter-notebook/",
    "title": "How to load weather data into a Juypter Notebook"
  },
  {
    "filename": "how_to_look_up_weather_by_address.txt",
    "id": "file-11BBkvyMfqqMyczPKNe6DC",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-look-up-weather-by-address/",
    "title": "How to look up weather by address"
  },
  {
    "filename": "how_to_retrieve_the_visual_crossing_api_query_string_when_using_the_web_query_builder_interface.txt",
    "id": "file-BgjzoEhEu7QypxpoQwLJwt",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-retrieve-the-visual-crossing-api-query-string-when-using-the-web-query-builder-interface/",
    "title": "How to retrieve the Visual Crossing API Query String when using the Web Query Builder interface"
  },
  {
    "filename": "how_to_sign_up_for_a_weather_data_038_weather_api_account.txt",
    "id": "file-S2FwjBRfk7A7JUH7rP1tSM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-sign-up-for-a-weather-data-weather-api-account/",
    "title": "How to sign up for a Weather Data & Weather API Account"
  },
  {
    "filename": "how_to_load_weather_data_into_sas_visual_analytics_or_sas_visual_statistics.txt",
    "id": "file-FYjv8iJAVtfxnPoPMHoPDq",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-data-into-sas-viya/",
    "title": "How to load weather data into SAS Visual Analytics or SAS Visual Statistics."
  },
  {
    "filename": "how_to_load_weather_data_in_matlab.txt",
    "id": "file-Sz1ef3innb4qWU3fqfmMkB",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-matlab/",
    "title": "How to load weather data in MATLAB"
  },
  {
    "filename": "how_to_load_weather_data_using_python.txt",
    "id": "file-6nHuF2sxY63NjiezNVE6Rt",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-load-historical-weather-data-using-python-without-scraping/",
    "title": "How to Load Weather Data Using Python?"
  },
  {
    "filename": "how_to_submit_weather_api_asynchronously.txt",
    "id": "file-JET2jVB6tcKEk48gz5y477",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-submit-weather-api-asynchronously/",
    "title": "How to submit weather API asynchronously"
  },
  {
    "filename": "how_to_look_up_weather_by_latitude_and_longitude.txt",
    "id": "file-REfAjn6WYqTFPX51sm2CdN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-look-up-weather-by-latitude-and-longitude/",
    "title": "How to look up weather by latitude and longitude"
  },
  {
    "filename": "how_to_load_weather_data_into_information_builders_ibi_webfocus_using_the_rest_api.txt",
    "id": "file-SzRhcMyjuBXm5DzftiqV8L",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-data-into-information-builders-ibi-webfocus-using-the-rest-api/",
    "title": "How to load weather data into Information Builders ibi WebFOCUS using the REST API"
  },
  {
    "filename": "how_to_schedule_weather_data_queries.txt",
    "id": "file-45pSsU1rLkvhMVYytMPpyo",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-schedule-weather-data-queries/",
    "title": "How to schedule weather data queries"
  },
  {
    "filename": "how_to_load_weather_forecast_data_as_a_microsoft_excel_xlsx_file.txt",
    "id": "file-SHUjurhKqnDhccxDCTWkpM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-as-a-microsoft-excel-xlsx-file/",
    "title": "How to load weather forecast data as a Microsoft Excel XLSX file"
  },
  {
    "filename": "how_to_retrieve_hail_tornado_wind_damage_and_earthquake_events_in_the_weather_api.txt",
    "id": "file-9a4ArFNHtAauMS6ieVae1c",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-retrieve-hail-tornado-wind-damage-and-earthquakes-events-in-the-weather-api/",
    "title": "How to retrieve hail, tornado, wind damage and earthquake events in the weather API"
  },
  {
    "filename": "how_to_load_weather_data_using_vb_net.txt",
    "id": "file-EGSyiTgZUkDWaQ84ycYsmX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-vb-net/",
    "title": "How to load weather data using VB.net"
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_qlik_sense.txt",
    "id": "file-NXVvcWuXfmxmQe9pt2Ecnd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-qlik-sense/",
    "title": "How to load weather forecast data into Qlik Sense?"
  },
  {
    "filename": "how_to_load_weather_data_in_swift.txt",
    "id": "file-K1JVRTRLDHVpK24tt2XhL1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-swift/",
    "title": "How to load weather data in Swift"
  },
  {
    "filename": "how_to_look_up_the_current_weather_conditions_in_the_weather_api.txt",
    "id": "file-MYe4DKTgDmeTBr7mkuxat6",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-look-up-the-current-weather-conditions-in-the-weather-api/",
    "title": "How to look up the current weather conditions in the Weather API"
  },
  {
    "filename": "how_to_load_weather_data_in_ruby.txt",
    "id": "file-DkXUBuE7U45JnSiqD1PagH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-ruby/",
    "title": "How to load weather data in Ruby"
  },
  {
    "filename": "how_to_automatically_refresh_weather_data_in_microsoft_excel.txt",
    "id": "file-SCkkypyU4jPhocFoYz4eaV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-automatically-refresh-weather-data-in-microsoft-excel/",
    "title": "How to automatically refresh Weather Data in Microsoft Excel"
  },
  {
    "filename": "how_to_load_weather_data_in_c.txt",
    "id": "file-XLo1j1HPmkLGc9qgxV2KE8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-c-sharp/",
    "title": "How to load weather data in C#"
  },
  {
    "filename": "how_historical_weather_data_is_updated.txt",
    "id": "file-DCPBB4NeZb5jLj4zVhQbHH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-is-updated/",
    "title": "How historical weather data is updated"
  },
  {
    "filename": "how_to_build_a_great_weather_dashboard.txt",
    "id": "file-KS6ehduj8KvcaJK6v9Hp7Z",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-build-a-great-weather-dashboard/",
    "title": "How to build a great Weather Dashboard"
  },
  {
    "filename": "how_to_download_weather_data_for_multiple_locations.txt",
    "id": "file-DE2Dbyfw4SyuqUXpJytTSq",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-weather-data-for-multiple-locations/",
    "title": "How to download weather data for multiple locations"
  },
  {
    "filename": "how_to_import_weather_data_into_microsoft_sql_server.txt",
    "id": "file-9T4QH8isJwaBFhxZnz2v7Q",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-import-weather-data-into-microsoft-sql-server/",
    "title": "How to import weather data into Microsoft SQL Server"
  },
  {
    "filename": "how_to_load_visual_crossing_weather_data_into_alibaba_cloud_dataworks.txt",
    "id": "file-U63kDYvz6WFtKPbEqUMheK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-visual-crossing-weather-data-into-alibaba-cloud-dataworks/",
    "title": "How to load Visual Crossing weather data into Alibaba Cloud DataWorks"
  },
  {
    "filename": "how_to_find_the_typical_weather_conditions_in_a_certain_area.txt",
    "id": "file-7qzUXahyFa5W77cV9TtAfT",
    "source": "https://www.visualcrossing.com/resources/blog/what-are-the-typical-weather-conditions-in-a-certain-area/",
    "title": "How to Find the Typical Weather Conditions in a Certain Area?"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_oracle_analytics_desktop.txt",
    "id": "file-4r3pfzPK8vRyevV7UBdnLM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-oracle-analytics-desktop/",
    "title": "How to load historical weather data into Oracle Analytics  Desktop?"
  },
  {
    "filename": "how_to_include_weather_radar_data_in_weather_datasets.txt",
    "id": "file-HLU4QBeDNupmjKEjHwL3TT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-include-weather-radar-data-in-weather-datasets/",
    "title": "How to Include Weather Radar Data in Weather Datasets"
  },
  {
    "filename": "how_to_find_weather_data_using_nlp_natural_language_processing.txt",
    "id": "file-VXm6wML8dNCm4sHujBBNCQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-weather-data-using-nlp/",
    "title": "How to find weather data using NLP (Natural Language Processing)"
  },
  {
    "filename": "how_to_include_sunrise_sunset_moon_phase_moonrise_and_moonset_data_into_your_api_requests.txt",
    "id": "file-NrU5CjJm3q78oBYeXXWBu8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-include-sunrise-sunset-and-moon-phase-data-into-your-api-requests/",
    "title": "How to include sunrise, sunset, moon phase, moonrise and moonset data into your API requests"
  },
  {
    "filename": "how_to_handle_daylight_savings_in_the_visual_crossing_weather_api.txt",
    "id": "file-Mry6cgzkgyH1DqjEvtXbmn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-handle-daylight-savings-in-the-visual-crossing-weather-api/",
    "title": "How to Handle Daylight Savings in the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_build_an_artificially_intelligent_chatbot_using_the_microsoft_bot_framework_and_the_visual_crossing_weather_api.txt",
    "id": "file-99Yza4ERCzdKNoHf9yEPDW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-build-an-artificially-intelligent-chatbot-using-the-microsoft-bot-framework-and-the-visual-crossing-weather-api/",
    "title": "How to Build an Artificially Intelligent Chatbot using the Microsoft Bot Framework and the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_find_and_manage_your_visual_crossing_weather_api_key.txt",
    "id": "file-FJaqJXo5EJa85GvpAFNFpU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-change-your-visual-crossing-weather-api-key/",
    "title": "How to Find and Manage Your Visual Crossing Weather API Key"
  },
  {
    "filename": "how_to_download_weather_forecast_data_as_a_microsoft_excel_workbook.txt",
    "id": "file-HA8bmu6dncLFr47wh1UwWs",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-download-weather-forecast-data-as-a-microsoft-excel-workbook/",
    "title": "How to download weather forecast data as a Microsoft Excel Workbook"
  },
  {
    "filename": "how_to_find_and_use_sub_hourly_historical_weather_data.txt",
    "id": "file-1bdLMBw8JXmW9F3xqfskzq",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-and-use-sub-hourly-historical-weather-data/",
    "title": "How to find and use sub-hourly historical weather data"
  },
  {
    "filename": "how_to_integrate_weather_data_for_postal_codes_in_the_business_cloud_of_domo.txt",
    "id": "file-TZFm1b5oKHPkLMAdaetpFo",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-integrate-weather-data-for-postal-codes-in-the-business-cloud-of-domo/",
    "title": "How to integrate weather data for postal codes in The Business Cloud of DOMO."
  },
  {
    "filename": "how_to_find_accurate_snow_weather_data.txt",
    "id": "file-927UMsc1pLdirRoeNNBBbe",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-accurate-snow-weather-data/",
    "title": "How to find accurate snow weather data"
  },
  {
    "filename": "how_to_add_free_weather_information_to_your_kanban_board_in_leankit_planview.txt",
    "id": "file-3h5vi8RVPoNG3dq3U1TCUs",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-your-kanban-board-in-leankit-planview/",
    "title": "How to add free weather information to your Kanban board in  LeanKit planview."
  },
  {
    "filename": "how_to_find_a_weather_api_for_your_hackathon.txt",
    "id": "file-MqQNks2iWL6Rfqa8uDP7Wa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-a-weather-api-for-your-hackathon/",
    "title": "How to find a Weather API for your hackathon"
  },
  {
    "filename": "how_to_add_weather_data_to_a_node_js_app_using_a_weather_api_and_javascript.txt",
    "id": "file-QHhBii1fLcJwq79SVPpuAa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-add-weather-data-to-a-node-js-app-using-a-weather-api-and-javascript/",
    "title": "How to add weather data to a Node.js app using a Weather API and JavaScript"
  },
  {
    "filename": "how_to_cancel_visual_crossing_weather_data_subscriptions.txt",
    "id": "file-QW76s3SSEd93ZyrqGoQKLx",
    "source": "https://www.visualcrossing.com/resources/documentation/how-to-cancel-visual-crossing-weather-data-subscriptions/",
    "title": "How to cancel Visual Crossing Weather Data Subscriptions"
  },
  {
    "filename": "how_to_find_weather_data_for_your_next_data_science_project.txt",
    "id": "file-YMTB3LwLLSFaYdwggthvP6",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-weather-data-for-data-science/",
    "title": "How to Find Weather Data for your Next Data Science Project"
  },
  {
    "filename": "how_to_create_annual_or_monthly_climate_summaries_and_normals_for_a_location.txt",
    "id": "file-V7fQvXTpad6TYbTPpmqAW3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-create-annual-or-monthly-climate-summaries-and-normals-for-a-location/",
    "title": "How to create annual or monthly climate summaries and normals for a location"
  },
  {
    "filename": "how_to_add_weather_data_to_sas_visual_data_mining_038_machine_learning.txt",
    "id": "file-Rqw3gjUsUnj2V2CmivMyTF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-sas-visual-data-mining-machine-learning/",
    "title": "How to add Weather Data to SAS Visual Data Mining & Machine Learning"
  },
  {
    "filename": "how_to_i_properly_cite_or_attribute_the_weather_data_in_my_project_to_visual_crossing_weather.txt",
    "id": "file-THXHysbmHzkguMzSC7LEuy",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-i-properly-cite-or-attribute-the-weather-data-in-my-project-to-visual-crossing-weather/",
    "title": "How to I properly cite or attribute the weather data in my project to Visual Crossing Weather?"
  },
  {
    "filename": "how_to_download_the_weather_forecast_for_all_us_zip_codes.txt",
    "id": "file-Y9eSSt1K4dzKc1m1irLzeM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-the-weather-forecast-for-all-us-zip-codes/",
    "title": "How to download the weather forecast for all US ZIP Codes"
  },
  {
    "filename": "how_to_find_historical_weather_for_maritime_sea_and_ocean_locations.txt",
    "id": "file-7iHfZTmjSDJWacyybZQdCg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-historical-weather-for-maritime-sea-and-ocean-locations/",
    "title": "How to find historical weather for maritime, sea and ocean locations"
  },
  {
    "filename": "how_to_import_weather_forecast_data_and_historical_weather_data_into_a_mysql_database.txt",
    "id": "file-LdttKvAYKxRn1sveTXePRZ",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-import-weather-data-into-mysql/",
    "title": "How to Import Weather Forecast Data and Historical Weather Data into a MySQL Database"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_any_database.txt",
    "id": "file-AH2JC8qfg9HVKUcXcz9mEA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-any-database/",
    "title": "How to load historical weather data into any database"
  },
  {
    "filename": "how_to_add_weather_data_to_your_microstrategy_project.txt",
    "id": "file-VBxp5uoBCpLScP4BLrgqw9",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-your-microstrategy-project/",
    "title": "How to add Weather Data to your MicroStrategy project"
  },
  {
    "filename": "how_to_add_weather_forecast_data_into_microsoft_planner.txt",
    "id": "file-1ftcNqpV3DBHQbXQdde1bh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-forecast-data-into-microsoft-planner/",
    "title": "How to add weather forecast data into Microsoft Planner"
  },
  {
    "filename": "how_does_weather_affect_agriculture.txt",
    "id": "file-NsAN4tk7UdwEEi9GxuWsof",
    "source": "https://www.visualcrossing.com/resources/blog/how-does-weather-affect-agriculture/",
    "title": "How Does Weather Affect Agriculture"
  },
  {
    "filename": "how_to_add_weather_data_to_google_sheets_using_a_dynamic_weather_query.txt",
    "id": "file-EkoEpD86F4t7acRBaG2g67",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-add-weather-data-to-google-sheets-using-a-dynamic-weather-query/",
    "title": "How to add Weather Data to Google Sheets using a Dynamic Weather Query"
  },
  {
    "filename": "how_has_technology_changed_weather_forecasting_for_meteorologists.txt",
    "id": "file-4488wmU8CiR7heTnjnB4wD",
    "source": "https://www.visualcrossing.com/resources/blog/how-has-technology-changed-weather-forecasting-for-meteorologists/",
    "title": "How Has Technology Changed Weather Forecasting for Meteorologists?"
  },
  {
    "filename": "how_to_build_a_weather_app.txt",
    "id": "file-2118Fer5bV9iKmyT2dhCxc",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-building-a-weather-app/",
    "title": "How to Build a Weather App?"
  },
  {
    "filename": "how_to_create_a_raspberry_pi_frost_alert_using_a_weather_api.txt",
    "id": "file-P8xogkB4WsWySDqzPWKs2p",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-a-raspberry-pi-frost-alert-using-a-weather-api/",
    "title": "How to create a Raspberry PI frost alert using a weather api"
  },
  {
    "filename": "how_to_create_a_weather_chatbot_step_by_step_guide.txt",
    "id": "file-QHrszzCJF18nWki7iLAoyQ",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-create-a-weather-chatbot-step-by-step-guide/",
    "title": "How to Create a Weather Chatbot | Step-by-Step Guide"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_tibco_spotfire_via_odata_request.txt",
    "id": "file-MR5X1BjaKTKRfH5CAQwaYJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-tibco-spotfire-via-odata-request/",
    "title": "How to add historical weather data to TIBCO Spotfire  via ODATA request"
  },
  {
    "filename": "how_historical_weather_data_records_are_created_from_local_weather_station_observations.txt",
    "id": "file-YSZMzQd8eVHuR2TDDCkmgC",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-records-are-created-from-local-weather-station-observations/",
    "title": "How Historical Weather Data Records are Created from Local Weather Station Observations"
  },
  {
    "filename": "how_to_create_or_modify_language_files.txt",
    "id": "file-VsPvM4esRWsZwekwRTGZSK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-or-modify-language-files/",
    "title": "How to create or modify language files"
  },
  {
    "filename": "how_to_debug_problems_when_running_weather_api_queries_in_code.txt",
    "id": "file-Fpd9ACwQE9z5AbuoKPivuV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-debug-problems-when-running-weather-api-queries-in-code/",
    "title": "How to debug problems when running weather API queries in code"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_qlik_sense.txt",
    "id": "file-FA65PrxoJTPtGdgoivGYM8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-qlik-sense/",
    "title": "How to add historical weather data to Qlik Sense"
  },
  {
    "filename": "how_to_add_free_weather_information_to_an_evernote_notebook.txt",
    "id": "file-Abu85h2jvqNjBPxu4RdTp1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-an-evernote-notebook/",
    "title": "How to add free weather information to an Evernote notebook"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_google_sheets.txt",
    "id": "file-Q8TYuiSGM4Uy8Gzi2oNYX1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-google-sheets/",
    "title": "How can I load weather forecast data into Google Sheets?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_using_google_apps_script.txt",
    "id": "file-JAz6FkfBXpT74kgiEdCs71",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-can-i-load-historical-weather-data-using-google-apps-script/",
    "title": "How can I load historical weather data using Google Apps Script?"
  },
  {
    "filename": "how_do_we_create_our_weather_forecast.txt",
    "id": "file-4KMqjXWZyGmFFdbd8h8N3w",
    "source": "https://www.visualcrossing.com/resources/documentation/how-do-we-create-our-weather-forecast/",
    "title": "How do we create our weather forecast?"
  },
  {
    "filename": "how_do_i_retrieve_weather_data_using_an_odata_request.txt",
    "id": "file-C1GKqjWKGvKuoQUxcnHPHF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-retrieve-weather-data-using-an-odata-request/",
    "title": "How do I retrieve weather data using an ODATA request?"
  },
  {
    "filename": "how_do_i_load_weather_history_data_into_a_pivot_table.txt",
    "id": "file-R7fUSLsYF4nVe6t6zJy7oT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-do-i-load-weather-history-data-into-a-pivot-table/",
    "title": "How do I load Weather History data into a Pivot Table?"
  },
  {
    "filename": "how_do_i_find_the_best_long_range_weather_forecast.txt",
    "id": "file-V5WxfFGKT6N89RFnryvQj9",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-find-the-best-long-range-weather-forecast/",
    "title": "How do I find the best long range Weather Forecast?"
  },
  {
    "filename": "how_does_the_wind_blow.txt",
    "id": "file-EZLJd6jBKurhEoyPDiWFht",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/how-does-the-wind-blow/",
    "title": "How does the wind blow?"
  },
  {
    "filename": "how_do_i_get_free_weather_api_access.txt",
    "id": "file-L4NLPcXqJKEoE4wNbgNMuy",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-get-free-weather-api-access/",
    "title": "How do I get free weather API access?"
  },
  {
    "filename": "how_do_i_run_a_weather_api_query_using_http_post.txt",
    "id": "file-M7zE9KBPLCnqwaaiH2qNwK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-run-a-weather-api-query-using-http-post/",
    "title": "How do I run a weather API query using HTTP POST?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_tableau_desktop.txt",
    "id": "file-H42Ck266GdN1i3zsypDgkg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-tableau-desktop/",
    "title": "How Can I Load Historical Weather Data into Tableau Desktop?"
  },
  {
    "filename": "how_do_i_add_the_weather_forecast_to_my_web_page.txt",
    "id": "file-EijGRxZ62Q9BZEBuzvbieq",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-add-weather-forecast-to-my-webpage/",
    "title": "How do I add the weather forecast to my web page?"
  },
  {
    "filename": "how_cold_did_it_get_in_texas.txt",
    "id": "file-7UKbMqEh6SVVTWpuXGesa7",
    "source": "https://www.visualcrossing.com/resources/blog/how-cold-did-it-get-in-texas/",
    "title": "How cold did it get in Texas?"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_powerpoint.txt",
    "id": "file-3FmuMyXjZcEGCZPAtC7Sub",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-powerpoint/",
    "title": "How do I add weather data into Microsoft PowerPoint?"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_word.txt",
    "id": "file-QQEjMxT9jS2vb6QLnBV3ap",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-word/",
    "title": "How do I add weather data into Microsoft Word?"
  },
  {
    "filename": "how_do_i_get_started_with_the_weather_api.txt",
    "id": "file-NGdn3VodsajUGixqjsxEGf",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-get-started-with-the-weather-api/",
    "title": "How do I get started with the Weather API?"
  },
  {
    "filename": "how_can_i_replace_the_dark_sky_api.txt",
    "id": "file-Ao5QtVHz1AELWq5h9CLVSm",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-replace-the-darksky-api/",
    "title": "How can I replace the Dark Sky API?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_google_sheets.txt",
    "id": "file-MwR2EQurm2B5oE291mavEV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-google-sheets/",
    "title": "How can I load historical weather data into Google Sheets?"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_microsoft_power_bi.txt",
    "id": "file-H7Bcv3DqA6paxqk4y2AeSc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-microsoft-power-bi/",
    "title": "How can I load weather forecast data into Microsoft Power BI?"
  },
  {
    "filename": "how_do_i_create_daily_statistics_for_historical_weather_summaries_and_climate_reports.txt",
    "id": "file-RUCWcD8yxmD4CrWxzdhhjF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-create-daily-statistics-for-historical-weather-summaries-and-climate-reports/",
    "title": "How do I create daily statistics for historical weather summaries and climate reports?"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_tableau_desktop.txt",
    "id": "file-VfgfenNGiEjtCi4M4AJnMb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-do-i-load-weather-forecast-data-into-tableau-desktop/",
    "title": "How Can I Load Weather Forecast Data into Tableau Desktop?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_microsoft_power_bi.txt",
    "id": "file-6v8t3nEkrgQNSTqnETW3Lz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-microsoft-power-bi/",
    "title": "How can I load historical weather data into Microsoft Power BI?"
  },
  {
    "filename": "how_do_i_find_my_nearest_weather_station.txt",
    "id": "file-K5R2BuFDqTDWVT4vzMptMH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-my-nearest-weather-station/",
    "title": "How do I find my nearest weather station?"
  },
  {
    "filename": "how_can_i_use_the_visual_crossing_weather_date_chooser_to_jump_to_historical_weather_for_any_time.txt",
    "id": "file-YZUQpRsq416pL2PrGw1Z79",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-use-the-visual-crossing-weather-date-chooser-to-jump-to-historical-weather-for-any-time/",
    "title": "How can I use the Visual Crossing Weather date chooser to jump to historical weather for any time?"
  },
  {
    "filename": "how_do_i_find_old_weather_data.txt",
    "id": "file-KESr6a9v1TwG1s4SAN4umn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-old-weather-data/",
    "title": "How do I find old weather data?"
  },
  {
    "filename": "certificate_error_running_weather_api_requests.txt",
    "id": "file-SUdzyAKBrsAtu3ab1MdZ3s",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/certificate-error-running-weather-api-requests/",
    "title": "Certificate error running Weather API requests"
  },
  {
    "filename": "how_can_i_download_weather_history_data_as_a_csv_file.txt",
    "id": "file-UcsnieUHkQRzRbGXv7kj2z",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-history-data-as-a-csv-file/",
    "title": "How can I download weather history data as a CSV file?"
  },
  {
    "filename": "how_can_i_find_historical_weather_data_for_analysis_in_r.txt",
    "id": "file-58c5wc9PYNRdyT1SYXawSu",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-historical-weather-data-for-analysis-in-r/",
    "title": "How can I find historical weather data for analysis in R?"
  },
  {
    "filename": "energy_sources_affected_by_the_weather.txt",
    "id": "file-TJMsL4bVzVcgiFZTyhZqJi",
    "source": "https://www.visualcrossing.com/resources/blog/energy-sources-affected-by-the-weather/",
    "title": "Energy Sources Affected by the Weather"
  },
  {
    "filename": "frequently_asked_questions_faq_for_visual_crossing_weather_data.txt",
    "id": "file-6vEnn9e1chCEyX29Sywp5s",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/frequently-asked-questions-faq-for-visual-crossing-weather-data/",
    "title": "Frequently Asked Questions (FAQ) for Visual Crossing Weather Data"
  },
  {
    "filename": "how_can_i_download_weather_forecast_data_as_a_csv_file.txt",
    "id": "file-BnpXe2tUXEZfqpHXDP2DxL",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-forecast-data-as-a-csv-file/",
    "title": "How can I download weather forecast data as a CSV file?"
  },
  {
    "filename": "date_and_times_in_the_weather_api.txt",
    "id": "file-VduaTTuZ9cAAfRM2sAiVwU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/date-and-times-in-the-weather-api/",
    "title": "Date and Times in the Weather API"
  },
  {
    "filename": "getting_started_with_logistics_and_delivery_weather.txt",
    "id": "file-4234NcZzC2kNhfqwcchv9V",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-shipment-weather/",
    "title": "Getting Started With Logistics and Delivery Weather"
  },
  {
    "filename": "bulk_weather_forecast_data_retrieval_for_multiple_locations.txt",
    "id": "file-6V3nooSncGFSAPXottEkeA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-forecast-data-retrieval-for-multiple-locations/",
    "title": "Bulk weather forecast data retrieval for multiple locations"
  },
  {
    "filename": "degree_day_calculator_for_microsoft_excel.txt",
    "id": "file-MzDxK8aJ1vQMm9XdgoY93d",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/degree-day-calculator/",
    "title": "Degree Day Calculator for Microsoft Excel"
  },
  {
    "filename": "how_can_i_get_bulk_weather_data.txt",
    "id": "file-UL53eXn4RcgJPw8Gfys8Jy",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-get-bulk-weather-data/",
    "title": "How can I get bulk weather data?"
  },
  {
    "filename": "does_weather_affect_hunting.txt",
    "id": "file-6uLB9iJ7pmBCQMX3233Q6h",
    "source": "https://www.visualcrossing.com/resources/blog/does-weather-affect-hunting/",
    "title": "Does Weather Affect Hunting?"
  },
  {
    "filename": "finding_historical_weather_data_for_remote_locations.txt",
    "id": "file-9DwSrXFBTJXcs2EP8ASqQt",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/finding-historical-weather-data-for-remote-locations/",
    "title": "Finding historical weather data for remote locations"
  },
  {
    "filename": "construction_management_using_weather_workbook.txt",
    "id": "file-XVZ7EKLNJGQ5ceAAkuayCo",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/construction-weather-management-workbook/",
    "title": "Construction Management using Weather Workbook"
  },
  {
    "filename": "energy_elements_in_the_timeline_weather_api.txt",
    "id": "file-J4vTvyuN67V5UkQvXC9xop",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/energy-elements-in-the-timeline-weather-api/",
    "title": "Energy elements in the Timeline Weather API"
  },
  {
    "filename": "how_can_i_find_past_weather_information_for_my_insurance_claim.txt",
    "id": "file-4u2n9qcnaDBnSmQkpotrpb",
    "source": "https://www.visualcrossing.com/resources/blog/how-can-i-find-past-weather-information-for-my-insurance-claim/",
    "title": "How can I find past weather information for my insurance claim?"
  },
  {
    "filename": "get_free_weather_data_with_our_weather_data_ambassadors_program.txt",
    "id": "file-9oVbSQiR5GcThe1M2oJq5X",
    "source": "https://www.visualcrossing.com/resources/news/free-weather-data-ambassadors-program/",
    "title": "Get Free Weather Data with our Weather Data Ambassadors Program"
  },
  {
    "filename": "helping_us_help_you_8211_how_to_submit_an_actionable_technical_support_case.txt",
    "id": "file-FHs8Pqsq8g4ZohiQLPb371",
    "source": "https://www.visualcrossing.com/resources/documentation/helping-us-help-you-how-to-submit-an-actionable-technical-support-case/",
    "title": "Helping us help you - How to submit an actionable technical support case"
  },
  {
    "filename": "did_it_rain_on_a_date.txt",
    "id": "file-VnK4MAELpfwaDt2Ln4o7yy",
    "source": "https://www.visualcrossing.com/resources/blog/did-it-rain-on-a-date/",
    "title": "Did it rain on a date?"
  },
  {
    "filename": "how_can_i_find_weather_forecast_data_for_analysis_in_r.txt",
    "id": "file-4zgD88w2yR39kiLfLHF9uz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-weather-forecast-data-for-analysis-in-r/",
    "title": "How can I find weather forecast data for analysis in R?"
  },
  {
    "filename": "how_can_i_find_the_average_temperature.txt",
    "id": "file-X5ya5SpkKbhWNbU3o9msYn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-can-i-find-the-average-temperature/",
    "title": "How can I find the Average Temperature?"
  },
  {
    "filename": "help_i_can_8217_t_log_in_to_visual_crossing_weather.txt",
    "id": "file-BcWgmdy3LmaQVMq5YrQaux",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/help-i-cant-log-in-to-visual-crossing-weather/",
    "title": "Help!  I can't log in to Visual Crossing Weather!"
  },
  {
    "filename": "free_weather_tools_and_dashboards.txt",
    "id": "file-S3TPHXJsmpmRBC1avYyqKz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/free-weather-tools-and-dashboards/",
    "title": "Free Weather Tools and Dashboards"
  },
  {
    "filename": "getting_started_with_weather_data_services.txt",
    "id": "file-QEFbedPppHdeJ9SFFLD9X2",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-weather-data-services/",
    "title": "Getting Started With Weather Data Services"
  },
  {
    "filename": "defining_the_icon_set_parameter_in_the_weather_api.txt",
    "id": "file-VyHwGZaGqcQ81i3RzHgPmj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/defining-icon-set-in-the-weather-api/",
    "title": "Defining the icon set parameter in the Weather API"
  },
  {
    "filename": "celebrate_national_weatherperson_s_day_on_february_5th.txt",
    "id": "file-CZconqiGrfsU7QW4nhQWNR",
    "source": "https://www.visualcrossing.com/resources/blog/celebrate-national-weatherpersons-day-on-february-5th/",
    "title": "Celebrate National Weatherperson\u2019s Day on February 5th"
  },
  {
    "filename": "how_are_weather_metrics_calculated_over_various_time_periods_in_different_weather_queries.txt",
    "id": "file-LnDbNDEMhT1vaoRo6xxaW8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-are-weather-metrics-calculated-over-various-time-periods-in-different-weather-queries/",
    "title": "How are weather metrics calculated over various time periods in different weather queries?"
  },
  {
    "filename": "bulk_weather_data_in_visual_crossing.txt",
    "id": "file-8BwqSAfDjeegXbh56y1Ned",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/bulk-weather-data-in-visual-crossing/",
    "title": "Bulk Weather Data in Visual Crossing"
  },
  {
    "filename": "comparing_the_visual_crossing_pricing_options_to_dark_sky.txt",
    "id": "file-EWzxWCPQGDxjC3h3Detjt5",
    "source": "https://www.visualcrossing.com/resources/documentation/comparing-the-visual-crossing-pricing-options-to-dark-sky/",
    "title": "Comparing the Visual Crossing Pricing Options to Dark Sky"
  },
  {
    "filename": "degree_days_weather_api.txt",
    "id": "file-1UEptK8rkgaiAoNpYvgFFn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/degree-day-weather-api/",
    "title": "Degree Days Weather API"
  },
  {
    "filename": "calculating_chill_hours_for_fruit_plants_and_trees.txt",
    "id": "file-6RfyKQJCSHVZj7N8NvjJzw",
    "source": "https://www.visualcrossing.com/resources/blog/calculating-chill-hours-for-fruit-plants-and-trees/",
    "title": "Calculating Chill Hours for Fruit Plants and Trees"
  },
  {
    "filename": "beaufort_vs_saffir_simpson_wind_scales.txt",
    "id": "file-HZsQxmNhxNsWfj14vic8GQ",
    "source": "https://www.visualcrossing.com/resources/blog/beaufort-and-saffir-simpson-hurricane-wind-scale-a-quick-glance/",
    "title": "Beaufort vs. Saffir-Simpson Wind Scales"
  },
  {
    "filename": "anchorage_november_snowfall_record_broken_2023_update.txt",
    "id": "file-9VnK8uXknALn79DExrCWrZ",
    "source": "https://www.visualcrossing.com/resources/blog/alaska-anchorage-breaks-the-november-snow-record-and-major-lake-effect-snow-update/",
    "title": "Anchorage November Snowfall Record Broken: 2023 Update"
  },
  {
    "filename": "best_practices_for_segmenting_your_weather_queries.txt",
    "id": "file-WW7WHJ3Cs9ed6xNK3zZBob",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/best-practices-for-segmenting-your-weather-queries/",
    "title": "Best practices for segmenting your weather queries"
  },
  {
    "filename": "building_and_running_your_first_weather_api_query.txt",
    "id": "file-W9nusMAkEGqtaWwoBR6Sbn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/building-and-running-your-first-weather-api-query/",
    "title": "Building and Running your first weather API query"
  },
  {
    "filename": "announcing_our_free_weather_api_plan.txt",
    "id": "file-4psKbxza6Hi7vcgWFeZ8DD",
    "source": "https://www.visualcrossing.com/resources/news/announcing-our-free-weather-api-plan/",
    "title": "Announcing our free Weather API Plan"
  },
  {
    "filename": "automate_recent_weather_history_data_retrieval_using_microsoft_power_query.txt",
    "id": "file-FKK98oVzQx3N23WwaXLFGK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/automate-recent-weather-history-data-retrieval-using-microsoft-power-query/",
    "title": "Automate recent weather history data retrieval using Microsoft Power Query"
  },
  {
    "filename": "add_location_and_date_time_filters_to_odata_weather_data_requests.txt",
    "id": "file-MEXfsyTRRyXCC9osLM2Dkc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/add-location-and-date-time-filters-to-odata-weather-data-requests/",
    "title": "Add location and date time filters to ODATA weather data requests"
  },
  {
    "filename": "adding_and_removing_elements_from_your_weather_query.txt",
    "id": "file-13tZahKm5oEP18pmcH9Ck5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/adding-and-removing-elements-from-your-weather-query/",
    "title": "Adding and Removing Elements from your Weather Query"
  },
  {
    "filename": "announcing_expanded_historical_weather_data.txt",
    "id": "file-3oCyrbE7qxLbHKt3MwVtbp",
    "source": "https://www.visualcrossing.com/resources/news/announcing-expanded-historical-weather-data/",
    "title": "Announcing Expanded Historical Weather Data"
  },
  {
    "filename": "agriculture_elements_in_the_timeline_weather_api.txt",
    "id": "file-XktQbSjatGr3e81aQzhqbh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/agriculture-elements-in-the-timeline-weather-api/",
    "title": "Agriculture elements in the Timeline Weather API"
  },
  {
    "filename": "bulk_weather_alerts_api.txt",
    "id": "file-DrjYRsMCv6uUWBvu6BNjR6",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-alerts-api/",
    "title": "Bulk Weather Alerts API"
  },
  {
    "filename": "academic_student_and_research_discounts_for_weather_data.txt",
    "id": "file-NyhM2br3cAX2Yr98sv74Dh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/academic-student-and-research-discounts-for-weather-data/",
    "title": "Academic, student and research discounts for weather data"
  },
  {
    "filename": "available_data_for_visual_crossing_weather_8211_updated_december_2020.txt",
    "id": "file-R2Dr6gsrNRGYEEYrK2mAH5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/available-data-for-visual-crossing-weather-updated-january-2020/",
    "title": "Available Data for Visual Crossing Weather - Updated December 2020"
  },
  {
    "filename": "atmospheric_rivers_bomb_cyclones_and_other_weird_weather_terms_explained.txt",
    "id": "file-QYTNkDH6cN6mgWiTmTbR9k",
    "source": "https://www.visualcrossing.com/resources/blog/atmospheric-rivers-bomb-cyclones-and-other-weird-weather-words-explained/",
    "title": "Atmospheric Rivers, Bomb Cyclones and Other Weird Weather Terms, Explained"
  },
  {
    "filename": "air_quality_elements_in_the_weather_api.txt",
    "id": "file-46jqRh9N7mnJotoZXVDb9u",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/air-quality-elements-in-the-weather-api/",
    "title": "Air Quality Elements in the Weather API"
  },
  {
    "filename": "8220_north_and_west_of_i_95_8221_8211_why_does_snow_in_the_eastern_us_always_seem_fall_to_the_west_of_i_95.txt",
    "id": "file-7utas1FZvRTrAYBFyM9KQH",
    "source": "https://www.visualcrossing.com/resources/blog/why-does-snow-in-the-eastern-us-always-seem-fall-to-the-west-of-i-95/",
    "title": "'North and West of I-95' - why does snow in the Eastern US always seem fall to the West of I-95?"
  },
  {
    "filename": "a_guide_to_weather_triggered_advertising.txt",
    "id": "file-EohtCMC131Zq8Djvri4q36",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-weather-triggered-advertising/",
    "title": "A Guide to Weather-Triggered Advertising"
  },
  {
    "filename": "how_to_create_a_weather_chatbot_step_by_step_guide.txt",
    "id": "file-8NjwrGrfZ51iPybBqRuq9y",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-create-a-weather-chatbot-step-by-step-guide/",
    "title": "How to Create a Weather Chatbot | Step-by-Step Guide"
  },
  {
    "filename": "how_to_find_and_use_sub_hourly_historical_weather_data.txt",
    "id": "file-CHhEEKKEin2JU2cSALUp6j",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-and-use-sub-hourly-historical-weather-data/",
    "title": "How to find and use sub-hourly historical weather data"
  },
  {
    "filename": "how_to_handle_daylight_savings_in_the_visual_crossing_weather_api.txt",
    "id": "file-VwizHkkUAmfNGrXEam93YM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-handle-daylight-savings-in-the-visual-crossing-weather-api/",
    "title": "How to Handle Daylight Savings in the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_find_accurate_snow_weather_data.txt",
    "id": "file-FfcXz5pSR1F96CvMZzFSfA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-accurate-snow-weather-data/",
    "title": "How to find accurate snow weather data"
  },
  {
    "filename": "how_to_find_the_typical_weather_conditions_in_a_certain_area.txt",
    "id": "file-Va67SMrBUjimEayj3TKArG",
    "source": "https://www.visualcrossing.com/resources/blog/what-are-the-typical-weather-conditions-in-a-certain-area/",
    "title": "How to Find the Typical Weather Conditions in a Certain Area?"
  },
  {
    "filename": "how_to_find_historical_weather_for_maritime_sea_and_ocean_locations.txt",
    "id": "file-YbaK4DzKbb44gQgvBoYGGW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-historical-weather-for-maritime-sea-and-ocean-locations/",
    "title": "How to find historical weather for maritime, sea and ocean locations"
  },
  {
    "filename": "how_to_find_weather_data_using_nlp_natural_language_processing.txt",
    "id": "file-Kxb2McCcPH7mi6ehSKTw4p",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-weather-data-using-nlp/",
    "title": "How to find weather data using NLP (Natural Language Processing)"
  },
  {
    "filename": "how_to_i_properly_cite_or_attribute_the_weather_data_in_my_project_to_visual_crossing_weather.txt",
    "id": "file-Qy18mdwbTxAhVrNN7NdGA2",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-i-properly-cite-or-attribute-the-weather-data-in-my-project-to-visual-crossing-weather/",
    "title": "How to I properly cite or attribute the weather data in my project to Visual Crossing Weather?"
  },
  {
    "filename": "how_to_download_weather_forecast_data_as_a_microsoft_excel_workbook.txt",
    "id": "file-NSsHkQHuSdCaBnKmA9csGX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-download-weather-forecast-data-as-a-microsoft-excel-workbook/",
    "title": "How to download weather forecast data as a Microsoft Excel Workbook"
  },
  {
    "filename": "how_to_download_weather_data_for_multiple_locations.txt",
    "id": "file-5fmbMVdy6vW1L86MaJp27C",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-weather-data-for-multiple-locations/",
    "title": "How to download weather data for multiple locations"
  },
  {
    "filename": "how_to_find_and_manage_your_visual_crossing_weather_api_key.txt",
    "id": "file-22nvuHZXccZY4qUNnZ5958",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-change-your-visual-crossing-weather-api-key/",
    "title": "How to Find and Manage Your Visual Crossing Weather API Key"
  },
  {
    "filename": "how_to_add_weather_data_to_your_microstrategy_project.txt",
    "id": "file-LrjGBvqPJQxe8ptZoqYHb3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-your-microstrategy-project/",
    "title": "How to add Weather Data to your MicroStrategy project"
  },
  {
    "filename": "how_to_find_weather_data_for_your_next_data_science_project.txt",
    "id": "file-T1tA6vt8KfsaPzDKQX1WhJ",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-weather-data-for-data-science/",
    "title": "How to Find Weather Data for your Next Data Science Project"
  },
  {
    "filename": "how_to_download_the_weather_forecast_for_all_us_zip_codes.txt",
    "id": "file-5DFir9tQRAkxGfYFh6vqLp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-the-weather-forecast-for-all-us-zip-codes/",
    "title": "How to download the weather forecast for all US ZIP Codes"
  },
  {
    "filename": "how_to_add_free_weather_information_to_your_kanban_board_in_leankit_planview.txt",
    "id": "file-U5PFgoXbWn9cgou1RRc1XR",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-your-kanban-board-in-leankit-planview/",
    "title": "How to add free weather information to your Kanban board in  LeanKit planview."
  },
  {
    "filename": "how_to_cancel_visual_crossing_weather_data_subscriptions.txt",
    "id": "file-EVCwoHFzFi9MvsAq7QNz9v",
    "source": "https://www.visualcrossing.com/resources/documentation/how-to-cancel-visual-crossing-weather-data-subscriptions/",
    "title": "How to cancel Visual Crossing Weather Data Subscriptions"
  },
  {
    "filename": "how_to_find_a_weather_api_for_your_hackathon.txt",
    "id": "file-UHcTgGXjeXn1CsnneuSDuv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-a-weather-api-for-your-hackathon/",
    "title": "How to find a Weather API for your hackathon"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_tibco_spotfire_via_odata_request.txt",
    "id": "file-2nvLbV9auQ8x5buzMam4wj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-tibco-spotfire-via-odata-request/",
    "title": "How to add historical weather data to TIBCO Spotfire  via ODATA request"
  },
  {
    "filename": "how_to_add_weather_data_to_google_sheets_using_a_dynamic_weather_query.txt",
    "id": "file-B6PzjaxWQoKo2jPAJ26gRJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-add-weather-data-to-google-sheets-using-a-dynamic-weather-query/",
    "title": "How to add Weather Data to Google Sheets using a Dynamic Weather Query"
  },
  {
    "filename": "how_to_create_annual_or_monthly_climate_summaries_and_normals_for_a_location.txt",
    "id": "file-DquM4GZse8qcDbvkEJ3bHX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-create-annual-or-monthly-climate-summaries-and-normals-for-a-location/",
    "title": "How to create annual or monthly climate summaries and normals for a location"
  },
  {
    "filename": "how_to_add_weather_forecast_data_into_microsoft_planner.txt",
    "id": "file-HKCUkwkqbvoQPejnVtgYKU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-forecast-data-into-microsoft-planner/",
    "title": "How to add weather forecast data into Microsoft Planner"
  },
  {
    "filename": "how_to_add_weather_data_to_sas_visual_data_mining_038_machine_learning.txt",
    "id": "file-TKc9iHqQjSaZdf8UyxzmHp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-sas-visual-data-mining-machine-learning/",
    "title": "How to add Weather Data to SAS Visual Data Mining & Machine Learning"
  },
  {
    "filename": "announcing_our_free_weather_api_plan.txt",
    "id": "file-1GNQ8Crnb1tt7pAYNydB3s",
    "source": "https://www.visualcrossing.com/resources/news/announcing-our-free-weather-api-plan/",
    "title": "Announcing our free Weather API Plan"
  },
  {
    "filename": "how_to_add_weather_data_to_a_node_js_app_using_a_weather_api_and_javascript.txt",
    "id": "file-S7kPn5NJbWQSmeDFqcftNX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-add-weather-data-to-a-node-js-app-using-a-weather-api-and-javascript/",
    "title": "How to add weather data to a Node.js app using a Weather API and JavaScript"
  },
  {
    "filename": "how_to_build_an_artificially_intelligent_chatbot_using_the_microsoft_bot_framework_and_the_visual_crossing_weather_api.txt",
    "id": "file-G45P2BZQPALoxMozN2koJU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-build-an-artificially-intelligent-chatbot-using-the-microsoft-bot-framework-and-the-visual-crossing-weather-api/",
    "title": "How to Build an Artificially Intelligent Chatbot using the Microsoft Bot Framework and the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_debug_problems_when_running_weather_api_queries_in_code.txt",
    "id": "file-CyvRL4fLAPFZAC6vdKctvQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-debug-problems-when-running-weather-api-queries-in-code/",
    "title": "How to debug problems when running weather API queries in code"
  },
  {
    "filename": "how_to_create_a_raspberry_pi_frost_alert_using_a_weather_api.txt",
    "id": "file-1vWvriMPcS5EoRxREt7Vax",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-a-raspberry-pi-frost-alert-using-a-weather-api/",
    "title": "How to create a Raspberry PI frost alert using a weather api"
  },
  {
    "filename": "how_do_i_get_started_with_the_weather_api.txt",
    "id": "file-QDZgy6H6KXvTzhWE7ovcRR",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-get-started-with-the-weather-api/",
    "title": "How do I get started with the Weather API?"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_microsoft_power_bi.txt",
    "id": "file-M62Fw65gCRxW3MvSVmfduY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-microsoft-power-bi/",
    "title": "How can I load weather forecast data into Microsoft Power BI?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_using_google_apps_script.txt",
    "id": "file-XWQEUMffQQy5ARsZeJ8Wkm",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-can-i-load-historical-weather-data-using-google-apps-script/",
    "title": "How can I load historical weather data using Google Apps Script?"
  },
  {
    "filename": "how_to_build_a_weather_app.txt",
    "id": "file-4cNTSJMbz8NERXHyodag1F",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-building-a-weather-app/",
    "title": "How to Build a Weather App?"
  },
  {
    "filename": "how_do_i_retrieve_weather_data_using_an_odata_request.txt",
    "id": "file-KSrdLZWqqa7fozxv3bpTkJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-retrieve-weather-data-using-an-odata-request/",
    "title": "How do I retrieve weather data using an ODATA request?"
  },
  {
    "filename": "how_can_i_replace_the_dark_sky_api.txt",
    "id": "file-56tFLgTexYATaGwS45wS6z",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-replace-the-darksky-api/",
    "title": "How can I replace the Dark Sky API?"
  },
  {
    "filename": "how_historical_weather_data_is_updated.txt",
    "id": "file-CZmPK4drwPBvX1Ew3sqX4o",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-is-updated/",
    "title": "How historical weather data is updated"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_tableau_desktop.txt",
    "id": "file-W4tqjBXxTkmJwYQkrfc4Dp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-do-i-load-weather-forecast-data-into-tableau-desktop/",
    "title": "How Can I Load Weather Forecast Data into Tableau Desktop?"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_word.txt",
    "id": "file-EtsvBrVvm3hsmEd7AJr4iz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-word/",
    "title": "How do I add weather data into Microsoft Word?"
  },
  {
    "filename": "how_to_build_a_great_weather_dashboard.txt",
    "id": "file-Jwg22ZQR57a88JxdLeHH93",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-build-a-great-weather-dashboard/",
    "title": "How to build a great Weather Dashboard"
  },
  {
    "filename": "how_to_create_or_modify_language_files.txt",
    "id": "file-VFXSLdzmyj8emJs59r7Nib",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-or-modify-language-files/",
    "title": "How to create or modify language files"
  },
  {
    "filename": "how_can_i_get_bulk_weather_data.txt",
    "id": "file-Vawi62EPjjcqhqykq61tJm",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-get-bulk-weather-data/",
    "title": "How can I get bulk weather data?"
  },
  {
    "filename": "how_do_we_create_our_weather_forecast.txt",
    "id": "file-88JGoypcEkx3H4y6bTEMSY",
    "source": "https://www.visualcrossing.com/resources/documentation/how-do-we-create-our-weather-forecast/",
    "title": "How do we create our weather forecast?"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_qlik_sense.txt",
    "id": "file-9FZJPEqx2HRtvpEDqXA6Bm",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-qlik-sense/",
    "title": "How to add historical weather data to Qlik Sense"
  },
  {
    "filename": "how_do_i_run_a_weather_api_query_using_http_post.txt",
    "id": "file-3xK3EwqkY4rXU1pMJ93XoP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-run-a-weather-api-query-using-http-post/",
    "title": "How do I run a weather API query using HTTP POST?"
  },
  {
    "filename": "certificate_error_running_weather_api_requests.txt",
    "id": "file-FbWmALdBFtqHWQMSYTb8KY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/certificate-error-running-weather-api-requests/",
    "title": "Certificate error running Weather API requests"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_google_sheets.txt",
    "id": "file-V7wHj3eQFa99kogG8tQoTo",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-google-sheets/",
    "title": "How can I load weather forecast data into Google Sheets?"
  },
  {
    "filename": "8220_north_and_west_of_i_95_8221_8211_why_does_snow_in_the_eastern_us_always_seem_fall_to_the_west_of_i_95.txt",
    "id": "file-4faQ4P94fujLbc3fjpfRaf",
    "source": "https://www.visualcrossing.com/resources/blog/why-does-snow-in-the-eastern-us-always-seem-fall-to-the-west-of-i-95/",
    "title": "'North and West of I-95' - why does snow in the Eastern US always seem fall to the West of I-95?"
  },
  {
    "filename": "how_can_i_use_the_visual_crossing_weather_date_chooser_to_jump_to_historical_weather_for_any_time.txt",
    "id": "file-89Mk78pNrTPJ2RKPXJPAkn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-use-the-visual-crossing-weather-date-chooser-to-jump-to-historical-weather-for-any-time/",
    "title": "How can I use the Visual Crossing Weather date chooser to jump to historical weather for any time?"
  },
  {
    "filename": "how_to_add_free_weather_information_to_an_evernote_notebook.txt",
    "id": "file-AcCbJtVGmwhkxjRNiMZ5sv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-an-evernote-notebook/",
    "title": "How to add free weather information to an Evernote notebook"
  },
  {
    "filename": "how_to_automatically_refresh_weather_data_in_microsoft_excel.txt",
    "id": "file-N8nPH4s7hLH1RmbWEgtuaW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-automatically-refresh-weather-data-in-microsoft-excel/",
    "title": "How to automatically refresh Weather Data in Microsoft Excel"
  },
  {
    "filename": "how_has_technology_changed_weather_forecasting_for_meteorologists.txt",
    "id": "file-LVHHoAuTLyz6PDaBumqFgT",
    "source": "https://www.visualcrossing.com/resources/blog/how-has-technology-changed-weather-forecasting-for-meteorologists/",
    "title": "How Has Technology Changed Weather Forecasting for Meteorologists?"
  },
  {
    "filename": "help_i_can_8217_t_log_in_to_visual_crossing_weather.txt",
    "id": "file-HbKFuC3xGb7mv5sES5MAoZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/help-i-cant-log-in-to-visual-crossing-weather/",
    "title": "Help!  I can't log in to Visual Crossing Weather!"
  },
  {
    "filename": "date_and_times_in_the_weather_api.txt",
    "id": "file-52XevUnWp99KSxZ8WwXxfb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/date-and-times-in-the-weather-api/",
    "title": "Date and Times in the Weather API"
  },
  {
    "filename": "comparing_the_visual_crossing_pricing_options_to_dark_sky.txt",
    "id": "file-R6xw1kuwCMUGQ5XHajCSQE",
    "source": "https://www.visualcrossing.com/resources/documentation/comparing-the-visual-crossing-pricing-options-to-dark-sky/",
    "title": "Comparing the Visual Crossing Pricing Options to Dark Sky"
  },
  {
    "filename": "frequently_asked_questions_faq_for_visual_crossing_weather_data.txt",
    "id": "file-DDXUdbVjw4GoHxyjVbsM8J",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/frequently-asked-questions-faq-for-visual-crossing-weather-data/",
    "title": "Frequently Asked Questions (FAQ) for Visual Crossing Weather Data"
  },
  {
    "filename": "energy_sources_affected_by_the_weather.txt",
    "id": "file-Hvuj7y85oJTBYeQUrUbmeD",
    "source": "https://www.visualcrossing.com/resources/blog/energy-sources-affected-by-the-weather/",
    "title": "Energy Sources Affected by the Weather"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_google_sheets.txt",
    "id": "file-8zr2xLuqRc7BH7Svdi8d1W",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-google-sheets/",
    "title": "How can I load historical weather data into Google Sheets?"
  },
  {
    "filename": "how_can_i_find_weather_forecast_data_for_analysis_in_r.txt",
    "id": "file-211s9hcoBgo8qgeu35h6Wn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-weather-forecast-data-for-analysis-in-r/",
    "title": "How can I find weather forecast data for analysis in R?"
  },
  {
    "filename": "how_do_i_find_the_best_long_range_weather_forecast.txt",
    "id": "file-KQRgT91zt22DmszxUV8oeT",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-find-the-best-long-range-weather-forecast/",
    "title": "How do I find the best long range Weather Forecast?"
  },
  {
    "filename": "how_do_i_load_weather_history_data_into_a_pivot_table.txt",
    "id": "file-FZWDTVVaSV9kpZBTe2ernD",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-do-i-load-weather-history-data-into-a-pivot-table/",
    "title": "How do I load Weather History data into a Pivot Table?"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_powerpoint.txt",
    "id": "file-L8gNjGMwHBKRqXsGPbgnQd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-powerpoint/",
    "title": "How do I add weather data into Microsoft PowerPoint?"
  },
  {
    "filename": "helping_us_help_you_8211_how_to_submit_an_actionable_technical_support_case.txt",
    "id": "file-Y6aZSGEPyBfM1rdcjLunLD",
    "source": "https://www.visualcrossing.com/resources/documentation/helping-us-help-you-how-to-submit-an-actionable-technical-support-case/",
    "title": "Helping us help you - How to submit an actionable technical support case"
  },
  {
    "filename": "defining_the_icon_set_parameter_in_the_weather_api.txt",
    "id": "file-3TDyj5uSXS1Z9CP9rr9wq5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/defining-icon-set-in-the-weather-api/",
    "title": "Defining the icon set parameter in the Weather API"
  },
  {
    "filename": "how_does_the_wind_blow.txt",
    "id": "file-Pc8BNYEW8AXiV5Puw4bCVD",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/how-does-the-wind-blow/",
    "title": "How does the wind blow?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_microsoft_power_bi.txt",
    "id": "file-1WqXo27SHVTmPhkg1x7txP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-microsoft-power-bi/",
    "title": "How can I load historical weather data into Microsoft Power BI?"
  },
  {
    "filename": "how_can_i_download_weather_forecast_data_as_a_csv_file.txt",
    "id": "file-3qPr1Av4h6RyRXWwnjiPy7",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-forecast-data-as-a-csv-file/",
    "title": "How can I download weather forecast data as a CSV file?"
  },
  {
    "filename": "how_do_i_get_free_weather_api_access.txt",
    "id": "file-AYSG3SDiskdqZTWos7Vwzw",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-get-free-weather-api-access/",
    "title": "How do I get free weather API access?"
  },
  {
    "filename": "how_cold_did_it_get_in_texas.txt",
    "id": "file-3Rccauk5x8uwQq8kyDR5mW",
    "source": "https://www.visualcrossing.com/resources/blog/how-cold-did-it-get-in-texas/",
    "title": "How cold did it get in Texas?"
  },
  {
    "filename": "how_do_i_find_my_nearest_weather_station.txt",
    "id": "file-MdJhbyUegjBTV4LtZ4jxQ6",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-my-nearest-weather-station/",
    "title": "How do I find my nearest weather station?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_tableau_desktop.txt",
    "id": "file-22VZLR7gfZfPhbq1jZ2Bic",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-tableau-desktop/",
    "title": "How Can I Load Historical Weather Data into Tableau Desktop?"
  },
  {
    "filename": "how_can_i_download_weather_history_data_as_a_csv_file.txt",
    "id": "file-XVcBfTqkC9ftovW8gSz3hj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-history-data-as-a-csv-file/",
    "title": "How can I download weather history data as a CSV file?"
  },
  {
    "filename": "how_do_i_find_old_weather_data.txt",
    "id": "file-L1EYzjMmLMjYMuebcwBrqx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-old-weather-data/",
    "title": "How do I find old weather data?"
  },
  {
    "filename": "how_can_i_find_past_weather_information_for_my_insurance_claim.txt",
    "id": "file-2JctMy3uY4hTZkqp5DCjSb",
    "source": "https://www.visualcrossing.com/resources/blog/how-can-i-find-past-weather-information-for-my-insurance-claim/",
    "title": "How can I find past weather information for my insurance claim?"
  },
  {
    "filename": "how_historical_weather_data_records_are_created_from_local_weather_station_observations.txt",
    "id": "file-SzcoYCJtXfKLevkx4HwhCX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-records-are-created-from-local-weather-station-observations/",
    "title": "How Historical Weather Data Records are Created from Local Weather Station Observations"
  },
  {
    "filename": "how_does_weather_affect_agriculture.txt",
    "id": "file-F7Lvw1FMX7xoU4wPUG8MtU",
    "source": "https://www.visualcrossing.com/resources/blog/how-does-weather-affect-agriculture/",
    "title": "How Does Weather Affect Agriculture"
  },
  {
    "filename": "available_data_for_visual_crossing_weather_8211_updated_december_2020.txt",
    "id": "file-2MfYfinknuKbLVuUALrYuh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/available-data-for-visual-crossing-weather-updated-january-2020/",
    "title": "Available Data for Visual Crossing Weather - Updated December 2020"
  },
  {
    "filename": "how_do_i_add_the_weather_forecast_to_my_web_page.txt",
    "id": "file-EXZYNkmhLMBc5BKXYj2UCb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-add-weather-forecast-to-my-webpage/",
    "title": "How do I add the weather forecast to my web page?"
  },
  {
    "filename": "bulk_weather_data_in_visual_crossing.txt",
    "id": "file-Kuex17GMYr5Rp5TXSJhAue",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/bulk-weather-data-in-visual-crossing/",
    "title": "Bulk Weather Data in Visual Crossing"
  },
  {
    "filename": "beaufort_vs_saffir_simpson_wind_scales.txt",
    "id": "file-4aVsdLGdnG4fvXp8oixzMj",
    "source": "https://www.visualcrossing.com/resources/blog/beaufort-and-saffir-simpson-hurricane-wind-scale-a-quick-glance/",
    "title": "Beaufort vs. Saffir-Simpson Wind Scales"
  },
  {
    "filename": "bulk_weather_forecast_data_retrieval_for_multiple_locations.txt",
    "id": "file-K7uoG4VpkAfg3CN9WKBHvF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-forecast-data-retrieval-for-multiple-locations/",
    "title": "Bulk weather forecast data retrieval for multiple locations"
  },
  {
    "filename": "celebrate_national_weatherperson_s_day_on_february_5th.txt",
    "id": "file-LPzPiu6Gmx7C2r5K2ynjCd",
    "source": "https://www.visualcrossing.com/resources/blog/celebrate-national-weatherpersons-day-on-february-5th/",
    "title": "Celebrate National Weatherperson\u2019s Day on February 5th"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_any_database.txt",
    "id": "file-E9CV6rf9ZuBfQKBDnPTR7a",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-any-database/",
    "title": "How to load historical weather data into any database"
  },
  {
    "filename": "getting_started_with_weather_data_services.txt",
    "id": "file-P3K88rDP17fT58tPi6ycjd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-weather-data-services/",
    "title": "Getting Started With Weather Data Services"
  },
  {
    "filename": "finding_historical_weather_data_for_remote_locations.txt",
    "id": "file-QG6YmXrg2mxAhX32M98cdS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/finding-historical-weather-data-for-remote-locations/",
    "title": "Finding historical weather data for remote locations"
  },
  {
    "filename": "announcing_expanded_historical_weather_data.txt",
    "id": "file-URp2noFYHMp9smtnHJmYSA",
    "source": "https://www.visualcrossing.com/resources/news/announcing-expanded-historical-weather-data/",
    "title": "Announcing Expanded Historical Weather Data"
  },
  {
    "filename": "how_do_i_create_daily_statistics_for_historical_weather_summaries_and_climate_reports.txt",
    "id": "file-4C53KBB8HpHEG1LEsP6Pxc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-create-daily-statistics-for-historical-weather-summaries-and-climate-reports/",
    "title": "How do I create daily statistics for historical weather summaries and climate reports?"
  },
  {
    "filename": "get_free_weather_data_with_our_weather_data_ambassadors_program.txt",
    "id": "file-RStNAQne9dRhiRf5S3nNvi",
    "source": "https://www.visualcrossing.com/resources/news/free-weather-data-ambassadors-program/",
    "title": "Get Free Weather Data with our Weather Data Ambassadors Program"
  },
  {
    "filename": "how_can_i_find_historical_weather_data_for_analysis_in_r.txt",
    "id": "file-XWmgKQaiW81Keq3seQhcbD",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-historical-weather-data-for-analysis-in-r/",
    "title": "How can I find historical weather data for analysis in R?"
  },
  {
    "filename": "calculating_chill_hours_for_fruit_plants_and_trees.txt",
    "id": "file-RuXcQnnJbA4fM3U8sS9Wxc",
    "source": "https://www.visualcrossing.com/resources/blog/calculating-chill-hours-for-fruit-plants-and-trees/",
    "title": "Calculating Chill Hours for Fruit Plants and Trees"
  },
  {
    "filename": "building_and_running_your_first_weather_api_query.txt",
    "id": "file-2oFoRxUe11dL4zQENMB66h",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/building-and-running-your-first-weather-api-query/",
    "title": "Building and Running your first weather API query"
  },
  {
    "filename": "construction_management_using_weather_workbook.txt",
    "id": "file-MFPJRHyRFgD3QCnDvPVL4M",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/construction-weather-management-workbook/",
    "title": "Construction Management using Weather Workbook"
  },
  {
    "filename": "automate_recent_weather_history_data_retrieval_using_microsoft_power_query.txt",
    "id": "file-NRu9fvUQsCEAoaJCLWobiY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/automate-recent-weather-history-data-retrieval-using-microsoft-power-query/",
    "title": "Automate recent weather history data retrieval using Microsoft Power Query"
  },
  {
    "filename": "degree_days_weather_api.txt",
    "id": "file-8RzNsJxsW3CWuV4so1Y8Zj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/degree-day-weather-api/",
    "title": "Degree Days Weather API"
  },
  {
    "filename": "adding_and_removing_elements_from_your_weather_query.txt",
    "id": "file-J3WKwKmATPVGzZgs5K4Z96",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/adding-and-removing-elements-from-your-weather-query/",
    "title": "Adding and Removing Elements from your Weather Query"
  },
  {
    "filename": "energy_elements_in_the_timeline_weather_api.txt",
    "id": "file-MsoamUSBzk3wfw14uwJJka",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/energy-elements-in-the-timeline-weather-api/",
    "title": "Energy elements in the Timeline Weather API"
  },
  {
    "filename": "free_weather_tools_and_dashboards.txt",
    "id": "file-GMv4VLxKrXb51xT4KF4oWg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/free-weather-tools-and-dashboards/",
    "title": "Free Weather Tools and Dashboards"
  },
  {
    "filename": "did_it_rain_on_a_date.txt",
    "id": "file-AQhArrfvHKcMNMsdPrSrvd",
    "source": "https://www.visualcrossing.com/resources/blog/did-it-rain-on-a-date/",
    "title": "Did it rain on a date?"
  },
  {
    "filename": "does_weather_affect_hunting.txt",
    "id": "file-RmHAGuyEPjEEFbinzVQmr1",
    "source": "https://www.visualcrossing.com/resources/blog/does-weather-affect-hunting/",
    "title": "Does Weather Affect Hunting?"
  },
  {
    "filename": "anchorage_november_snowfall_record_broken_2023_update.txt",
    "id": "file-Vmc9MFrNeCxYPAWhp3f6Ws",
    "source": "https://www.visualcrossing.com/resources/blog/alaska-anchorage-breaks-the-november-snow-record-and-major-lake-effect-snow-update/",
    "title": "Anchorage November Snowfall Record Broken: 2023 Update"
  },
  {
    "filename": "agriculture_elements_in_the_timeline_weather_api.txt",
    "id": "file-VantuAiiaHXTnZfxaBuwLB",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/agriculture-elements-in-the-timeline-weather-api/",
    "title": "Agriculture elements in the Timeline Weather API"
  },
  {
    "filename": "add_location_and_date_time_filters_to_odata_weather_data_requests.txt",
    "id": "file-1gXbezpGeD1qZBz2QSChw3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/add-location-and-date-time-filters-to-odata-weather-data-requests/",
    "title": "Add location and date time filters to ODATA weather data requests"
  },
  {
    "filename": "air_quality_elements_in_the_weather_api.txt",
    "id": "file-6h5yk7L2jZGhEsXfudredL",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/air-quality-elements-in-the-weather-api/",
    "title": "Air Quality Elements in the Weather API"
  },
  {
    "filename": "bulk_weather_alerts_api.txt",
    "id": "file-3rrP3KQkQve2iwg6VEFrPe",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-alerts-api/",
    "title": "Bulk Weather Alerts API"
  },
  {
    "filename": "getting_started_with_logistics_and_delivery_weather.txt",
    "id": "file-DrPg5puDUJZvjhbkVTj2aw",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-shipment-weather/",
    "title": "Getting Started With Logistics and Delivery Weather"
  },
  {
    "filename": "best_practices_for_segmenting_your_weather_queries.txt",
    "id": "file-25bpaNspir6FVTHxNgfQeA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/best-practices-for-segmenting-your-weather-queries/",
    "title": "Best practices for segmenting your weather queries"
  },
  {
    "filename": "a_guide_to_weather_triggered_advertising.txt",
    "id": "file-VQYTwp9otxuia4h54fNpxS",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-weather-triggered-advertising/",
    "title": "A Guide to Weather-Triggered Advertising"
  },
  {
    "filename": "atmospheric_rivers_bomb_cyclones_and_other_weird_weather_terms_explained.txt",
    "id": "file-TGpLJuiXqmZKvY99CR9qPV",
    "source": "https://www.visualcrossing.com/resources/blog/atmospheric-rivers-bomb-cyclones-and-other-weird-weather-words-explained/",
    "title": "Atmospheric Rivers, Bomb Cyclones and Other Weird Weather Terms, Explained"
  },
  {
    "filename": "how_are_weather_metrics_calculated_over_various_time_periods_in_different_weather_queries.txt",
    "id": "file-BydY3HsbWUY4qNVpXkyWnj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-are-weather-metrics-calculated-over-various-time-periods-in-different-weather-queries/",
    "title": "How are weather metrics calculated over various time periods in different weather queries?"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_oracle_analytics_desktop.txt",
    "id": "file-KZ3vvZoDMfbF3gZeQXmPY9",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-oracle-analytics-desktop/",
    "title": "How to load historical weather data into Oracle Analytics  Desktop?"
  },
  {
    "filename": "how_to_load_weather_data_in_c.txt",
    "id": "file-XX6iT8jdx8p4SEgPhuNVXm",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-c-sharp/",
    "title": "How to load weather data in C#"
  },
  {
    "filename": "how_to_include_sunrise_sunset_moon_phase_moonrise_and_moonset_data_into_your_api_requests.txt",
    "id": "file-S13NF8xYzXjyZzCUmwy4f8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-include-sunrise-sunset-and-moon-phase-data-into-your-api-requests/",
    "title": "How to include sunrise, sunset, moon phase, moonrise and moonset data into your API requests"
  },
  {
    "filename": "how_to_integrate_weather_data_for_postal_codes_in_the_business_cloud_of_domo.txt",
    "id": "file-WckBwFQUXjzKJe4cJpRYsa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-integrate-weather-data-for-postal-codes-in-the-business-cloud-of-domo/",
    "title": "How to integrate weather data for postal codes in The Business Cloud of DOMO."
  },
  {
    "filename": "how_to_import_weather_forecast_data_and_historical_weather_data_into_a_mysql_database.txt",
    "id": "file-G9MmsryQj1cBAnu9RKGaqU",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-import-weather-data-into-mysql/",
    "title": "How to Import Weather Forecast Data and Historical Weather Data into a MySQL Database"
  },
  {
    "filename": "degree_day_calculator_for_microsoft_excel.txt",
    "id": "file-Y2Qk7Nd6i7jV4xYE6QbE4d",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/degree-day-calculator/",
    "title": "Degree Day Calculator for Microsoft Excel"
  },
  {
    "filename": "how_can_i_find_the_average_temperature.txt",
    "id": "file-3HVsBqDKPxUk5mrCYrZTt1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-can-i-find-the-average-temperature/",
    "title": "How can I find the Average Temperature?"
  },
  {
    "filename": "academic_student_and_research_discounts_for_weather_data.txt",
    "id": "file-H79RD4kk39tmCnFHsCWkwQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/academic-student-and-research-discounts-for-weather-data/",
    "title": "Academic, student and research discounts for weather data"
  },
  {
    "filename": "how_to_include_weather_radar_data_in_weather_datasets.txt",
    "id": "file-1DdNSN91kZYX3XrjL8d6yb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-include-weather-radar-data-in-weather-datasets/",
    "title": "How to Include Weather Radar Data in Weather Datasets"
  },
  {
    "filename": "how_to_load_visual_crossing_weather_data_into_alibaba_cloud_dataworks.txt",
    "id": "file-KxkNnMaN8WcAPPNsUmsbQd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-visual-crossing-weather-data-into-alibaba-cloud-dataworks/",
    "title": "How to load Visual Crossing weather data into Alibaba Cloud DataWorks"
  },
  {
    "filename": "how_to_import_weather_data_into_microsoft_sql_server.txt",
    "id": "file-N4zWENSnjdJvQxWXhWMro8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-import-weather-data-into-microsoft-sql-server/",
    "title": "How to import weather data into Microsoft SQL Server"
  },
  {
    "filename": "how_to_i_properly_cite_or_attribute_the_weather_data_in_my_project_to_visual_crossing_weather.txt",
    "id": "file-Cgw4c45A8Rdei3W5ubDHFP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-i-properly-cite-or-attribute-the-weather-data-in-my-project-to-visual-crossing-weather/",
    "title": "How to I properly cite or attribute the weather data in my project to Visual Crossing Weather?"
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_qlik_sense.txt",
    "id": "file-KfpXmDNVc1uKVv1YmLjzkQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-qlik-sense/",
    "title": "How to load weather forecast data into Qlik Sense?"
  },
  {
    "filename": "how_to_find_weather_data_for_your_next_data_science_project.txt",
    "id": "file-N5njHfhCetukYhXF7gGFet",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-weather-data-for-data-science/",
    "title": "How to Find Weather Data for your Next Data Science Project"
  },
  {
    "filename": "how_to_load_weather_data_in_matlab.txt",
    "id": "file-CZzMMvXkKARNxQJVzbLHeV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-matlab/",
    "title": "How to load weather data in MATLAB"
  },
  {
    "filename": "how_to_load_visual_crossing_weather_data_into_alibaba_cloud_dataworks.txt",
    "id": "file-WUv1jnjM7gDWFSTc8WoTqD",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-visual-crossing-weather-data-into-alibaba-cloud-dataworks/",
    "title": "How to load Visual Crossing weather data into Alibaba Cloud DataWorks"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_any_database.txt",
    "id": "file-CehJYZskqzejzwpaE3GWcf",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-any-database/",
    "title": "How to load historical weather data into any database"
  },
  {
    "filename": "how_to_find_the_typical_weather_conditions_in_a_certain_area.txt",
    "id": "file-8syjMbC2BEPdVosWXZyvjL",
    "source": "https://www.visualcrossing.com/resources/blog/what-are-the-typical-weather-conditions-in-a-certain-area/",
    "title": "How to Find the Typical Weather Conditions in a Certain Area?"
  },
  {
    "filename": "certificate_error_running_weather_api_requests.txt",
    "id": "file-4RkwcRkBhgjdGJzCKnFQeK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/certificate-error-running-weather-api-requests/",
    "title": "Certificate error running Weather API requests"
  },
  {
    "filename": "how_to_load_weather_data_in_ruby.txt",
    "id": "file-Pcpmow8Pzvovjh8fQiJGcx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-ruby/",
    "title": "How to load weather data in Ruby"
  },
  {
    "filename": "atmospheric_rivers_bomb_cyclones_and_other_weird_weather_terms_explained.txt",
    "id": "file-Qqi7pCLCYee37JPZe18iF8",
    "source": "https://www.visualcrossing.com/resources/blog/atmospheric-rivers-bomb-cyclones-and-other-weird-weather-words-explained/",
    "title": "Atmospheric Rivers, Bomb Cyclones and Other Weird Weather Terms, Explained"
  },
  {
    "filename": "how_to_load_weather_data_into_apache_openoffice_calc.txt",
    "id": "file-Ak8GgjFkte6pNoV5MJkQDA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-load-weather-data-into-apache-openoffice-calc/",
    "title": "How to load Weather Data into Apache OpenOffice Calc"
  },
  {
    "filename": "how_to_handle_daylight_savings_in_the_visual_crossing_weather_api.txt",
    "id": "file-GZRuEm5S83eq1dQgEKo3vK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-handle-daylight-savings-in-the-visual-crossing-weather-api/",
    "title": "How to Handle Daylight Savings in the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_load_weather_data_using_python.txt",
    "id": "file-RmYxwTjaegbyRKR41Xa5Bp",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-load-historical-weather-data-using-python-without-scraping/",
    "title": "How to Load Weather Data Using Python?"
  },
  {
    "filename": "how_to_load_weather_data_in_swift.txt",
    "id": "file-7pmaxPc25GUZEQMYkQe6UA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-swift/",
    "title": "How to load weather data in Swift"
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_tibco_spotfire_via_odata_request.txt",
    "id": "file-D7iQ5xNCCA72evnfvQWuQM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-tibco-spotfire-via-odata-request/",
    "title": "How to load weather forecast data into TIBCO Spotfire via ODATA request"
  },
  {
    "filename": "how_to_load_weather_data_into_a_juypter_notebook.txt",
    "id": "file-4Fg89LpUSuYygxrwpvtJxZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-into-a-juypter-notebook/",
    "title": "How to load weather data into a Juypter Notebook"
  },
  {
    "filename": "how_to_load_weather_data_using_vb_net.txt",
    "id": "file-PzsKT7sVGp4Pd1RPFb6obf",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-vb-net/",
    "title": "How to load weather data using VB.net"
  },
  {
    "filename": "how_to_load_weather_data_into_sas_visual_analytics_or_sas_visual_statistics.txt",
    "id": "file-GYjE1xjAqiZ1DhPpx7zmp8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-data-into-sas-viya/",
    "title": "How to load weather data into SAS Visual Analytics or SAS Visual Statistics."
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_oracle_analytics_desktop.txt",
    "id": "file-8DRgEiekbLcwAZoPowx1Ba",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-oracle-analytics-desktop/",
    "title": "How to load weather forecast data into Oracle Analytics Desktop"
  },
  {
    "filename": "how_to_load_weather_data_using_lisp.txt",
    "id": "file-YLSc38UjxaAJcmLkGzxNp9",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-lisp/",
    "title": "How to load weather data using LISP"
  },
  {
    "filename": "how_to_load_weather_data_into_information_builders_ibi_webfocus_using_the_rest_api.txt",
    "id": "file-XEdTw3D27gjnKpCen9Kom4",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-data-into-information-builders-ibi-webfocus-using-the-rest-api/",
    "title": "How to load weather data into Information Builders ibi WebFOCUS using the REST API"
  },
  {
    "filename": "how_to_load_weather_forecast_data_as_a_microsoft_excel_xlsx_file.txt",
    "id": "file-WYWXAcbKgRt87TuciagHaF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-as-a-microsoft-excel-xlsx-file/",
    "title": "How to load weather forecast data as a Microsoft Excel XLSX file"
  },
  {
    "filename": "how_to_import_weather_data_into_microsoft_sql_server.txt",
    "id": "file-H9JmwuxkC5RdJ3LkjNtsxZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-import-weather-data-into-microsoft-sql-server/",
    "title": "How to import weather data into Microsoft SQL Server"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_oracle_analytics_desktop.txt",
    "id": "file-8NwbDtz1qDiKvugzYLVy6v",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-oracle-analytics-desktop/",
    "title": "How to load historical weather data into Oracle Analytics  Desktop?"
  },
  {
    "filename": "how_to_load_weather_data_into_google_sheets_using_json.txt",
    "id": "file-JYsqre6sQbZTwgyRnGBbfQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-load-weather-data-into-google-sheets-using-json/",
    "title": "How To Load Weather Data into Google Sheets using JSON"
  },
  {
    "filename": "how_to_load_weather_data_in_php.txt",
    "id": "file-CyGaydHsyR5N2sSNeL6Pzo",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-php/",
    "title": "How to load weather data in PHP"
  },
  {
    "filename": "how_to_load_weather_data_using_google_s_go_language.txt",
    "id": "file-Uo8WoDk9VfrKu1ySMauqmK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-googles-go-language/",
    "title": "How to load weather data using Google\u2019s Go language"
  },
  {
    "filename": "how_to_include_weather_radar_data_in_weather_datasets.txt",
    "id": "file-GtX1woiKbvwzdpzx2HHmAX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-include-weather-radar-data-in-weather-datasets/",
    "title": "How to Include Weather Radar Data in Weather Datasets"
  },
  {
    "filename": "how_to_import_weather_forecast_data_and_historical_weather_data_into_a_mysql_database.txt",
    "id": "file-HZmQFxwHjZqKgHWFGJjoMe",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-import-weather-data-into-mysql/",
    "title": "How to Import Weather Forecast Data and Historical Weather Data into a MySQL Database"
  },
  {
    "filename": "how_to_load_weather_data_in_javascript_using_fetch_api_jquery_d3_or_node_js.txt",
    "id": "file-PGbH9kuhabS88FWXZBVjNv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-javascript/",
    "title": "How to load weather data in JavaScript using Fetch API, jQuery, d3 or node.js"
  },
  {
    "filename": "how_to_integrate_weather_data_for_postal_codes_in_the_business_cloud_of_domo.txt",
    "id": "file-1XYrjvXnaZKaEpRHjBwKHw",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-integrate-weather-data-for-postal-codes-in-the-business-cloud-of-domo/",
    "title": "How to integrate weather data for postal codes in The Business Cloud of DOMO."
  },
  {
    "filename": "how_to_load_weather_data_in_c.txt",
    "id": "file-YYMcf7idbqAzf9wV3V83Ht",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-c-sharp/",
    "title": "How to load weather data in C#"
  },
  {
    "filename": "how_can_i_find_the_average_temperature.txt",
    "id": "file-PuHUYHALcRcxvRYvFM35KX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-can-i-find-the-average-temperature/",
    "title": "How can I find the Average Temperature?"
  },
  {
    "filename": "how_to_find_historical_weather_for_maritime_sea_and_ocean_locations.txt",
    "id": "file-MAqsUw8jzuaByPt75S1mu1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-historical-weather-for-maritime-sea-and-ocean-locations/",
    "title": "How to find historical weather for maritime, sea and ocean locations"
  },
  {
    "filename": "how_do_i_get_free_weather_api_access.txt",
    "id": "file-3LDy9a5w2zu6QbU8BwTi4K",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-get-free-weather-api-access/",
    "title": "How do I get free weather API access?"
  },
  {
    "filename": "how_to_include_sunrise_sunset_moon_phase_moonrise_and_moonset_data_into_your_api_requests.txt",
    "id": "file-7Vi1648FqXMLLwVeojJ3Ea",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-include-sunrise-sunset-and-moon-phase-data-into-your-api-requests/",
    "title": "How to include sunrise, sunset, moon phase, moonrise and moonset data into your API requests"
  },
  {
    "filename": "how_to_create_annual_or_monthly_climate_summaries_and_normals_for_a_location.txt",
    "id": "file-2dbaqETtwsyXvqPQzfEByg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-create-annual-or-monthly-climate-summaries-and-normals-for-a-location/",
    "title": "How to create annual or monthly climate summaries and normals for a location"
  },
  {
    "filename": "getting_started_with_logistics_and_delivery_weather.txt",
    "id": "file-Y5GDdU2Mz5bdBqWbSPiQ4T",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-shipment-weather/",
    "title": "Getting Started With Logistics and Delivery Weather"
  },
  {
    "filename": "how_to_find_and_use_sub_hourly_historical_weather_data.txt",
    "id": "file-Wj45y8d76wR8s8E8pRq7AY",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-and-use-sub-hourly-historical-weather-data/",
    "title": "How to find and use sub-hourly historical weather data"
  },
  {
    "filename": "how_to_find_weather_data_using_nlp_natural_language_processing.txt",
    "id": "file-4MfXm3XokpT3vyZ2SRHujS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-weather-data-using-nlp/",
    "title": "How to find weather data using NLP (Natural Language Processing)"
  },
  {
    "filename": "how_to_download_weather_forecast_data_as_a_microsoft_excel_workbook.txt",
    "id": "file-SJ4a2hggesR4jnBZnxPmoe",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-download-weather-forecast-data-as-a-microsoft-excel-workbook/",
    "title": "How to download weather forecast data as a Microsoft Excel Workbook"
  },
  {
    "filename": "how_to_add_weather_forecast_data_into_microsoft_planner.txt",
    "id": "file-ToTNCvamPnCWgPPTkVnfpY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-forecast-data-into-microsoft-planner/",
    "title": "How to add weather forecast data into Microsoft Planner"
  },
  {
    "filename": "how_historical_weather_data_records_are_created_from_local_weather_station_observations.txt",
    "id": "file-PGVdtA7DuhC8amxamUzGkg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-records-are-created-from-local-weather-station-observations/",
    "title": "How Historical Weather Data Records are Created from Local Weather Station Observations"
  },
  {
    "filename": "how_to_find_accurate_snow_weather_data.txt",
    "id": "file-39JPXqUsEDXx7STmXAL8cJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-accurate-snow-weather-data/",
    "title": "How to find accurate snow weather data"
  },
  {
    "filename": "how_to_find_and_manage_your_visual_crossing_weather_api_key.txt",
    "id": "file-25Qqk9Rw7wZuEoPWWiRhqs",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-change-your-visual-crossing-weather-api-key/",
    "title": "How to Find and Manage Your Visual Crossing Weather API Key"
  },
  {
    "filename": "how_to_create_or_modify_language_files.txt",
    "id": "file-P55A3Nz9tLPGEpdMi3vU4h",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-or-modify-language-files/",
    "title": "How to create or modify language files"
  },
  {
    "filename": "how_to_add_weather_data_to_sas_visual_data_mining_038_machine_learning.txt",
    "id": "file-8CjH6oC3otsRQGXEuWahkb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-sas-visual-data-mining-machine-learning/",
    "title": "How to add Weather Data to SAS Visual Data Mining & Machine Learning"
  },
  {
    "filename": "how_historical_weather_data_is_updated.txt",
    "id": "file-XFW3DET5zzroNXPoagCyqy",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-is-updated/",
    "title": "How historical weather data is updated"
  },
  {
    "filename": "how_can_i_download_weather_history_data_as_a_csv_file.txt",
    "id": "file-FxftLfExksrbxZVm14r9AG",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-history-data-as-a-csv-file/",
    "title": "How can I download weather history data as a CSV file?"
  },
  {
    "filename": "how_to_download_the_weather_forecast_for_all_us_zip_codes.txt",
    "id": "file-Vut4FMpWr9id1zQyTjUGWs",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-the-weather-forecast-for-all-us-zip-codes/",
    "title": "How to download the weather forecast for all US ZIP Codes"
  },
  {
    "filename": "how_can_i_find_historical_weather_data_for_analysis_in_r.txt",
    "id": "file-Ku46BWd8qib9zd9A8vtsGq",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-historical-weather-data-for-analysis-in-r/",
    "title": "How can I find historical weather data for analysis in R?"
  },
  {
    "filename": "how_do_i_find_old_weather_data.txt",
    "id": "file-P9DuovPqPAVfsAXqAUtGUZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-old-weather-data/",
    "title": "How do I find old weather data?"
  },
  {
    "filename": "how_to_automatically_refresh_weather_data_in_microsoft_excel.txt",
    "id": "file-GYzZSbMrPQ6TFJKfqYNtb3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-automatically-refresh-weather-data-in-microsoft-excel/",
    "title": "How to automatically refresh Weather Data in Microsoft Excel"
  },
  {
    "filename": "how_to_build_a_weather_app.txt",
    "id": "file-CwsLRNKsWRoUtU89D2N9vF",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-building-a-weather-app/",
    "title": "How to Build a Weather App?"
  },
  {
    "filename": "how_to_create_a_raspberry_pi_frost_alert_using_a_weather_api.txt",
    "id": "file-RyHeXxai9ugKwhifXNn9xx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-a-raspberry-pi-frost-alert-using-a-weather-api/",
    "title": "How to create a Raspberry PI frost alert using a weather api"
  },
  {
    "filename": "how_to_find_a_weather_api_for_your_hackathon.txt",
    "id": "file-W91L5oHJDYFR2MHKtKHGQA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-a-weather-api-for-your-hackathon/",
    "title": "How to find a Weather API for your hackathon"
  },
  {
    "filename": "how_to_add_weather_data_to_a_node_js_app_using_a_weather_api_and_javascript.txt",
    "id": "file-E2qJkpvrWKH5AkQX3utfB1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-add-weather-data-to-a-node-js-app-using-a-weather-api-and-javascript/",
    "title": "How to add weather data to a Node.js app using a Weather API and JavaScript"
  },
  {
    "filename": "how_to_debug_problems_when_running_weather_api_queries_in_code.txt",
    "id": "file-PgMvzGPFZ2SCCwmbzHhHUK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-debug-problems-when-running-weather-api-queries-in-code/",
    "title": "How to debug problems when running weather API queries in code"
  },
  {
    "filename": "how_do_i_retrieve_weather_data_using_an_odata_request.txt",
    "id": "file-9aeEVFFrV2Wvd1ehCu8J4U",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-retrieve-weather-data-using-an-odata-request/",
    "title": "How do I retrieve weather data using an ODATA request?"
  },
  {
    "filename": "degree_days_weather_api.txt",
    "id": "file-4sHD3tsWt3krdqH8RiMsBM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/degree-day-weather-api/",
    "title": "Degree Days Weather API"
  },
  {
    "filename": "how_cold_did_it_get_in_texas.txt",
    "id": "file-TiqmWgMQneouZGPpwGgyX9",
    "source": "https://www.visualcrossing.com/resources/blog/how-cold-did-it-get-in-texas/",
    "title": "How cold did it get in Texas?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_using_google_apps_script.txt",
    "id": "file-D7acegWrGtXx8biiNpJaF1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-can-i-load-historical-weather-data-using-google-apps-script/",
    "title": "How can I load historical weather data using Google Apps Script?"
  },
  {
    "filename": "how_to_add_free_weather_information_to_your_kanban_board_in_leankit_planview.txt",
    "id": "file-RiedSqfG99akCJKizpbZVo",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-your-kanban-board-in-leankit-planview/",
    "title": "How to add free weather information to your Kanban board in  LeanKit planview."
  },
  {
    "filename": "how_to_create_a_weather_chatbot_step_by_step_guide.txt",
    "id": "file-VkRYiqf9WK9hZPVg5fNMev",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-create-a-weather-chatbot-step-by-step-guide/",
    "title": "How to Create a Weather Chatbot | Step-by-Step Guide"
  },
  {
    "filename": "how_do_we_create_our_weather_forecast.txt",
    "id": "file-PjJq7X1gcFF1LZcgqzd3pK",
    "source": "https://www.visualcrossing.com/resources/documentation/how-do-we-create-our-weather-forecast/",
    "title": "How do we create our weather forecast?"
  },
  {
    "filename": "how_to_add_weather_data_to_google_sheets_using_a_dynamic_weather_query.txt",
    "id": "file-Xp9fyhFBDa2g8Cjhdgj9oK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-add-weather-data-to-google-sheets-using-a-dynamic-weather-query/",
    "title": "How to add Weather Data to Google Sheets using a Dynamic Weather Query"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_google_sheets.txt",
    "id": "file-Y6U6Ahyp4oQ63sEHCBZ8uy",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-google-sheets/",
    "title": "How can I load historical weather data into Google Sheets?"
  },
  {
    "filename": "get_free_weather_data_with_our_weather_data_ambassadors_program.txt",
    "id": "file-Vbot6bXjV4FkGLwNvGhwr4",
    "source": "https://www.visualcrossing.com/resources/news/free-weather-data-ambassadors-program/",
    "title": "Get Free Weather Data with our Weather Data Ambassadors Program"
  },
  {
    "filename": "a_guide_to_weather_triggered_advertising.txt",
    "id": "file-Sf64EnwFeCqDgCDQsCu4Bz",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-weather-triggered-advertising/",
    "title": "A Guide to Weather-Triggered Advertising"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_powerpoint.txt",
    "id": "file-2Mag7RuXKKhQrJ9fsWtccT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-powerpoint/",
    "title": "How do I add weather data into Microsoft PowerPoint?"
  },
  {
    "filename": "how_to_use_the_microsoft_excel_webservice_function_to_retrieve_weather_data.txt",
    "id": "file-52sNjvAFGyX3nxG62hkvrX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-use-the-microsoft-excel-webservice-function-to-retrieve-weather-data/",
    "title": "How to use the Microsoft Excel WEBSERVICE function to retrieve weather data"
  },
  {
    "filename": "how_are_weather_metrics_calculated_over_various_time_periods_in_different_weather_queries.txt",
    "id": "file-HcT9b4hq1dn8qesToRyyLH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-are-weather-metrics-calculated-over-various-time-periods-in-different-weather-queries/",
    "title": "How are weather metrics calculated over various time periods in different weather queries?"
  },
  {
    "filename": "how_to_manage_your_personal_account_information.txt",
    "id": "file-VrcEfE3Q3beo6ALWbrtVxR",
    "source": "https://www.visualcrossing.com/resources/documentation/how-to-manage-your-personal-account-information/",
    "title": "How to manage your personal account information"
  },
  {
    "filename": "how_to_cancel_visual_crossing_weather_data_subscriptions.txt",
    "id": "file-MkBEaxkxmJ8yod1PFjj43V",
    "source": "https://www.visualcrossing.com/resources/documentation/how-to-cancel-visual-crossing-weather-data-subscriptions/",
    "title": "How to cancel Visual Crossing Weather Data Subscriptions"
  },
  {
    "filename": "how_to_download_weather_data_for_multiple_locations.txt",
    "id": "file-Gdi1nt7VfSf5SNFnHyYDpw",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-weather-data-for-multiple-locations/",
    "title": "How to download weather data for multiple locations"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_tableau_desktop.txt",
    "id": "file-QK1dSiPZRgWojUt6stcNc7",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-tableau-desktop/",
    "title": "How Can I Load Historical Weather Data into Tableau Desktop?"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_tableau_desktop.txt",
    "id": "file-Gh7zPBfrLKDmJRBN9TEiw9",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-do-i-load-weather-forecast-data-into-tableau-desktop/",
    "title": "How Can I Load Weather Forecast Data into Tableau Desktop?"
  },
  {
    "filename": "how_do_i_create_daily_statistics_for_historical_weather_summaries_and_climate_reports.txt",
    "id": "file-CCDbuiMHnQ1uu2SphL7cbu",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-create-daily-statistics-for-historical-weather-summaries-and-climate-reports/",
    "title": "How do I create daily statistics for historical weather summaries and climate reports?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_microsoft_power_bi.txt",
    "id": "file-HjfR3ZSarhA21wYno4EFVs",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-microsoft-power-bi/",
    "title": "How can I load historical weather data into Microsoft Power BI?"
  },
  {
    "filename": "how_do_i_get_started_with_the_weather_api.txt",
    "id": "file-PocGx7SGdxnZnTvQeNw2ct",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-get-started-with-the-weather-api/",
    "title": "How do I get started with the Weather API?"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_qlik_sense.txt",
    "id": "file-BPwYf2abr35btPzErdso4U",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-qlik-sense/",
    "title": "How to add historical weather data to Qlik Sense"
  },
  {
    "filename": "how_to_build_an_artificially_intelligent_chatbot_using_the_microsoft_bot_framework_and_the_visual_crossing_weather_api.txt",
    "id": "file-WPKiArqcoW7pjZCWew6kH4",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-build-an-artificially-intelligent-chatbot-using-the-microsoft-bot-framework-and-the-visual-crossing-weather-api/",
    "title": "How to Build an Artificially Intelligent Chatbot using the Microsoft Bot Framework and the Visual Crossing Weather API"
  },
  {
    "filename": "how_does_weather_affect_agriculture.txt",
    "id": "file-356fag9TtGc6iGofZpiTFS",
    "source": "https://www.visualcrossing.com/resources/blog/how-does-weather-affect-agriculture/",
    "title": "How Does Weather Affect Agriculture"
  },
  {
    "filename": "frequently_asked_questions_faq_for_visual_crossing_weather_data.txt",
    "id": "file-QcwvJWiTsqAz2Mwjsx8RqE",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/frequently-asked-questions-faq-for-visual-crossing-weather-data/",
    "title": "Frequently Asked Questions (FAQ) for Visual Crossing Weather Data"
  },
  {
    "filename": "how_do_i_find_my_nearest_weather_station.txt",
    "id": "file-8SN8xEh6EaCrtTgkp2BFYx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-my-nearest-weather-station/",
    "title": "How do I find my nearest weather station?"
  },
  {
    "filename": "defining_the_icon_set_parameter_in_the_weather_api.txt",
    "id": "file-HsQnHe2ccbwQj5YuJCgtLN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/defining-icon-set-in-the-weather-api/",
    "title": "Defining the icon set parameter in the Weather API"
  },
  {
    "filename": "free_weather_tools_and_dashboards.txt",
    "id": "file-1cBy3EZ5AkFiMo9DsSygGT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/free-weather-tools-and-dashboards/",
    "title": "Free Weather Tools and Dashboards"
  },
  {
    "filename": "how_does_the_wind_blow.txt",
    "id": "file-HE7fNY7Ga5A3qcEXexyVYh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/how-does-the-wind-blow/",
    "title": "How does the wind blow?"
  },
  {
    "filename": "how_can_i_find_past_weather_information_for_my_insurance_claim.txt",
    "id": "file-Lbo9W2AKE6TaLG96KT9AS7",
    "source": "https://www.visualcrossing.com/resources/blog/how-can-i-find-past-weather-information-for-my-insurance-claim/",
    "title": "How can I find past weather information for my insurance claim?"
  },
  {
    "filename": "construction_management_using_weather_workbook.txt",
    "id": "file-Mkoo73ecwjBwhXpYJaZ1bQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/construction-weather-management-workbook/",
    "title": "Construction Management using Weather Workbook"
  },
  {
    "filename": "how_to_add_weather_data_to_your_microstrategy_project.txt",
    "id": "file-GE4KKEqUjCQZJkDDCzUzwn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-your-microstrategy-project/",
    "title": "How to add Weather Data to your MicroStrategy project"
  },
  {
    "filename": "how_has_technology_changed_weather_forecasting_for_meteorologists.txt",
    "id": "file-X4x4v9RMY5TsQ7RikFnfDW",
    "source": "https://www.visualcrossing.com/resources/blog/how-has-technology-changed-weather-forecasting-for-meteorologists/",
    "title": "How Has Technology Changed Weather Forecasting for Meteorologists?"
  },
  {
    "filename": "date_and_times_in_the_weather_api.txt",
    "id": "file-GqAsND7U6nTjhftjYDt51d",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/date-and-times-in-the-weather-api/",
    "title": "Date and Times in the Weather API"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_google_sheets.txt",
    "id": "file-63ut2DrfJAPUWfcnRp4Mng",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-google-sheets/",
    "title": "How can I load weather forecast data into Google Sheets?"
  },
  {
    "filename": "how_do_i_find_the_best_long_range_weather_forecast.txt",
    "id": "file-88bQ47FFQhjPHrU2fnwPmZ",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-find-the-best-long-range-weather-forecast/",
    "title": "How do I find the best long range Weather Forecast?"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_tibco_spotfire_via_odata_request.txt",
    "id": "file-7oeZUGM7cyeb5XritfDSpX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-tibco-spotfire-via-odata-request/",
    "title": "How to add historical weather data to TIBCO Spotfire  via ODATA request"
  },
  {
    "filename": "calculating_chill_hours_for_fruit_plants_and_trees.txt",
    "id": "file-FKdDou51Rz4t7c11X5doru",
    "source": "https://www.visualcrossing.com/resources/blog/calculating-chill-hours-for-fruit-plants-and-trees/",
    "title": "Calculating Chill Hours for Fruit Plants and Trees"
  },
  {
    "filename": "how_can_i_find_weather_forecast_data_for_analysis_in_r.txt",
    "id": "file-ALb7MjBUYmKzSrd9sSXwCz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-weather-forecast-data-for-analysis-in-r/",
    "title": "How can I find weather forecast data for analysis in R?"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_microsoft_power_bi.txt",
    "id": "file-XJYseATynit6VxZWyvpofS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-microsoft-power-bi/",
    "title": "How can I load weather forecast data into Microsoft Power BI?"
  },
  {
    "filename": "beaufort_vs_saffir_simpson_wind_scales.txt",
    "id": "file-K6CRs1x8QfaBxYyGUvQoQi",
    "source": "https://www.visualcrossing.com/resources/blog/beaufort-and-saffir-simpson-hurricane-wind-scale-a-quick-glance/",
    "title": "Beaufort vs. Saffir-Simpson Wind Scales"
  },
  {
    "filename": "how_to_add_free_weather_information_to_an_evernote_notebook.txt",
    "id": "file-Uoope9cGDjjBpnARViiNki",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-an-evernote-notebook/",
    "title": "How to add free weather information to an Evernote notebook"
  },
  {
    "filename": "bulk_weather_forecast_data_retrieval_for_multiple_locations.txt",
    "id": "file-XG3h1zwMQaYAFD6oCY3K4E",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-forecast-data-retrieval-for-multiple-locations/",
    "title": "Bulk weather forecast data retrieval for multiple locations"
  },
  {
    "filename": "how_can_i_get_bulk_weather_data.txt",
    "id": "file-NPcnJE8YLkZT1D7SQF8ScK",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-get-bulk-weather-data/",
    "title": "How can I get bulk weather data?"
  },
  {
    "filename": "how_do_i_run_a_weather_api_query_using_http_post.txt",
    "id": "file-GRB2vD25qyw79woxXzYe2w",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-run-a-weather-api-query-using-http-post/",
    "title": "How do I run a weather API query using HTTP POST?"
  },
  {
    "filename": "how_to_sign_up_for_a_weather_data_038_weather_api_account.txt",
    "id": "file-DpaFaz9MwxFGCh4AtpeJQJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-sign-up-for-a-weather-data-weather-api-account/",
    "title": "How to sign up for a Weather Data & Weather API Account"
  },
  {
    "filename": "how_do_i_add_the_weather_forecast_to_my_web_page.txt",
    "id": "file-E5RJTNeL8tJWsq1TVrt26g",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-add-weather-forecast-to-my-webpage/",
    "title": "How do I add the weather forecast to my web page?"
  },
  {
    "filename": "finding_historical_weather_data_for_remote_locations.txt",
    "id": "file-HhUMMEtr2Hmmb2LJjYonuy",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/finding-historical-weather-data-for-remote-locations/",
    "title": "Finding historical weather data for remote locations"
  },
  {
    "filename": "how_can_i_use_the_visual_crossing_weather_date_chooser_to_jump_to_historical_weather_for_any_time.txt",
    "id": "file-UxWbX2biJJ8BKWGwMhCfLJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-use-the-visual-crossing-weather-date-chooser-to-jump-to-historical-weather-for-any-time/",
    "title": "How can I use the Visual Crossing Weather date chooser to jump to historical weather for any time?"
  },
  {
    "filename": "announcing_our_free_weather_api_plan.txt",
    "id": "file-9rfY9QhTH9Etngc3VpFpTr",
    "source": "https://www.visualcrossing.com/resources/news/announcing-our-free-weather-api-plan/",
    "title": "Announcing our free Weather API Plan"
  },
  {
    "filename": "energy_elements_in_the_timeline_weather_api.txt",
    "id": "file-SA85QVt5QA76UsmN8aJUHj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/energy-elements-in-the-timeline-weather-api/",
    "title": "Energy elements in the Timeline Weather API"
  },
  {
    "filename": "bulk_weather_data_in_visual_crossing.txt",
    "id": "file-Qrf9kvirdWdsHWvTZ3KSb7",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/bulk-weather-data-in-visual-crossing/",
    "title": "Bulk Weather Data in Visual Crossing"
  },
  {
    "filename": "how_do_i_load_weather_history_data_into_a_pivot_table.txt",
    "id": "file-6e3F6J4mxDpNjpbxt26JMd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-do-i-load-weather-history-data-into-a-pivot-table/",
    "title": "How do I load Weather History data into a Pivot Table?"
  },
  {
    "filename": "bulk_weather_alerts_api.txt",
    "id": "file-9wnFHT8qHbPBBd1eBfDGHf",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-alerts-api/",
    "title": "Bulk Weather Alerts API"
  },
  {
    "filename": "how_to_use_historical_weather_data_to_forecast_the_weather_for_any_day_of_the_year.txt",
    "id": "file-LM3iq2ttHS9DficrHzUtwW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-use-historical-weather-data-to-forecast-the-weather-for-any-day-of-the-year/",
    "title": "How to use historical weather data to forecast the weather for any day of the year."
  },
  {
    "filename": "how_can_i_download_weather_forecast_data_as_a_csv_file.txt",
    "id": "file-LNcpJQh9PuGma4pq5hYRhV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-forecast-data-as-a-csv-file/",
    "title": "How can I download weather forecast data as a CSV file?"
  },
  {
    "filename": "degree_day_calculator_for_microsoft_excel.txt",
    "id": "file-PWMYArpmcJ1vo4653T42u2",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/degree-day-calculator/",
    "title": "Degree Day Calculator for Microsoft Excel"
  },
  {
    "filename": "getting_started_with_weather_data_services.txt",
    "id": "file-SwedS9EN1AyVNGKRNxdHZZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-weather-data-services/",
    "title": "Getting Started With Weather Data Services"
  },
  {
    "filename": "help_i_can_8217_t_log_in_to_visual_crossing_weather.txt",
    "id": "file-PU3HdAfJpru4yKXM3wEJu5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/help-i-cant-log-in-to-visual-crossing-weather/",
    "title": "Help!  I can't log in to Visual Crossing Weather!"
  },
  {
    "filename": "how_can_i_replace_the_dark_sky_api.txt",
    "id": "file-K5HAM8c4eLxJHNr6WRGG5n",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-replace-the-darksky-api/",
    "title": "How can I replace the Dark Sky API?"
  },
  {
    "filename": "comparing_the_visual_crossing_pricing_options_to_dark_sky.txt",
    "id": "file-6HppssAbc91hhn7a3dfMU1",
    "source": "https://www.visualcrossing.com/resources/documentation/comparing-the-visual-crossing-pricing-options-to-dark-sky/",
    "title": "Comparing the Visual Crossing Pricing Options to Dark Sky"
  },
  {
    "filename": "how_to_use_the_calendar_control_in_the_visual_crossing_weather_data_web_query_gui.txt",
    "id": "file-MNqoYGVp3KrxkpHL7hUv9z",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/how-to-use-the-calendar-control-in-the-visual-crossing-weather-data-web-query-gui/",
    "title": "How to use the calendar control in the Visual Crossing Weather Data Web Query GUI"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_word.txt",
    "id": "file-BjCR5SYEhZRhD4gGNHvfAr",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-word/",
    "title": "How do I add weather data into Microsoft Word?"
  },
  {
    "filename": "best_practices_for_segmenting_your_weather_queries.txt",
    "id": "file-C8jxsVmYaW5PedaBe8guJk",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/best-practices-for-segmenting-your-weather-queries/",
    "title": "Best practices for segmenting your weather queries"
  },
  {
    "filename": "does_weather_affect_hunting.txt",
    "id": "file-NKh4oj68ZDoFaWZZz4LLKf",
    "source": "https://www.visualcrossing.com/resources/blog/does-weather-affect-hunting/",
    "title": "Does Weather Affect Hunting?"
  },
  {
    "filename": "automate_recent_weather_history_data_retrieval_using_microsoft_power_query.txt",
    "id": "file-NqktbUYtoRtiyuLW6gDVSd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/automate-recent-weather-history-data-retrieval-using-microsoft-power-query/",
    "title": "Automate recent weather history data retrieval using Microsoft Power Query"
  },
  {
    "filename": "how_to_build_a_great_weather_dashboard.txt",
    "id": "file-VWfsgBLndTQYULm1QJJhgk",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-build-a-great-weather-dashboard/",
    "title": "How to build a great Weather Dashboard"
  },
  {
    "filename": "energy_sources_affected_by_the_weather.txt",
    "id": "file-GPQfGyMi5NNv6Kk5rXjazj",
    "source": "https://www.visualcrossing.com/resources/blog/energy-sources-affected-by-the-weather/",
    "title": "Energy Sources Affected by the Weather"
  },
  {
    "filename": "agriculture_elements_in_the_timeline_weather_api.txt",
    "id": "file-P9Y8TJj4hiKW1T1s3PMSD5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/agriculture-elements-in-the-timeline-weather-api/",
    "title": "Agriculture elements in the Timeline Weather API"
  },
  {
    "filename": "8220_north_and_west_of_i_95_8221_8211_why_does_snow_in_the_eastern_us_always_seem_fall_to_the_west_of_i_95.txt",
    "id": "file-Tb7FpH1oq5Vbp5LeKBNJdX",
    "source": "https://www.visualcrossing.com/resources/blog/why-does-snow-in-the-eastern-us-always-seem-fall-to-the-west-of-i-95/",
    "title": "'North and West of I-95' - why does snow in the Eastern US always seem fall to the West of I-95?"
  },
  {
    "filename": "add_location_and_date_time_filters_to_odata_weather_data_requests.txt",
    "id": "file-QrAEE9CdayEefJNxgRqceT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/add-location-and-date-time-filters-to-odata-weather-data-requests/",
    "title": "Add location and date time filters to ODATA weather data requests"
  },
  {
    "filename": "how_we_process_the_noaa_integrated_surface_database_historical_weather_data.txt",
    "id": "file-KmNhTEMZsTC2p5HfPxYqsJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-we-process-integrated-surface-database-historical-weather-data/",
    "title": "How We Process the NOAA Integrated Surface Database Historical Weather Data"
  },
  {
    "filename": "helping_us_help_you_8211_how_to_submit_an_actionable_technical_support_case.txt",
    "id": "file-EhtUcyjrzXoUQekoyV2E5t",
    "source": "https://www.visualcrossing.com/resources/documentation/helping-us-help-you-how-to-submit-an-actionable-technical-support-case/",
    "title": "Helping us help you - How to submit an actionable technical support case"
  },
  {
    "filename": "how_to_replace_the_dark_sky_api_using_the_visual_crossing_weather_api.txt",
    "id": "file-2kBL1Yf26ezBh4ioW6psBi",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-replace-the-dark-sky-api-using-the-visual-crossing-timeline-weather-api/",
    "title": "How to replace the Dark Sky API using the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_use_the_timeline_weather_api_to_retrieve_historical_weather_data_and_weather_forecast_data_in_java.txt",
    "id": "file-9GJoXhUJHSnZs37GY99D1Q",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-timeline-weather-api-to-retrieve-historical-weather-data-and-weather-forecast-data-in-java/",
    "title": "How to use the Timeline Weather API to retrieve historical weather data and weather forecast data in Java"
  },
  {
    "filename": "building_and_running_your_first_weather_api_query.txt",
    "id": "file-SuZ79LcU7urBC4DhKiRHE3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/building-and-running-your-first-weather-api-query/",
    "title": "Building and Running your first weather API query"
  },
  {
    "filename": "how_your_data_is_used_within_visual_crossing.txt",
    "id": "file-Ns2K2VAR3RBKi1bpYFnfwF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-your-data-is-used-within-visual-crossing/",
    "title": "How your data is used within Visual Crossing"
  },
  {
    "filename": "did_it_rain_on_a_date.txt",
    "id": "file-QFLEoKBVEsULotgkYxdFY9",
    "source": "https://www.visualcrossing.com/resources/blog/did-it-rain-on-a-date/",
    "title": "Did it rain on a date?"
  },
  {
    "filename": "anchorage_november_snowfall_record_broken_2023_update.txt",
    "id": "file-VjpbTvW6FLBFnjxoRC1aCJ",
    "source": "https://www.visualcrossing.com/resources/blog/alaska-anchorage-breaks-the-november-snow-record-and-major-lake-effect-snow-update/",
    "title": "Anchorage November Snowfall Record Broken: 2023 Update"
  },
  {
    "filename": "celebrate_national_weatherperson_s_day_on_february_5th.txt",
    "id": "file-FBRfEuxfUUPWi1zspobTt5",
    "source": "https://www.visualcrossing.com/resources/blog/celebrate-national-weatherpersons-day-on-february-5th/",
    "title": "Celebrate National Weatherperson\u2019s Day on February 5th"
  },
  {
    "filename": "how_to_use_the_visual_crossing_weather_microsoft_excel_add_in.txt",
    "id": "file-KhBJHxTZj2wAVuTintBiFi",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-use-the-visual-crossing-weather-microsoft-excel-add-in/",
    "title": "How to use the Visual Crossing Weather Microsoft Excel Add-in"
  },
  {
    "filename": "how_we_built_the_winter_energy_calculator.txt",
    "id": "file-GsarV34Akegngds3jBF55M",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-we-built-the-winter-energy-calculator/",
    "title": "How We Built the Winter Energy Calculator"
  },
  {
    "filename": "air_quality_elements_in_the_weather_api.txt",
    "id": "file-2aF97jMDzL6gDwTQcGpKLY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/air-quality-elements-in-the-weather-api/",
    "title": "Air Quality Elements in the Weather API"
  },
  {
    "filename": "how_to_view_usage_details_of_your_account.txt",
    "id": "file-2Btn1BfUjSBWCd39aAYTRv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-view-usage-details-of-your-account/",
    "title": "How to view usage details of your account"
  },
  {
    "filename": "http_error_codes.txt",
    "id": "file-1ANtBHRTbjsbfAmLjixyYV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/http-error-codes/",
    "title": "HTTP Error Codes"
  },
  {
    "filename": "how_to_submit_weather_api_asynchronously.txt",
    "id": "file-EzhkseiM3Ny5Et2TC9YsxY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-submit-weather-api-asynchronously/",
    "title": "How to submit weather API asynchronously"
  },
  {
    "filename": "announcing_expanded_historical_weather_data.txt",
    "id": "file-GpWLVzbQD6wM6eYWXpWq8K",
    "source": "https://www.visualcrossing.com/resources/news/announcing-expanded-historical-weather-data/",
    "title": "Announcing Expanded Historical Weather Data"
  },
  {
    "filename": "how_to_retrieve_the_visual_crossing_api_query_string_when_using_the_web_query_builder_interface.txt",
    "id": "file-PCjghbfVLCFDS6CKmvSwXW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-retrieve-the-visual-crossing-api-query-string-when-using-the-web-query-builder-interface/",
    "title": "How to retrieve the Visual Crossing API Query String when using the Web Query Builder interface"
  },
  {
    "filename": "how_to_use_curl_to_fetch_bulk_weather_data.txt",
    "id": "file-YaCUz8ovMNXJpkkSP2gFPb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-curl-to-fetch-bulk-weather-data/",
    "title": "How to use cURL to fetch bulk weather data"
  },
  {
    "filename": "how_to_replace_the_weather_underground_api.txt",
    "id": "file-Jfoa5CpeK1QiKo6xvuFpyT",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-weather-underground-api/",
    "title": "How to Replace the Weather Underground API?"
  },
  {
    "filename": "how_to_use_cors_with_a_restful_weather_api.txt",
    "id": "file-N73X3De7HLyMnzNEZ24Sto",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-use-cors-with-a-restful-weather-api/",
    "title": "How to use CORS with a RESTful Weather API"
  },
  {
    "filename": "how_to_use_java_to_load_weather_forecast_data.txt",
    "id": "file-EvmA8EY3wWhgKo6uf7BWLN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-fetch-weather-forecast-data-from-a-restful-web-service-in-java/",
    "title": "How to use Java to load weather forecast data"
  },
  {
    "filename": "how_to_retrieve_hail_tornado_wind_damage_and_earthquake_events_in_the_weather_api.txt",
    "id": "file-LsAZGktnK2C1kFv8Wktawe",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-retrieve-hail-tornado-wind-damage-and-earthquakes-events-in-the-weather-api/",
    "title": "How to retrieve hail, tornado, wind damage and earthquake events in the weather API"
  },
  {
    "filename": "academic_student_and_research_discounts_for_weather_data.txt",
    "id": "file-9zcSeRjb6TwEVmqXMyPmFR",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/academic-student-and-research-discounts-for-weather-data/",
    "title": "Academic, student and research discounts for weather data"
  },
  {
    "filename": "how_to_use_python_and_pandas_to_join_historical_weather_data_to_road_accident_data.txt",
    "id": "file-DevaPJ4oJfp9GQu6HBfqKn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-python-and-pandas-to-join-historical-weather-data-to-road-accident-data/",
    "title": "How to use Python and Pandas to join historical weather data to road accident data"
  },
  {
    "filename": "how_to_use_curl_to_download_weather_data.txt",
    "id": "file-38PxNMUkfbVPVtycM5KjmC",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-curl-to-download-weather-data/",
    "title": "How to use cURL to download weather data"
  },
  {
    "filename": "how_to_manage_visual_crossing_weather_data_subscriptions.txt",
    "id": "file-3vwQgUgjogkoaZ3dBhPQH5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-manage-visual-crossing-weather-data-subscriptions/",
    "title": "How to manage Visual Crossing Weather Data Subscriptions"
  },
  {
    "filename": "how_to_schedule_weather_data_queries.txt",
    "id": "file-D4HGsntuQMaZsrPEFmGp2o",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-schedule-weather-data-queries/",
    "title": "How to schedule weather data queries"
  },
  {
    "filename": "how_to_show_weather_data_in_an_outlook_add_in.txt",
    "id": "file-QRu5rSZSzTSDm8UtqBrLwS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-show-weather-data-in-an-outlook-add-in/",
    "title": "How to show weather data in an Outlook add-in"
  },
  {
    "filename": "how_to_obtain_solar_radiation_data.txt",
    "id": "file-3bqNiBDUedTnhfwg3NqChS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-obtain-solar-radiation-data/",
    "title": "How to obtain solar radiation data?"
  },
  {
    "filename": "available_data_for_visual_crossing_weather_8211_updated_december_2020.txt",
    "id": "file-2m5bS7VWZovwFzygBGz5k8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/available-data-for-visual-crossing-weather-updated-january-2020/",
    "title": "Available Data for Visual Crossing Weather - Updated December 2020"
  },
  {
    "filename": "how_to_query_weather_forecasts_from_the_past_8211_historical_forecasts.txt",
    "id": "file-LRo7tpWuBSb8jE39uoYnxi",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-query-weather-forecasts-from-the-past-historical-forecasts/",
    "title": "How to query weather forecasts from the past - Historical Forecasts"
  },
  {
    "filename": "how_to_look_up_weather_by_address.txt",
    "id": "file-ArrUhZheq6NakwRbMUxAkM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-look-up-weather-by-address/",
    "title": "How to look up weather by address"
  },
  {
    "filename": "how_to_make_a_wordpress_plugin_that_uses_shortcodes_to_show_the_weather_forecast.txt",
    "id": "file-Hiqf9Sck3HAteoN6Pq4aBa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-make-a-wordpress-plugin-that-uses-shortcodes-to-show-the-weather-forecast/",
    "title": "How to make a WordPress plugin that uses shortcodes to show the weather forecast"
  },
  {
    "filename": "how_to_look_up_the_current_weather_conditions_in_the_weather_api.txt",
    "id": "file-W6ZAbDVUDE77z6o982woBc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-look-up-the-current-weather-conditions-in-the-weather-api/",
    "title": "How to look up the current weather conditions in the Weather API"
  },
  {
    "filename": "adding_and_removing_elements_from_your_weather_query.txt",
    "id": "file-NuVTFyK3kCwPZ9DoSk4UGd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/adding-and-removing-elements-from-your-weather-query/",
    "title": "Adding and Removing Elements from your Weather Query"
  },
  {
    "filename": "how_to_look_up_weather_by_latitude_and_longitude.txt",
    "id": "file-HVuhKgzieo9xYkpeHGeB92",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-look-up-weather-by-latitude-and-longitude/",
    "title": "How to look up weather by latitude and longitude"
  },
  {
    "filename": "how_to_load_weather_data_into_google_sheets_using_json.txt",
    "id": "file-9CP2rAJLyTyJbdJBTcDnoB",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-load-weather-data-into-google-sheets-using-json/",
    "title": "How To Load Weather Data into Google Sheets using JSON"
  },
  {
    "filename": "how_to_look_up_weather_by_latitude_and_longitude.txt",
    "id": "file-CCL1gbtjbHNPYn4P6JWFFW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-look-up-weather-by-latitude-and-longitude/",
    "title": "How to look up weather by latitude and longitude"
  },
  {
    "filename": "how_to_integrate_weather_data_for_postal_codes_in_the_business_cloud_of_domo.txt",
    "id": "file-CeE4T1wW6ujhfKq2xvictM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-integrate-weather-data-for-postal-codes-in-the-business-cloud-of-domo/",
    "title": "How to integrate weather data for postal codes in The Business Cloud of DOMO."
  },
  {
    "filename": "how_to_look_up_the_current_weather_conditions_in_the_weather_api.txt",
    "id": "file-KB5DV8814sJJXhTHBmV5FV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-look-up-the-current-weather-conditions-in-the-weather-api/",
    "title": "How to look up the current weather conditions in the Weather API"
  },
  {
    "filename": "how_can_i_get_bulk_weather_data.txt",
    "id": "file-EVydKHek3rUPXzqdwsyvdD",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-get-bulk-weather-data/",
    "title": "How can I get bulk weather data?"
  },
  {
    "filename": "how_to_look_up_weather_by_address.txt",
    "id": "file-AEopkyNZq9C4esSZ8dhAXU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-look-up-weather-by-address/",
    "title": "How to look up weather by address"
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_qlik_sense.txt",
    "id": "file-7k1LLmrDUyDu38SEKY8u1c",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-qlik-sense/",
    "title": "How to load weather forecast data into Qlik Sense?"
  },
  {
    "filename": "how_to_load_weather_data_using_python.txt",
    "id": "file-Gj6fCyPovAKF1nuyhrUvTU",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-load-historical-weather-data-using-python-without-scraping/",
    "title": "How to Load Weather Data Using Python?"
  },
  {
    "filename": "how_to_load_weather_data_in_ruby.txt",
    "id": "file-Nb2iFzBvmtv3y3DK352ksU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-ruby/",
    "title": "How to load weather data in Ruby"
  },
  {
    "filename": "how_to_load_weather_data_using_lisp.txt",
    "id": "file-DQzKqKXEENuMsKzUJzS4aX",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-lisp/",
    "title": "How to load weather data using LISP"
  },
  {
    "filename": "does_weather_affect_hunting.txt",
    "id": "file-6NmpuHdkgfV4NdMt8m9mp8",
    "source": "https://www.visualcrossing.com/resources/blog/does-weather-affect-hunting/",
    "title": "Does Weather Affect Hunting?"
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_tibco_spotfire_via_odata_request.txt",
    "id": "file-Em3GuSZmcXKfAFyUyAr5Fw",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-tibco-spotfire-via-odata-request/",
    "title": "How to load weather forecast data into TIBCO Spotfire via ODATA request"
  },
  {
    "filename": "how_to_load_weather_forecast_data_as_a_microsoft_excel_xlsx_file.txt",
    "id": "file-6CrcQVZQ8NgZnknbv4ZhR7",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-as-a-microsoft-excel-xlsx-file/",
    "title": "How to load weather forecast data as a Microsoft Excel XLSX file"
  },
  {
    "filename": "how_does_weather_affect_agriculture.txt",
    "id": "file-MWQJf2UWpjrhqLMYAJYf4k",
    "source": "https://www.visualcrossing.com/resources/blog/how-does-weather-affect-agriculture/",
    "title": "How Does Weather Affect Agriculture"
  },
  {
    "filename": "how_to_load_weather_data_into_information_builders_ibi_webfocus_using_the_rest_api.txt",
    "id": "file-7ExttWsTXrDgPYGRyXcgfZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-data-into-information-builders-ibi-webfocus-using-the-rest-api/",
    "title": "How to load weather data into Information Builders ibi WebFOCUS using the REST API"
  },
  {
    "filename": "how_to_load_weather_data_into_sas_visual_analytics_or_sas_visual_statistics.txt",
    "id": "file-LT6Pu8XdQJ5QsCz6KqW8Fv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-data-into-sas-viya/",
    "title": "How to load weather data into SAS Visual Analytics or SAS Visual Statistics."
  },
  {
    "filename": "how_to_load_weather_forecast_data_into_oracle_analytics_desktop.txt",
    "id": "file-NCfgJ9sgWaSu168mFckPZa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-weather-forecast-data-into-oracle-analytics-desktop/",
    "title": "How to load weather forecast data into Oracle Analytics Desktop"
  },
  {
    "filename": "how_to_include_weather_radar_data_in_weather_datasets.txt",
    "id": "file-6mUV7h8pgxyXVtwdrvoay3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-include-weather-radar-data-in-weather-datasets/",
    "title": "How to Include Weather Radar Data in Weather Datasets"
  },
  {
    "filename": "how_to_load_visual_crossing_weather_data_into_alibaba_cloud_dataworks.txt",
    "id": "file-7EHXYUieQkjcz24Jn1XqUb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-visual-crossing-weather-data-into-alibaba-cloud-dataworks/",
    "title": "How to load Visual Crossing weather data into Alibaba Cloud DataWorks"
  },
  {
    "filename": "how_to_load_weather_data_in_swift.txt",
    "id": "file-4txeKFNXdfRBsLoGcYHvJm",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-swift/",
    "title": "How to load weather data in Swift"
  },
  {
    "filename": "how_to_load_weather_data_into_a_juypter_notebook.txt",
    "id": "file-RTGsQ2gRoy7a4UH2GGBVK2",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-into-a-juypter-notebook/",
    "title": "How to load weather data into a Juypter Notebook"
  },
  {
    "filename": "how_to_load_weather_data_in_php.txt",
    "id": "file-VKffmPt1pD9Fa1bWw3VeNA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-php/",
    "title": "How to load weather data in PHP"
  },
  {
    "filename": "how_to_load_weather_data_into_apache_openoffice_calc.txt",
    "id": "file-8MP77nBnwyMpszQ5H9giMc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-load-weather-data-into-apache-openoffice-calc/",
    "title": "How to load Weather Data into Apache OpenOffice Calc"
  },
  {
    "filename": "how_to_load_weather_data_using_vb_net.txt",
    "id": "file-1pj34BgHHJFVnxFQUhVf5R",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-vb-net/",
    "title": "How to load weather data using VB.net"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_any_database.txt",
    "id": "file-JQPDsyMdf6mT2nuqpZSyqW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-any-database/",
    "title": "How to load historical weather data into any database"
  },
  {
    "filename": "how_to_find_weather_data_for_your_next_data_science_project.txt",
    "id": "file-P5yEKzMuP28tZWrHt3ELQJ",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-weather-data-for-data-science/",
    "title": "How to Find Weather Data for your Next Data Science Project"
  },
  {
    "filename": "how_to_load_weather_data_using_google_s_go_language.txt",
    "id": "file-GFbTKBb65NJuUKVmcdkdSK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-using-googles-go-language/",
    "title": "How to load weather data using Google\u2019s Go language"
  },
  {
    "filename": "how_to_load_weather_data_in_matlab.txt",
    "id": "file-EtoAzptRyHPvGb4jExT3aU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-matlab/",
    "title": "How to load weather data in MATLAB"
  },
  {
    "filename": "how_to_find_weather_data_using_nlp_natural_language_processing.txt",
    "id": "file-QiN1CgznbHN1AygYB7ptVF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-weather-data-using-nlp/",
    "title": "How to find weather data using NLP (Natural Language Processing)"
  },
  {
    "filename": "how_to_load_weather_data_in_javascript_using_fetch_api_jquery_d3_or_node_js.txt",
    "id": "file-SEG7GaTR7Gq74DNAniLhLe",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-javascript/",
    "title": "How to load weather data in JavaScript using Fetch API, jQuery, d3 or node.js"
  },
  {
    "filename": "how_to_import_weather_forecast_data_and_historical_weather_data_into_a_mysql_database.txt",
    "id": "file-Pvu6k8ZVPoNcMmhVW71sFn",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-import-weather-data-into-mysql/",
    "title": "How to Import Weather Forecast Data and Historical Weather Data into a MySQL Database"
  },
  {
    "filename": "how_to_load_historical_weather_data_into_oracle_analytics_desktop.txt",
    "id": "file-T8SqUCZtNYjavjHEajbSJx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-oracle-analytics-desktop/",
    "title": "How to load historical weather data into Oracle Analytics  Desktop?"
  },
  {
    "filename": "how_to_load_weather_data_in_c.txt",
    "id": "file-Fv6aCHGJigv2NazPE1qVBn",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-in-c-sharp/",
    "title": "How to load weather data in C#"
  },
  {
    "filename": "how_to_handle_daylight_savings_in_the_visual_crossing_weather_api.txt",
    "id": "file-Y87wYEiR1XLBKLeMYsNDbo",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-handle-daylight-savings-in-the-visual-crossing-weather-api/",
    "title": "How to Handle Daylight Savings in the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_import_weather_data_into_microsoft_sql_server.txt",
    "id": "file-PshzExDopz1WhujZXbZUwB",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-import-weather-data-into-microsoft-sql-server/",
    "title": "How to import weather data into Microsoft SQL Server"
  },
  {
    "filename": "how_to_i_properly_cite_or_attribute_the_weather_data_in_my_project_to_visual_crossing_weather.txt",
    "id": "file-Km92H4wrRrF1jwi9rchLUM",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-i-properly-cite-or-attribute-the-weather-data-in-my-project-to-visual-crossing-weather/",
    "title": "How to I properly cite or attribute the weather data in my project to Visual Crossing Weather?"
  },
  {
    "filename": "how_do_i_find_old_weather_data.txt",
    "id": "file-JQBQ9MDz38tu3jdyTUjwio",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-old-weather-data/",
    "title": "How do I find old weather data?"
  },
  {
    "filename": "how_to_include_sunrise_sunset_moon_phase_moonrise_and_moonset_data_into_your_api_requests.txt",
    "id": "file-4BiCMqur1cT6vuM4Q3Njis",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-include-sunrise-sunset-and-moon-phase-data-into-your-api-requests/",
    "title": "How to include sunrise, sunset, moon phase, moonrise and moonset data into your API requests"
  },
  {
    "filename": "how_to_download_weather_forecast_data_as_a_microsoft_excel_workbook.txt",
    "id": "file-WvoSq7C1iUNWQMLtDbAMby",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-download-weather-forecast-data-as-a-microsoft-excel-workbook/",
    "title": "How to download weather forecast data as a Microsoft Excel Workbook"
  },
  {
    "filename": "how_to_find_the_typical_weather_conditions_in_a_certain_area.txt",
    "id": "file-62JEwbyAtVLxm5cGEnSXKf",
    "source": "https://www.visualcrossing.com/resources/blog/what-are-the-typical-weather-conditions-in-a-certain-area/",
    "title": "How to Find the Typical Weather Conditions in a Certain Area?"
  },
  {
    "filename": "how_to_create_or_modify_language_files.txt",
    "id": "file-54LWvkrRymsj5P1vamWqBj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-or-modify-language-files/",
    "title": "How to create or modify language files"
  },
  {
    "filename": "how_to_debug_problems_when_running_weather_api_queries_in_code.txt",
    "id": "file-9KSwVX5hZGCmXqbdwdz6FN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-debug-problems-when-running-weather-api-queries-in-code/",
    "title": "How to debug problems when running weather API queries in code"
  },
  {
    "filename": "how_to_find_historical_weather_for_maritime_sea_and_ocean_locations.txt",
    "id": "file-231hgMJGW5dKL3XBiDrCYW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-historical-weather-for-maritime-sea-and-ocean-locations/",
    "title": "How to find historical weather for maritime, sea and ocean locations"
  },
  {
    "filename": "how_to_find_and_manage_your_visual_crossing_weather_api_key.txt",
    "id": "file-Tv42EbNuv69pDP82jbWpLU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-change-your-visual-crossing-weather-api-key/",
    "title": "How to Find and Manage Your Visual Crossing Weather API Key"
  },
  {
    "filename": "how_to_cancel_visual_crossing_weather_data_subscriptions.txt",
    "id": "file-47CjwqNMbiBaQkXzvv2gAi",
    "source": "https://www.visualcrossing.com/resources/documentation/how-to-cancel-visual-crossing-weather-data-subscriptions/",
    "title": "How to cancel Visual Crossing Weather Data Subscriptions"
  },
  {
    "filename": "how_has_technology_changed_weather_forecasting_for_meteorologists.txt",
    "id": "file-BiuksvsMrqoSMZ6t8zZEXn",
    "source": "https://www.visualcrossing.com/resources/blog/how-has-technology-changed-weather-forecasting-for-meteorologists/",
    "title": "How Has Technology Changed Weather Forecasting for Meteorologists?"
  },
  {
    "filename": "how_to_add_weather_data_to_google_sheets_using_a_dynamic_weather_query.txt",
    "id": "file-U1MhxVBkP8WQLQhZWACeRs",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-add-weather-data-to-google-sheets-using-a-dynamic-weather-query/",
    "title": "How to add Weather Data to Google Sheets using a Dynamic Weather Query"
  },
  {
    "filename": "how_to_download_weather_data_for_multiple_locations.txt",
    "id": "file-Chfk9bVNmiWYfdNr1m8JXJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-weather-data-for-multiple-locations/",
    "title": "How to download weather data for multiple locations"
  },
  {
    "filename": "how_to_find_and_use_sub_hourly_historical_weather_data.txt",
    "id": "file-UXSLJi5MWjtNJvzUgRt1qF",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-find-and-use-sub-hourly-historical-weather-data/",
    "title": "How to find and use sub-hourly historical weather data"
  },
  {
    "filename": "how_can_i_find_weather_forecast_data_for_analysis_in_r.txt",
    "id": "file-MprSmBPCHHX4GTJtRzqdBm",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-weather-forecast-data-for-analysis-in-r/",
    "title": "How can I find weather forecast data for analysis in R?"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_microsoft_power_bi.txt",
    "id": "file-WdQ2quAxsMDRPLpEBrFhzg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-microsoft-power-bi/",
    "title": "How can I load weather forecast data into Microsoft Power BI?"
  },
  {
    "filename": "how_historical_weather_data_is_updated.txt",
    "id": "file-N516creRCVLuwbmMHXXKGv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-is-updated/",
    "title": "How historical weather data is updated"
  },
  {
    "filename": "how_to_create_a_weather_chatbot_step_by_step_guide.txt",
    "id": "file-8nv8BL47UuXGwmKPxvRm4Q",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-create-a-weather-chatbot-step-by-step-guide/",
    "title": "How to Create a Weather Chatbot | Step-by-Step Guide"
  },
  {
    "filename": "how_can_i_use_the_visual_crossing_weather_date_chooser_to_jump_to_historical_weather_for_any_time.txt",
    "id": "file-KfgZkcwk8KKneSDuyG9ZPH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-use-the-visual-crossing-weather-date-chooser-to-jump-to-historical-weather-for-any-time/",
    "title": "How can I use the Visual Crossing Weather date chooser to jump to historical weather for any time?"
  },
  {
    "filename": "how_to_add_weather_data_to_sas_visual_data_mining_038_machine_learning.txt",
    "id": "file-1CAzvp7aMFfoGaHhzi9yGZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-sas-visual-data-mining-machine-learning/",
    "title": "How to add Weather Data to SAS Visual Data Mining & Machine Learning"
  },
  {
    "filename": "how_to_add_weather_forecast_data_into_microsoft_planner.txt",
    "id": "file-G4vkwBhAVRuFXD42fXpTz7",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-forecast-data-into-microsoft-planner/",
    "title": "How to add weather forecast data into Microsoft Planner"
  },
  {
    "filename": "how_to_build_a_weather_app.txt",
    "id": "file-Wgx4g84jMhwtgMFz5pvTA4",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-building-a-weather-app/",
    "title": "How to Build a Weather App?"
  },
  {
    "filename": "how_to_add_free_weather_information_to_an_evernote_notebook.txt",
    "id": "file-EfPJ1s6W11LEGmo5NPTs1r",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-an-evernote-notebook/",
    "title": "How to add free weather information to an Evernote notebook"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_microsoft_power_bi.txt",
    "id": "file-Q5suAuM9tVgZrdrkmMXbqh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-microsoft-power-bi/",
    "title": "How can I load historical weather data into Microsoft Power BI?"
  },
  {
    "filename": "celebrate_national_weatherperson_s_day_on_february_5th.txt",
    "id": "file-UdHvJckaVfsLaz5kESBQcQ",
    "source": "https://www.visualcrossing.com/resources/blog/celebrate-national-weatherpersons-day-on-february-5th/",
    "title": "Celebrate National Weatherperson\u2019s Day on February 5th"
  },
  {
    "filename": "how_to_find_a_weather_api_for_your_hackathon.txt",
    "id": "file-FxYY5VFdoAzaXq2dsc2oJL",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-find-a-weather-api-for-your-hackathon/",
    "title": "How to find a Weather API for your hackathon"
  },
  {
    "filename": "how_to_download_the_weather_forecast_for_all_us_zip_codes.txt",
    "id": "file-BUnLnvvUVDV8qBZs6B1HhK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-the-weather-forecast-for-all-us-zip-codes/",
    "title": "How to download the weather forecast for all US ZIP Codes"
  },
  {
    "filename": "how_to_find_accurate_snow_weather_data.txt",
    "id": "file-RwLuFWrEA6D5AWoxVevvgu",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-find-accurate-snow-weather-data/",
    "title": "How to find accurate snow weather data"
  },
  {
    "filename": "how_to_create_annual_or_monthly_climate_summaries_and_normals_for_a_location.txt",
    "id": "file-Xb6Pwu4dB8dMNMsGWvBwqh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-create-annual-or-monthly-climate-summaries-and-normals-for-a-location/",
    "title": "How to create annual or monthly climate summaries and normals for a location"
  },
  {
    "filename": "how_to_create_a_raspberry_pi_frost_alert_using_a_weather_api.txt",
    "id": "file-D3pbzJqWRkM612cz1nC5CW",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-create-a-raspberry-pi-frost-alert-using-a-weather-api/",
    "title": "How to create a Raspberry PI frost alert using a weather api"
  },
  {
    "filename": "how_to_automatically_refresh_weather_data_in_microsoft_excel.txt",
    "id": "file-VkABQyMiG6PNREKPtFPU1Z",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-automatically-refresh-weather-data-in-microsoft-excel/",
    "title": "How to automatically refresh Weather Data in Microsoft Excel"
  },
  {
    "filename": "how_to_build_an_artificially_intelligent_chatbot_using_the_microsoft_bot_framework_and_the_visual_crossing_weather_api.txt",
    "id": "file-Teeijbu4w4XbvpK15ZafJB",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-build-an-artificially-intelligent-chatbot-using-the-microsoft-bot-framework-and-the-visual-crossing-weather-api/",
    "title": "How to Build an Artificially Intelligent Chatbot using the Microsoft Bot Framework and the Visual Crossing Weather API"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_tibco_spotfire_via_odata_request.txt",
    "id": "file-1er18FG9CDXwLhtdwBPGnN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-tibco-spotfire-via-odata-request/",
    "title": "How to add historical weather data to TIBCO Spotfire  via ODATA request"
  },
  {
    "filename": "how_do_i_run_a_weather_api_query_using_http_post.txt",
    "id": "file-K8ZdVki9rhnaCsfh6fJkRU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-run-a-weather-api-query-using-http-post/",
    "title": "How do I run a weather API query using HTTP POST?"
  },
  {
    "filename": "how_do_i_load_weather_history_data_into_a_pivot_table.txt",
    "id": "file-BigwJqEq7ShbYaqEDvsHFT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-do-i-load-weather-history-data-into-a-pivot-table/",
    "title": "How do I load Weather History data into a Pivot Table?"
  },
  {
    "filename": "how_do_i_retrieve_weather_data_using_an_odata_request.txt",
    "id": "file-L1XwFW1NCs57cAXAmW1mNj",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-retrieve-weather-data-using-an-odata-request/",
    "title": "How do I retrieve weather data using an ODATA request?"
  },
  {
    "filename": "how_do_i_find_the_best_long_range_weather_forecast.txt",
    "id": "file-HRt8y7jLJC32GEGrDFdkFJ",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-find-the-best-long-range-weather-forecast/",
    "title": "How do I find the best long range Weather Forecast?"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_word.txt",
    "id": "file-EU7wpU13Pm3kHEXYpZU8QF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-word/",
    "title": "How do I add weather data into Microsoft Word?"
  },
  {
    "filename": "how_do_i_add_the_weather_forecast_to_my_web_page.txt",
    "id": "file-Grx6WYRLZZnt2iUB3S43Qr",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-add-weather-forecast-to-my-webpage/",
    "title": "How do I add the weather forecast to my web page?"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_google_sheets.txt",
    "id": "file-4XBoGf7Qy4F4dpcZNkLLjg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-weather-forecast-data-into-google-sheets/",
    "title": "How can I load weather forecast data into Google Sheets?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_using_google_apps_script.txt",
    "id": "file-7TBK2jH2XPG17rRCXnhFQa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-can-i-load-historical-weather-data-using-google-apps-script/",
    "title": "How can I load historical weather data using Google Apps Script?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_tableau_desktop.txt",
    "id": "file-CRU5FDEMShzjiiD3VszjGJ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-tableau-desktop/",
    "title": "How Can I Load Historical Weather Data into Tableau Desktop?"
  },
  {
    "filename": "degree_days_weather_api.txt",
    "id": "file-MDrTHA6rH7jDgeJ6vnHco1",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/degree-day-weather-api/",
    "title": "Degree Days Weather API"
  },
  {
    "filename": "how_can_i_download_weather_forecast_data_as_a_csv_file.txt",
    "id": "file-Lq9f5CA3AJbpwb2mUX93nP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-forecast-data-as-a-csv-file/",
    "title": "How can I download weather forecast data as a CSV file?"
  },
  {
    "filename": "get_free_weather_data_with_our_weather_data_ambassadors_program.txt",
    "id": "file-Di3syBHwVLqBDowTs1HCqb",
    "source": "https://www.visualcrossing.com/resources/news/free-weather-data-ambassadors-program/",
    "title": "Get Free Weather Data with our Weather Data Ambassadors Program"
  },
  {
    "filename": "introduction_to_weather_statistics_and_analysis.txt",
    "id": "file-6vxTCEqajdvpi1R5D915Lw",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/introduction-to-weather-statistics-and-analysis/",
    "title": "Introduction to Weather Statistics and Analysis"
  },
  {
    "filename": "frequently_asked_questions_faq_for_visual_crossing_weather_data.txt",
    "id": "file-1wQ3FUDHV4TCWdtUoukKze",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/frequently-asked-questions-faq-for-visual-crossing-weather-data/",
    "title": "Frequently Asked Questions (FAQ) for Visual Crossing Weather Data"
  },
  {
    "filename": "how_to_add_free_weather_information_to_your_kanban_board_in_leankit_planview.txt",
    "id": "file-KndiwFBbhTfwu2un8x5ZNQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-free-weather-information-to-your-kanban-board-in-leankit-planview/",
    "title": "How to add free weather information to your Kanban board in  LeanKit planview."
  },
  {
    "filename": "how_do_i_get_free_weather_api_access.txt",
    "id": "file-Q7X8qDywbT3WCMgstB7doD",
    "source": "https://www.visualcrossing.com/resources/blog/how-do-i-get-free-weather-api-access/",
    "title": "How do I get free weather API access?"
  },
  {
    "filename": "how_can_i_replace_the_dark_sky_api.txt",
    "id": "file-XZQUEQEQAbnZ9N9TkzPec3",
    "source": "https://www.visualcrossing.com/resources/news/how-can-i-replace-the-darksky-api/",
    "title": "How can I replace the Dark Sky API?"
  },
  {
    "filename": "energy_sources_affected_by_the_weather.txt",
    "id": "file-23esste6SFE8EdEhKqJvz6",
    "source": "https://www.visualcrossing.com/resources/blog/energy-sources-affected-by-the-weather/",
    "title": "Energy Sources Affected by the Weather"
  },
  {
    "filename": "how_do_i_add_weather_data_into_microsoft_powerpoint.txt",
    "id": "file-FwQRKT5gHdJ9Kmv4cLpPoC",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-add-weather-data-into-microsoft-powerpoint/",
    "title": "How do I add weather data into Microsoft PowerPoint?"
  },
  {
    "filename": "how_to_build_a_great_weather_dashboard.txt",
    "id": "file-Wt6u8H8uViqeyedThAzNDD",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-build-a-great-weather-dashboard/",
    "title": "How to build a great Weather Dashboard"
  },
  {
    "filename": "how_to_add_weather_data_to_a_node_js_app_using_a_weather_api_and_javascript.txt",
    "id": "file-PU7x7FeLi3YtbhYDcabuYt",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-add-weather-data-to-a-node-js-app-using-a-weather-api-and-javascript/",
    "title": "How to add weather data to a Node.js app using a Weather API and JavaScript"
  },
  {
    "filename": "how_cold_did_it_get_in_texas.txt",
    "id": "file-CmcGxuy3vYktFRMvW4UQKn",
    "source": "https://www.visualcrossing.com/resources/blog/how-cold-did-it-get-in-texas/",
    "title": "How cold did it get in Texas?"
  },
  {
    "filename": "how_do_i_get_started_with_the_weather_api.txt",
    "id": "file-UxnEdU2Z7s4yDKXcZdBAWi",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-do-i-get-started-with-the-weather-api/",
    "title": "How do I get started with the Weather API?"
  },
  {
    "filename": "how_does_the_wind_blow.txt",
    "id": "file-WtLeXaDDP4ZwpwGdrKYU79",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/how-does-the-wind-blow/",
    "title": "How does the wind blow?"
  },
  {
    "filename": "how_historical_weather_data_records_are_created_from_local_weather_station_observations.txt",
    "id": "file-KQSDWSAss9v63d5bthHxbP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-historical-weather-data-records-are-created-from-local-weather-station-observations/",
    "title": "How Historical Weather Data Records are Created from Local Weather Station Observations"
  },
  {
    "filename": "how_can_i_find_past_weather_information_for_my_insurance_claim.txt",
    "id": "file-QL1u6xYQ8BHJcvBPV8EeH3",
    "source": "https://www.visualcrossing.com/resources/blog/how-can-i-find-past-weather-information-for-my-insurance-claim/",
    "title": "How can I find past weather information for my insurance claim?"
  },
  {
    "filename": "how_to_add_historical_weather_data_to_qlik_sense.txt",
    "id": "file-7pqkTKtfcrmiXbGBaPLWkm",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-historical-weather-data-to-qlik-sense/",
    "title": "How to add historical weather data to Qlik Sense"
  },
  {
    "filename": "finding_historical_weather_data_for_remote_locations.txt",
    "id": "file-XbuVMTvWEM5PvRKYvsWABE",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/finding-historical-weather-data-for-remote-locations/",
    "title": "Finding historical weather data for remote locations"
  },
  {
    "filename": "where_can_you_find_high_quality_historical_weather_data_at_a_low_cost.txt",
    "id": "file-Bppe6Re1bDqCVRKp21wAZz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-you-find-high-quality-historical-weather-data-at-a-low-cost/",
    "title": "Where can you find high quality Historical Weather Data at a low cost?"
  },
  {
    "filename": "where_can_i_find_historical_temperature_data.txt",
    "id": "file-CWJwZYGKwSeXLEHn6hbort",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-temperature-data/",
    "title": "Where can I find historical temperature data?"
  },
  {
    "filename": "how_can_i_download_weather_history_data_as_a_csv_file.txt",
    "id": "file-UR27WZxeCzyY7vLK5WS6WV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-download-weather-history-data-as-a-csv-file/",
    "title": "How can I download weather history data as a CSV file?"
  },
  {
    "filename": "getting_started_with_weather_data_services.txt",
    "id": "file-RYj1zDomfanam7P5xMVbCF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-weather-data-services/",
    "title": "Getting Started With Weather Data Services"
  },
  {
    "filename": "world_meteorological_day_2025.txt",
    "id": "file-DMf2tiLrMNYnJEFUc8b28V",
    "source": "https://www.visualcrossing.com/resources/blog/world-meteorological-day-celebrating-science-awareness/",
    "title": "World Meteorological Day 2025"
  },
  {
    "filename": "how_do_i_find_my_nearest_weather_station.txt",
    "id": "file-SuHS9E4okVdDgZZ5xaEAhC",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-find-my-nearest-weather-station/",
    "title": "How do I find my nearest weather station?"
  },
  {
    "filename": "how_can_i_load_historical_weather_data_into_google_sheets.txt",
    "id": "file-MEM6kb41WvtfiMUhKEkY7Z",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-load-historical-weather-data-into-google-sheets/",
    "title": "How can I load historical weather data into Google Sheets?"
  },
  {
    "filename": "where_does_the_weather_get_energy.txt",
    "id": "file-363ijo9gtLrZP5Y1x4nWUE",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/where-does-the-weather-get-energy/",
    "title": "Where does the weather get energy?"
  },
  {
    "filename": "why_do_weather_systems_typically_move_from_west_to_east.txt",
    "id": "file-4hvLyZgQgpMrwqXfkxkJk6",
    "source": "https://www.visualcrossing.com/resources/blog/why-weather-systems-move-from-west-to-east/",
    "title": "Why Do Weather Systems Typically Move from West to East?"
  },
  {
    "filename": "helping_us_help_you_8211_how_to_submit_an_actionable_technical_support_case.txt",
    "id": "file-SW5NBKtUqJQcrrYFjY16mL",
    "source": "https://www.visualcrossing.com/resources/documentation/helping-us-help-you-how-to-submit-an-actionable-technical-support-case/",
    "title": "Helping us help you - How to submit an actionable technical support case"
  },
  {
    "filename": "how_can_i_find_the_average_temperature.txt",
    "id": "file-AAc7w4sBCpVcNep87ewc3U",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-can-i-find-the-average-temperature/",
    "title": "How can I find the Average Temperature?"
  },
  {
    "filename": "where_can_i_find_historical_wind_data.txt",
    "id": "file-WB8Y15kSLYjUbTagrJrDWz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-wind-data/",
    "title": "Where can I find historical wind data?"
  },
  {
    "filename": "where_can_i_find_historical_rainfall_data.txt",
    "id": "file-5y5ayV7mn57SewAPYU59oD",
    "source": "https://www.visualcrossing.com/resources/blog/where-can-i-find-historical-rainfall-data/",
    "title": "Where can I find historical rainfall data?"
  },
  {
    "filename": "how_to_add_weather_data_to_your_microstrategy_project.txt",
    "id": "file-8PYdFdEcR2H8gpSsjcuQBV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-add-weather-data-to-your-microstrategy-project/",
    "title": "How to add Weather Data to your MicroStrategy project"
  },
  {
    "filename": "where_can_i_find_historical_precipitation_data.txt",
    "id": "file-MjJkkpX5BA3BikCygaRp4R",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/where-can-i-find-historical-precipitation-data/",
    "title": "Where can I find historical precipitation data?"
  },
  {
    "filename": "how_are_weather_metrics_calculated_over_various_time_periods_in_different_weather_queries.txt",
    "id": "file-TqKEqYSAQ7w3m5rnJahQrF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-are-weather-metrics-calculated-over-various-time-periods-in-different-weather-queries/",
    "title": "How are weather metrics calculated over various time periods in different weather queries?"
  },
  {
    "filename": "what_was_the_temperature_on_a_date.txt",
    "id": "file-RLyW3ydRfrSSHovgpxiUu4",
    "source": "https://www.visualcrossing.com/resources/blog/what-was-the-temperature-on-a-date/",
    "title": "What was the temperature on a date?"
  },
  {
    "filename": "where_can_i_find_historical_humidity_data.txt",
    "id": "file-3WHAygiVZKHKapWcFnSYwV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-humidity-data/",
    "title": "Where can I find historical humidity data?"
  },
  {
    "filename": "what_weather_cancels_flights.txt",
    "id": "file-PQQKtAVKP3P5JzeqCpnvhy",
    "source": "https://www.visualcrossing.com/resources/blog/what-weather-cancels-flights/",
    "title": "What Weather Cancels Flights"
  },
  {
    "filename": "where_can_i_find_historical_heat_index_and_wind_chill_data.txt",
    "id": "file-5EXoNPZsNy4ugmtyEkTKLe",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-heat-index-and-wind-chill-data/",
    "title": "Where can I find historical heat index and wind chill data?"
  },
  {
    "filename": "what_will_my_weather_data_cost.txt",
    "id": "file-WobMdoTfGcsEFVGwzkDKNn",
    "source": "https://www.visualcrossing.com/resources/blog/what-will-my-weather-data-cost/",
    "title": "What will my weather data cost?"
  },
  {
    "filename": "where_can_i_find_historical_cloud_and_visibility_data.txt",
    "id": "file-B3sagDawUQavuL86LiP2yT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/where-can-i-find-historical-cloud-and-visibility-data/",
    "title": "Where can I find historical cloud and visibility data?"
  },
  {
    "filename": "what_was_the_weather_on_a_certain_date.txt",
    "id": "file-RuMwLFBkFT5iJMQF2YNBEe",
    "source": "https://www.visualcrossing.com/resources/blog/what-was-the-weather-on-a-certain-date/",
    "title": "What was the Weather on a Certain Date?"
  },
  {
    "filename": "what_is_the_typical_weather_for_universal_studios.txt",
    "id": "file-KWMpugr6DpT6BjPrTo84vo",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-the-typical-weather-for-universal-studios/",
    "title": "What is the Typical Weather for Universal Studios?"
  },
  {
    "filename": "construction_management_using_weather_workbook.txt",
    "id": "file-2hL7wUHDzNL4zRRxwsb5hP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/construction-weather-management-workbook/",
    "title": "Construction Management using Weather Workbook"
  },
  {
    "filename": "what_is_a_weather_api.txt",
    "id": "file-NZHbkjW87XJjWmW7PBvHuY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/what-is-a-weather-api/",
    "title": "What is a Weather API?"
  },
  {
    "filename": "what_is_the_querycost_parameter.txt",
    "id": "file-BvYePLtYc2EDEqncC3QYxg",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/what-is-the-querycost-parameter/",
    "title": "What is the queryCost parameter?"
  },
  {
    "filename": "what_is_the_difference_between_rain_sleet_snow_and_ice_precipitation_types.txt",
    "id": "file-5picJV6GjDdL7FB1TVzKJS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-is-the-difference-between-rain-sleet-snow-and-ice-precipitation-types/",
    "title": "What is the difference between rain, sleet, snow and ice precipitation types?"
  },
  {
    "filename": "what_is_the_cause_of_8220_maximum_concurrent_jobs_has_been_exceeded_8221_http_response_429.txt",
    "id": "file-KHzLesb3XK53jeEYZA87fS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/what-is-the-cause-of-maximum-concurrent-jobs-has-been-exceeded-http-response-429/",
    "title": "What is the cause of 'Maximum concurrent jobs has been exceeded', HTTP response 429"
  },
  {
    "filename": "what_is_the_difference_between_temperature_heat_index_wind_chill_feels_like_temperature_apparent_temperature_and_realfeel_temperature.txt",
    "id": "file-MefqH84yrFsHSrt4tP14AV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/what-is-the-difference-between-temperature-heat-index-wind-chill-feels-like-temperature-apparent-temperature-and-realfeel-temperature/",
    "title": "What is the difference between temperature, heat index, wind chill, feels like temperature, apparent temperature and RealFeel Temperature?"
  },
  {
    "filename": "anchorage_november_snowfall_record_broken_2023_update.txt",
    "id": "file-U1HM4C6XsHet18NVpd3NqF",
    "source": "https://www.visualcrossing.com/resources/blog/alaska-anchorage-breaks-the-november-snow-record-and-major-lake-effect-snow-update/",
    "title": "Anchorage November Snowfall Record Broken: 2023 Update"
  },
  {
    "filename": "how_can_i_load_weather_forecast_data_into_tableau_desktop.txt",
    "id": "file-Gs2UxK5cXvNebgUfwzP9g8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-do-i-load-weather-forecast-data-into-tableau-desktop/",
    "title": "How Can I Load Weather Forecast Data into Tableau Desktop?"
  },
  {
    "filename": "how_do_i_create_daily_statistics_for_historical_weather_summaries_and_climate_reports.txt",
    "id": "file-2FMtzyDKnyq7kDuPswgSE9",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-do-i-create-daily-statistics-for-historical-weather-summaries-and-climate-reports/",
    "title": "How do I create daily statistics for historical weather summaries and climate reports?"
  },
  {
    "filename": "what_industries_rely_on_visual_crossing_weather_data.txt",
    "id": "file-FWYE2wfgsMnzSpXZf44s79",
    "source": "https://www.visualcrossing.com/resources/blog/what-industries-rely-on-visual-crossing-weather-data/",
    "title": "What industries rely on Visual Crossing Weather data?"
  },
  {
    "filename": "what_is_kwhth_or_kwhe_and_why_does_the_difference_matter.txt",
    "id": "file-5kKmZCrNHWwsKP263KhCiD",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-a-kwhth-kwhe-or-kilowatt-hour-thermal/",
    "title": "What Is kWhth or kWhe and Why Does the Difference Matter?"
  },
  {
    "filename": "what_historical_weather_measures_are_available.txt",
    "id": "file-9tSqNaMC9ZXCXYeA7sea3J",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-historical-weather-measures-are-available/",
    "title": "What historical weather measures are available?"
  },
  {
    "filename": "what_forecast_weather_measures_are_available.txt",
    "id": "file-A2bzAYzoFdpkva3URu7A77",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-forecast-weather-measures-are-available/",
    "title": "What forecast weather measures are available?"
  },
  {
    "filename": "getting_started_with_logistics_and_delivery_weather.txt",
    "id": "file-MXA7peCGTjR3E3hUkzwAx3",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/getting-started-with-shipment-weather/",
    "title": "Getting Started With Logistics and Delivery Weather"
  },
  {
    "filename": "best_practices_for_segmenting_your_weather_queries.txt",
    "id": "file-5jPbzAiP19xxgzKC5XWYXH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/best-practices-for-segmenting-your-weather-queries/",
    "title": "Best practices for segmenting your weather queries"
  },
  {
    "filename": "what_exactly_is_a_weather_record.txt",
    "id": "file-NTG5sC2bC9C5w1pv8qFJSK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/what-exactly-is-a-weather-record/",
    "title": "What exactly is a weather record?"
  },
  {
    "filename": "how_do_we_create_our_weather_forecast.txt",
    "id": "file-8BwmQBKhGHKjcX4G1sYR7V",
    "source": "https://www.visualcrossing.com/resources/documentation/how-do-we-create-our-weather-forecast/",
    "title": "How do we create our weather forecast?"
  },
  {
    "filename": "http_error_codes.txt",
    "id": "file-LgEueTeBNr4TEMfoPNRByQ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/http-error-codes/",
    "title": "HTTP Error Codes"
  },
  {
    "filename": "what_are_frost_quakes_and_cryoseisms.txt",
    "id": "file-V64dz16AJaSWctyqiaqNcs",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-frost-quakes-and-cryoseisms/",
    "title": "What are Frost Quakes and Cryoseisms?"
  },
  {
    "filename": "bulk_weather_alerts_api.txt",
    "id": "file-TCgt5KQtYb583xfs8YXSbq",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-alerts-api/",
    "title": "Bulk Weather Alerts API"
  },
  {
    "filename": "announcing_expanded_historical_weather_data.txt",
    "id": "file-PJoiH45JLKhqGsCCHaz4YW",
    "source": "https://www.visualcrossing.com/resources/news/announcing-expanded-historical-weather-data/",
    "title": "Announcing Expanded Historical Weather Data"
  },
  {
    "filename": "add_location_and_date_time_filters_to_odata_weather_data_requests.txt",
    "id": "file-XnKP1F6CqPxL8krFamQwFS",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/add-location-and-date-time-filters-to-odata-weather-data-requests/",
    "title": "Add location and date time filters to ODATA weather data requests"
  },
  {
    "filename": "what_are_degree_days_038_how_to_use_them.txt",
    "id": "file-Dts36KtH2DsgaeegT26bs8",
    "source": "https://www.visualcrossing.com/resources/blog/degree-days/",
    "title": "What Are Degree Days & How to Use Them?"
  },
  {
    "filename": "weather_workbook_for_excel_8211_customization.txt",
    "id": "file-2icjjYLBiqfgY2fsf9S54g",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/weather-workbook-for-excel-customization/",
    "title": "Weather Workbook for Excel - Customization"
  },
  {
    "filename": "how_we_built_the_winter_energy_calculator.txt",
    "id": "file-8VRc4kHqaubdx4SqwZJJBh",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-we-built-the-winter-energy-calculator/",
    "title": "How We Built the Winter Energy Calculator"
  },
  {
    "filename": "help_i_can_8217_t_log_in_to_visual_crossing_weather.txt",
    "id": "file-PozuUg3v7jnpCvGRhGP9W5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/help-i-cant-log-in-to-visual-crossing-weather/",
    "title": "Help!  I can't log in to Visual Crossing Weather!"
  },
  {
    "filename": "weather_api_documentation_legacy_endpoints.txt",
    "id": "file-EcUERFpaAFZs8V3K8mbfna",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-api-documentation/",
    "title": "Weather API Documentation (Legacy endpoints)"
  },
  {
    "filename": "weather_data_documentation.txt",
    "id": "file-6B42g4F5xHBPd5MFaRTdHx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-data-documentation/",
    "title": "Weather Data Documentation"
  },
  {
    "filename": "weather_widget_install_guide.txt",
    "id": "file-PjGGxWDYMXD7YccbggeNT7",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/weather-widget-install-guide/",
    "title": "Weather Widget Install Guide"
  },
  {
    "filename": "visual_crossing_weather_data_availability_guide.txt",
    "id": "file-MNknhXT6SUCpUnpBQKBjHw",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/visual-crossing-weather-data-availability-guide/",
    "title": "Visual Crossing Weather Data Availability Guide"
  },
  {
    "filename": "weather_alerts_for_excel.txt",
    "id": "file-BsuCseB7E7k6igUvDnz8pz",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/weather-alerts-for-excel/",
    "title": "Weather Alerts for Excel"
  },
  {
    "filename": "calculating_chill_hours_for_fruit_plants_and_trees.txt",
    "id": "file-F8s9sE87WaQ3NQReJdAYXG",
    "source": "https://www.visualcrossing.com/resources/blog/calculating-chill-hours-for-fruit-plants-and-trees/",
    "title": "Calculating Chill Hours for Fruit Plants and Trees"
  },
  {
    "filename": "weather_dependent_industries.txt",
    "id": "file-YZiZyBdkjyNgVp6NbecPDg",
    "source": "https://www.visualcrossing.com/resources/blog/weather-dependent-industries/",
    "title": "Weather-Dependent Industries"
  },
  {
    "filename": "replacing_the_yahoo_weather_api.txt",
    "id": "file-94zW9Sgjk2ES7mVq63k3wC",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-yahoo-weather-api/",
    "title": "Replacing the Yahoo Weather API"
  },
  {
    "filename": "free_weather_tools_and_dashboards.txt",
    "id": "file-L3QvEV1kcM3P8ZKwnBZwLt",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/free-weather-tools-and-dashboards/",
    "title": "Free Weather Tools and Dashboards"
  },
  {
    "filename": "weather_api_changelog.txt",
    "id": "file-8naMVVkLfz8XGDSGNhFrtR",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-api-changelog/",
    "title": "Weather API Changelog"
  },
  {
    "filename": "weather_usage_in_home_automation_domotics.txt",
    "id": "file-5S33T4zLfsFJaKzfToSUes",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/weather-usage-in-home-automation-domotics/",
    "title": "Weather usage in home automation / domotics"
  },
  {
    "filename": "weather_data_and_weather_apis_for_nonprofit_organizations.txt",
    "id": "file-Eghhj2Au1EezcEPVyccnQd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-data-and-weather-apis-for-nonprofit-organizations/",
    "title": "Weather Data and Weather APIs for Nonprofit Organizations"
  },
  {
    "filename": "using_the_time_period_parameter_to_specify_dynamic_dates_for_weather_api_requests.txt",
    "id": "file-SScHDgedDQFhmcBkhwqsTZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/using-the-time-period-parameter-to-specify-dynamic-dates-for-weather-api-requests/",
    "title": "Using the time period parameter to specify dynamic dates for Weather API requests"
  },
  {
    "filename": "the_role_of_ai_tools_in_weather_forecasting.txt",
    "id": "file-QkxsYB1GZ6Y5pHbCuRfSPu",
    "source": "https://www.visualcrossing.com/resources/blog/the-role-of-ai-tools-in-weather-forecasting/",
    "title": "The Role of AI Tools in Weather Forecasting"
  },
  {
    "filename": "weather_alerts.txt",
    "id": "file-NGPB2gWCrbdRjSL6yk9XyU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-alerts/",
    "title": "Weather Alerts"
  },
  {
    "filename": "comparing_the_visual_crossing_pricing_options_to_dark_sky.txt",
    "id": "file-9sCwYgm6qMc6SxGBoDyNeP",
    "source": "https://www.visualcrossing.com/resources/documentation/comparing-the-visual-crossing-pricing-options-to-dark-sky/",
    "title": "Comparing the Visual Crossing Pricing Options to Dark Sky"
  },
  {
    "filename": "weather_unit_conversion_in_microsoft_excel.txt",
    "id": "file-KU7h75KZxp9WAZovgfHxqN",
    "source": "https://www.visualcrossing.com/resources/blog/weather-unit-conversion-in-microsoft-excel/",
    "title": "Weather unit conversion in Microsoft Excel"
  },
  {
    "filename": "parameter_based_web_queries_in_excel.txt",
    "id": "file-2DVGaLQr7BoeVyHwAkLUAK",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/parameter-based-web-queries-in-excel/",
    "title": "Parameter Based, Web Queries in Excel"
  },
  {
    "filename": "visual_crossing_weather_extensions.txt",
    "id": "file-HyFFvjUbVDm1kJ3AS4acQL",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/visual-crossing-weather-extensions/",
    "title": "Visual Crossing Weather Extensions"
  },
  {
    "filename": "weather_forecast_widget_implementation_guide.txt",
    "id": "file-Wes47nw85YexWUzpyKPfTi",
    "source": "https://www.visualcrossing.com/resources/documentation/widgets/weather-forecast-widget-implementation-guide/",
    "title": "Weather Forecast Widget Implementation Guide"
  },
  {
    "filename": "multi_site_forecast_workbook_for_excel.txt",
    "id": "file-6kSpFafrM9r53vqx5Te5RT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/multi-site-weather-forecast-excel-workbook/",
    "title": "Multi-site Forecast Workbook for Excel"
  },
  {
    "filename": "understanding_the_8220_fair_use_8221_system_in_visual_crossing_weather.txt",
    "id": "file-Vbrr97XGRitqm79cn7zbMv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/understanding-the-fair-use-system-in-visual-crossing-weather/",
    "title": "Understanding the 'fair use' system in Visual Crossing Weather"
  },
  {
    "filename": "understanding_and_optimizing_the_visual_crossing_weather_pay_as_you_go_plan.txt",
    "id": "file-VhyUyTzYgrwSJA1U795cLF",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/understanding-and-optimizing-the-visual-crossing-weather-pay-as-you-go-plan/",
    "title": "Understanding and optimizing the Visual Crossing Weather Pay-as-you-go plan"
  },
  {
    "filename": "invoice_and_billing_questions.txt",
    "id": "file-PGF3WwdhxEnv5AgaHLzyJZ",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/invoice-and-billing-questions/",
    "title": "Invoice and billing questions"
  },
  {
    "filename": "announcing_our_free_weather_api_plan.txt",
    "id": "file-AdS74Myk2wDX9pLw9WVuSE",
    "source": "https://www.visualcrossing.com/resources/news/announcing-our-free-weather-api-plan/",
    "title": "Announcing our free Weather API Plan"
  },
  {
    "filename": "did_it_rain_on_a_date.txt",
    "id": "file-P4hXBnScR2wWjsKzWiwDPB",
    "source": "https://www.visualcrossing.com/resources/blog/did-it-rain-on-a-date/",
    "title": "Did it rain on a date?"
  },
  {
    "filename": "weather_data_visualization.txt",
    "id": "file-DsBaVD8Aj9cjUykJYF11mJ",
    "source": "https://www.visualcrossing.com/resources/blog/weather-data-visualization/",
    "title": "Weather Data Visualization"
  },
  {
    "filename": "using_microsoft_excel_to_analyze_gardening_weather_and_climate_8211_part_1.txt",
    "id": "file-GvoR1bV6PF9itPdyih73DG",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/using-microsoft-excel-to-analyze-gardening-weather-and-climate/",
    "title": "Using Microsoft Excel to Analyze Gardening Weather and Climate - Part 1"
  },
  {
    "filename": "weather_api_json_result_structure.txt",
    "id": "file-Nn87pZqePT2dMxnWGk6L9E",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-api-json-result-structure/",
    "title": "Weather API JSON result structure"
  },
  {
    "filename": "weather_data_sources_and_attribution.txt",
    "id": "file-MmkiQSggRW4kaxUSNnztMb",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/weather-data-sources-and-attribution/",
    "title": "Weather data sources and attribution"
  },
  {
    "filename": "date_and_times_in_the_weather_api.txt",
    "id": "file-UrTYxRYaLUmViP2A3hENBG",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/date-and-times-in-the-weather-api/",
    "title": "Date and Times in the Weather API"
  },
  {
    "filename": "setting_the_location_source_for_the_visual_crossing_weather_add_in.txt",
    "id": "file-FznV6sZqkNv71PJ4C5ZnhT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/setting-the-location-source-for-the-visual-crossing-weather-add-in/",
    "title": "Setting the Location Source for the Visual Crossing Weather Add-in"
  },
  {
    "filename": "degree_day_calculator_for_microsoft_excel.txt",
    "id": "file-MaSmztiAK1YZzoA9eGJyek",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/degree-day-calculator/",
    "title": "Degree Day Calculator for Microsoft Excel"
  },
  {
    "filename": "building_and_running_your_first_weather_api_query.txt",
    "id": "file-7XBCJcp4mSYqS1Uw1FoXWV",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/building-and-running-your-first-weather-api-query/",
    "title": "Building and Running your first weather API query"
  },
  {
    "filename": "defining_the_icon_set_parameter_in_the_weather_api.txt",
    "id": "file-QGfeH9wEHSncpcg1YBEBAA",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/defining-icon-set-in-the-weather-api/",
    "title": "Defining the icon set parameter in the Weather API"
  },
  {
    "filename": "bulk_weather_data_in_visual_crossing.txt",
    "id": "file-8NsoVDepNE7nLVxxTjN1KN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/bulk-weather-data-in-visual-crossing/",
    "title": "Bulk Weather Data in Visual Crossing"
  },
  {
    "filename": "weather_data_conditions.txt",
    "id": "file-Wcyd56QgpKwTWyo7Msh6b5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/weather-condition-fields/",
    "title": "Weather Data Conditions"
  },
  {
    "filename": "using_remote_data_sources_in_the_weather_api.txt",
    "id": "file-S4nkcTksLVe2GkoZ6tUeuk",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/using-remote-data-sources-in-the-weather-api/",
    "title": "Using remote data sources in the Weather API"
  },
  {
    "filename": "stored_dataset_api_documentation.txt",
    "id": "file-RurExEa9HHWJ4kP79A3X61",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/stored-dataset-api-documentation/",
    "title": "Stored Dataset API Documentation"
  },
  {
    "filename": "i_think_that_i_8217_m_seeing_bad_weather_data_what_should_i_do.txt",
    "id": "file-C1XJYdQfMTRWm9xzsKXWyc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/i-think-that-im-seeing-bad-weather-data-what-should-i-do/",
    "title": "I think that I'm seeing bad weather data.  What should I do?"
  },
  {
    "filename": "certificate_error_running_weather_api_requests.txt",
    "id": "file-TMCtYrcke8E9nLPw4vU4Ce",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/certificate-error-running-weather-api-requests/",
    "title": "Certificate error running Weather API requests"
  },
  {
    "filename": "replacing_the_openweathermap_api_with_visual_crossing_weather.txt",
    "id": "file-GDqhHQuh15AE9UbtkzajQi",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-openweathermap-api-with-visual-crossing-weather/",
    "title": "Replacing the OpenWeatherMap API with Visual Crossing Weather"
  },
  {
    "filename": "energy_elements_in_the_timeline_weather_api.txt",
    "id": "file-5qXxSMG1jxs5WGboFy6ZjR",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/energy-elements-in-the-timeline-weather-api/",
    "title": "Energy elements in the Timeline Weather API"
  },
  {
    "filename": "tutorial_how_to_build_a_weather_dataset_for_download_bulk_import_or_scheduling.txt",
    "id": "file-65JkLzPNNHmg2uPvu6EhEU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-build-a-weather-dataset-for-download-bulk-import-or-scheduling/",
    "title": "Tutorial:  How to Build a Weather Dataset for Download, Bulk Import or Scheduling"
  },
  {
    "filename": "unit_groups_and_measurement_units.txt",
    "id": "file-Luq79JCx9WXwTDCreyt35a",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/unit-groups-and-measurement-units/",
    "title": "Unit groups and measurement units"
  },
  {
    "filename": "timeline_weather_api.txt",
    "id": "file-GuSq87pdsNUYgpH6tnthfR",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/timeline-weather-api/",
    "title": "Timeline Weather API"
  },
  {
    "filename": "visual_crossing_weather_packaged_options.txt",
    "id": "file-UUNUb4diU1zsHxEUAbkhky",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/visual-crossing-weather-packaged-options/",
    "title": "Visual Crossing Weather Packaged Options"
  },
  {
    "filename": "requesting_sub_hourly_weather_data_using_the_weather_api.txt",
    "id": "file-BEBNAozMPHr4uRgLCgha8v",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/requesting-sub-hourly-weather-data-using-the-weather-api/",
    "title": "Requesting sub-hourly weather data using the Weather API"
  },
  {
    "filename": "requesting_sub_hourly_data_in_the_timeline_weather_api.txt",
    "id": "file-7QoXSnKVQyE4bAxuEkNzP2",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/sub-hourly-data-in-the-timeline-weather-api/",
    "title": "Requesting sub-hourly data in the Timeline Weather API"
  },
  {
    "filename": "how_can_i_find_historical_weather_data_for_analysis_in_r.txt",
    "id": "file-2JDUwvV1NScoNUjz1vpGou",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-can-i-find-historical-weather-data-for-analysis-in-r/",
    "title": "How can I find historical weather data for analysis in R?"
  },
  {
    "filename": "how_we_process_the_noaa_integrated_surface_database_historical_weather_data.txt",
    "id": "file-8ojJbLWe6HtRhEoixJBiAv",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-we-process-integrated-surface-database-historical-weather-data/",
    "title": "How We Process the NOAA Integrated Surface Database Historical Weather Data"
  },
  {
    "filename": "air_quality_elements_in_the_weather_api.txt",
    "id": "file-Qvm7tRj23PyuZtFZp9pYTN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/air-quality-elements-in-the-weather-api/",
    "title": "Air Quality Elements in the Weather API"
  },
  {
    "filename": "using_microsoft_excel_to_analyze_gardening_weather_8211_part_3_growing_degree_days.txt",
    "id": "file-QPjwhwaDMPBUkGv65Vasdx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/using-microsoft-excel-to-analyze-gardening-weather-part-3-growing-degree-days/",
    "title": "Using Microsoft Excel to Analyze Gardening Weather - Part 3, Growing Degree Days"
  },
  {
    "filename": "tutorial_how_to_load_weather_data_into_microsoft_excel_using_a_web_query_url.txt",
    "id": "file-7fyRBvLyovYAbVjaLgZ3pH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-load-weather-data-into-microsoft-excel-using-a-web-query-data-connection/",
    "title": "Tutorial: How to Load Weather Data into Microsoft Excel using a Web Query URL"
  },
  {
    "filename": "in_what_environments_can_i_run_weather_api_queries.txt",
    "id": "file-5eUb4Du334hvcxUjRz3Gqp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/in-what-environments-can-i-run-weather-api-queries/",
    "title": "In what environments can I run weather API queries?"
  },
  {
    "filename": "replacing_the_google_weather_api.txt",
    "id": "file-Q4Q1ULfsJJDZZczj3fBv9x",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-google-weather-api/",
    "title": "Replacing the Google Weather API"
  },
  {
    "filename": "importing_data_from_a_json_weather_api_into_microsoft_excel_using_power_query.txt",
    "id": "file-WKcw5Kx1KQjFNeG8eqhJUR",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/importing-data-from-a-json-weather-api-into-microsoft-excel-using-power-query/",
    "title": "Importing data from a JSON Weather API  into Microsoft Excel using Power Query"
  },
  {
    "filename": "available_data_for_visual_crossing_weather_8211_updated_december_2020.txt",
    "id": "file-6VWyCR8mgnBttmuKWAKVpc",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/available-data-for-visual-crossing-weather-updated-january-2020/",
    "title": "Available Data for Visual Crossing Weather - Updated December 2020"
  },
  {
    "filename": "beaufort_vs_saffir_simpson_wind_scales.txt",
    "id": "file-688Yx5ywFeJbY1StsyyMV4",
    "source": "https://www.visualcrossing.com/resources/blog/beaufort-and-saffir-simpson-hurricane-wind-scale-a-quick-glance/",
    "title": "Beaufort vs. Saffir-Simpson Wind Scales"
  },
  {
    "filename": "how_to_use_curl_to_fetch_bulk_weather_data.txt",
    "id": "file-CEiU79yYxoxEVEkUTLBRzd",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-curl-to-fetch-bulk-weather-data/",
    "title": "How to use cURL to fetch bulk weather data"
  },
  {
    "filename": "precipitation_coverage_is_the_most_important_weather_metric_you_don_8217_t_know.txt",
    "id": "file-1SHq8uEt7UybRZkMdgV9BK",
    "source": "https://www.visualcrossing.com/resources/blog/what-is-precipitation-coverage/",
    "title": "Precipitation coverage is the most important weather metric you don't know"
  },
  {
    "filename": "how_to_use_the_visual_crossing_weather_microsoft_excel_add_in.txt",
    "id": "file-TPBWvd4qgLe1P14cf1TL64",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-use-the-visual-crossing-weather-microsoft-excel-add-in/",
    "title": "How to use the Visual Crossing Weather Microsoft Excel Add-in"
  },
  {
    "filename": "how_to_use_java_to_load_weather_forecast_data.txt",
    "id": "file-Bs14kr2jjkUf8Zh4zWiU36",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-fetch-weather-forecast-data-from-a-restful-web-service-in-java/",
    "title": "How to use Java to load weather forecast data"
  },
  {
    "filename": "modifying_the_weather_station_search_parameters.txt",
    "id": "file-9zn5LGHawD55fkwaW5iH4V",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/modifying-the-weather-station-search-parameters/",
    "title": "Modifying the weather station search parameters"
  },
  {
    "filename": "agriculture_elements_in_the_timeline_weather_api.txt",
    "id": "file-ExvFCRYsbjExtTULP471eU",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/agriculture-elements-in-the-timeline-weather-api/",
    "title": "Agriculture elements in the Timeline Weather API"
  },
  {
    "filename": "how_to_use_the_timeline_weather_api_to_retrieve_historical_weather_data_and_weather_forecast_data_in_java.txt",
    "id": "file-RoBGwvu7e6aa2g9iAQmDpa",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-timeline-weather-api-to-retrieve-historical-weather-data-and-weather-forecast-data-in-java/",
    "title": "How to use the Timeline Weather API to retrieve historical weather data and weather forecast data in Java"
  },
  {
    "filename": "8220_north_and_west_of_i_95_8221_8211_why_does_snow_in_the_eastern_us_always_seem_fall_to_the_west_of_i_95.txt",
    "id": "file-WH9s7cubgXTGkDmm8SMWWW",
    "source": "https://www.visualcrossing.com/resources/blog/why-does-snow-in-the-eastern-us-always-seem-fall-to-the-west-of-i-95/",
    "title": "'North and West of I-95' - why does snow in the Eastern US always seem fall to the West of I-95?"
  },
  {
    "filename": "automate_recent_weather_history_data_retrieval_using_microsoft_power_query.txt",
    "id": "file-Hw9FGcN5c9FTVjHG3nTL5M",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/automate-recent-weather-history-data-retrieval-using-microsoft-power-query/",
    "title": "Automate recent weather history data retrieval using Microsoft Power Query"
  },
  {
    "filename": "how_to_use_the_calendar_control_in_the_visual_crossing_weather_data_web_query_gui.txt",
    "id": "file-CPpqpz2r2sEmXJz6HU6BYP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-101/how-to-use-the-calendar-control-in-the-visual-crossing-weather-data-web-query-gui/",
    "title": "How to use the calendar control in the Visual Crossing Weather Data Web Query GUI"
  },
  {
    "filename": "how_to_view_usage_details_of_your_account.txt",
    "id": "file-CEwUtheoqJetR9VV1m6tCq",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-tutorials/how-to-view-usage-details-of-your-account/",
    "title": "How to view usage details of your account"
  },
  {
    "filename": "how_to_submit_weather_api_asynchronously.txt",
    "id": "file-Fprm9cadccVuELY6VPHSvp",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-submit-weather-api-asynchronously/",
    "title": "How to submit weather API asynchronously"
  },
  {
    "filename": "how_to_use_the_microsoft_excel_webservice_function_to_retrieve_weather_data.txt",
    "id": "file-BtidKrm2TUFLNMLgqMnHb2",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data-for-excel-and-google-sheets/how-to-use-the-microsoft-excel-webservice-function-to-retrieve-weather-data/",
    "title": "How to use the Microsoft Excel WEBSERVICE function to retrieve weather data"
  },
  {
    "filename": "bulk_weather_forecast_data_retrieval_for_multiple_locations.txt",
    "id": "file-JHThBhmcqX4Kttihi2XZhP",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/bulk-weather-forecast-data-retrieval-for-multiple-locations/",
    "title": "Bulk weather forecast data retrieval for multiple locations"
  },
  {
    "filename": "how_to_use_python_and_pandas_to_join_historical_weather_data_to_road_accident_data.txt",
    "id": "file-HLCVmedMJtgVLxfrW76idT",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-python-and-pandas-to-join-historical-weather-data-to-road-accident-data/",
    "title": "How to use Python and Pandas to join historical weather data to road accident data"
  },
  {
    "filename": "atmospheric_rivers_bomb_cyclones_and_other_weird_weather_terms_explained.txt",
    "id": "file-N8toLCtaVDxnd856gf2i5v",
    "source": "https://www.visualcrossing.com/resources/blog/atmospheric-rivers-bomb-cyclones-and-other-weird-weather-words-explained/",
    "title": "Atmospheric Rivers, Bomb Cyclones and Other Weird Weather Terms, Explained"
  },
  {
    "filename": "academic_student_and_research_discounts_for_weather_data.txt",
    "id": "file-UxdWAQhqLbpcb8Uu2We5kL",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/academic-student-and-research-discounts-for-weather-data/",
    "title": "Academic, student and research discounts for weather data"
  },
  {
    "filename": "how_to_retrieve_the_visual_crossing_api_query_string_when_using_the_web_query_builder_interface.txt",
    "id": "file-R1VQxQRgJWx4wLskGt7jgN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-retrieve-the-visual-crossing-api-query-string-when-using-the-web-query-builder-interface/",
    "title": "How to retrieve the Visual Crossing API Query String when using the Web Query Builder interface"
  },
  {
    "filename": "how_to_obtain_solar_radiation_data.txt",
    "id": "file-Vvowy9aHkQ52fMF2BRt5m5",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-obtain-solar-radiation-data/",
    "title": "How to obtain solar radiation data?"
  },
  {
    "filename": "how_to_use_cors_with_a_restful_weather_api.txt",
    "id": "file-3EzhyiEWYhsg6KSe5YYqRT",
    "source": "https://www.visualcrossing.com/resources/blog/how-to-use-cors-with-a-restful-weather-api/",
    "title": "How to use CORS with a RESTful Weather API"
  },
  {
    "filename": "how_to_manage_your_personal_account_information.txt",
    "id": "file-22j4B8BQbphzsTvpaJwMMn",
    "source": "https://www.visualcrossing.com/resources/documentation/how-to-manage-your-personal-account-information/",
    "title": "How to manage your personal account information"
  },
  {
    "filename": "how_to_use_historical_weather_data_to_forecast_the_weather_for_any_day_of_the_year.txt",
    "id": "file-FDU2N942uRdfnWq7FSmGWx",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-use-historical-weather-data-to-forecast-the-weather-for-any-day-of-the-year/",
    "title": "How to use historical weather data to forecast the weather for any day of the year."
  },
  {
    "filename": "how_to_use_curl_to_download_weather_data.txt",
    "id": "file-EpfJhmpawrukjkP59xhfou",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-use-curl-to-download-weather-data/",
    "title": "How to use cURL to download weather data"
  },
  {
    "filename": "how_your_data_is_used_within_visual_crossing.txt",
    "id": "file-7xW7mBAK61TeyDG6NJfY96",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-your-data-is-used-within-visual-crossing/",
    "title": "How your data is used within Visual Crossing"
  },
  {
    "filename": "how_to_show_weather_data_in_an_outlook_add_in.txt",
    "id": "file-4r4ABS4P2ciiFVij5ZgiQY",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-show-weather-data-in-an-outlook-add-in/",
    "title": "How to show weather data in an Outlook add-in"
  },
  {
    "filename": "how_to_query_weather_forecasts_from_the_past_8211_historical_forecasts.txt",
    "id": "file-6cFPGJuGJ4mY1BGNSw4tSN",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-query-weather-forecasts-from-the-past-historical-forecasts/",
    "title": "How to query weather forecasts from the past - Historical Forecasts"
  },
  {
    "filename": "how_to_replace_the_weather_underground_api.txt",
    "id": "file-SVMbeDrGurVJnMWVMBdDQ8",
    "source": "https://www.visualcrossing.com/resources/blog/replacing-the-weather-underground-api/",
    "title": "How to Replace the Weather Underground API?"
  },
  {
    "filename": "how_to_sign_up_for_a_weather_data_038_weather_api_account.txt",
    "id": "file-X5p6PCxrbkpXNW2AuX2Qj8",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-sign-up-for-a-weather-data-weather-api-account/",
    "title": "How to sign up for a Weather Data & Weather API Account"
  },
  {
    "filename": "adding_and_removing_elements_from_your_weather_query.txt",
    "id": "file-BHhrikaseQPRtytnGWBcVq",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/adding-and-removing-elements-from-your-weather-query/",
    "title": "Adding and Removing Elements from your Weather Query"
  },
  {
    "filename": "how_to_retrieve_hail_tornado_wind_damage_and_earthquake_events_in_the_weather_api.txt",
    "id": "file-Undv5TKzeKJ2GDSERDThTG",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-retrieve-hail-tornado-wind-damage-and-earthquakes-events-in-the-weather-api/",
    "title": "How to retrieve hail, tornado, wind damage and earthquake events in the weather API"
  },
  {
    "filename": "how_to_schedule_weather_data_queries.txt",
    "id": "file-LMQpY1yxWz2AsKfoerv2ss",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-schedule-weather-data-queries/",
    "title": "How to schedule weather data queries"
  },
  {
    "filename": "a_guide_to_weather_triggered_advertising.txt",
    "id": "file-QMwru5KsVeoqWU2QZMwcEN",
    "source": "https://www.visualcrossing.com/resources/blog/a-guide-to-weather-triggered-advertising/",
    "title": "A Guide to Weather-Triggered Advertising"
  },
  {
    "filename": "how_to_make_a_wordpress_plugin_that_uses_shortcodes_to_show_the_weather_forecast.txt",
    "id": "file-SGFQLwaerRU9PHqVDBzXGH",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-api/how-to-make-a-wordpress-plugin-that-uses-shortcodes-to-show-the-weather-forecast/",
    "title": "How to make a WordPress plugin that uses shortcodes to show the weather forecast"
  },
  {
    "filename": "how_to_manage_visual_crossing_weather_data_subscriptions.txt",
    "id": "file-X1bXsBCNqCfHnLME7ozAfs",
    "source": "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-manage-visual-crossing-weather-data-subscriptions/",
    "title": "How to manage Visual Crossing Weather Data Subscriptions"
  }
];
    
    // Create a Map for O(1) lookup performance
    this.fileMap = new Map(
      this.data.map(file => [file.id, file])
    );
  }

  // Look up file details by ID
  lookup(fileId) {
    const file = this.fileMap.get(fileId);
    return file ? {
      source: file.source,
      title: file.title,
      filename: file.filename
    } : null;
  }

  // Get just the source URL
  getSource(fileId) {
    const file = this.fileMap.get(fileId);
    return file ? file.source : null;
  }

  // Get just the title
  getTitle(fileId) {
    const file = this.fileMap.get(fileId);
    return file ? file.title : null;
  }

  // Get just the filename
  getFilename(fileId) {
    const file = this.fileMap.get(fileId);
    return file ? file.filename : null;
  }

  // Check if a file ID exists
  hasFile(fileId) {
    return this.fileMap.has(fileId);
  }
}

// Export as singleton instance
export default new WebsiteFilesDictionary();